"use strict";

function _typeof(e) {
	"@babel/helpers - typeof";
	return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
		return typeof e
	} : function(e) {
		return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
	})(e)
}

function _typeof(e) {
	"@babel/helpers - typeof";
	return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
		return typeof e
	} : function(e) {
		return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
	})(e)
}

function _typeof(e) {
	"@babel/helpers - typeof";
	return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
		return typeof e
	} : function(e) {
		return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
	})(e)
}

function _typeof(e) {
	"@babel/helpers - typeof";
	return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
		return typeof e
	} : function(e) {
		return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
	})(e)
}

function _typeof(e) {
	"@babel/helpers - typeof";
	return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
		return typeof e
	} : function(e) {
		return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
	})(e)
}

function _classCallCheck(e, t) {
	if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
}

function _defineProperties(e, t) {
	for (var n = 0; n < t.length; n++) {
		var i = t[n];
		i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
	}
}

function _createClass(e, t, n) {
	return t && _defineProperties(e.prototype, t), n && _defineProperties(e, n), e
}

function _typeof(e) {
	"@babel/helpers - typeof";
	return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
		return typeof e
	} : function(e) {
		return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
	})(e)
}! function(e, t) {
	"object" == ("undefined" == typeof module ? "undefined" : _typeof(module)) && "object" == _typeof(module.exports) ? module.exports = e.document ? t(e, !0) : function(e) {
		if (!e.document) throw new Error("jQuery requires a window with a document");
		return t(e)
	} : t(e)
}("undefined" != typeof window ? window : void 0, function(e, t) {
	function n(e) {
		var t = e.length,
			n = oe.type(e);
		return "function" !== n && !oe.isWindow(e) && (!(1 !== e.nodeType || !t) || ("array" === n || 0 === t || "number" == typeof t && t > 0 && t - 1 in e))
	}

	function i(e, t, n) {
		if (oe.isFunction(t)) return oe.grep(e, function(e, i) {
			return !!t.call(e, i, e) !== n
		});
		if (t.nodeType) return oe.grep(e, function(e) {
			return e === t !== n
		});
		if ("string" == typeof t) {
			if (pe.test(t)) return oe.filter(t, e, n);
			t = oe.filter(t, e)
		}
		return oe.grep(e, function(e) {
			return oe.inArray(e, t) >= 0 !== n
		})
	}

	function o(e, t) {
		do {
			e = e[t]
		} while (e && 1 !== e.nodeType);
		return e
	}

	function r(e) {
		var t = we[e] = {};
		return oe.each(e.match(ye) || [], function(e, n) {
			t[n] = !0
		}), t
	}

	function s() {
		he.addEventListener ? (he.removeEventListener("DOMContentLoaded", a, !1), e.removeEventListener("load", a, !1)) : (he.detachEvent("onreadystatechange", a), e.detachEvent("onload", a))
	}

	function a() {
		(he.addEventListener || "load" === event.type || "complete" === he.readyState) && (s(), oe.ready())
	}

	function l(e, t, n) {
		if (void 0 === n && 1 === e.nodeType) {
			var i = "data-" + t.replace(Se, "-$1").toLowerCase();
			if ("string" == typeof(n = e.getAttribute(i))) {
				try {
					n = "true" === n || "false" !== n && ("null" === n ? null : +n + "" === n ? +n : ke.test(n) ? oe.parseJSON(n) : n)
				} catch (e) {}
				oe.data(e, t, n)
			} else n = void 0
		}
		return n
	}

	function c(e) {
		var t;
		for (t in e)
			if (("data" !== t || !oe.isEmptyObject(e[t])) && "toJSON" !== t) return !1;
		return !0
	}

	function d(e, t, n, i) {
		if (oe.acceptData(e)) {
			var o, r, s = oe.expando,
				a = e.nodeType,
				l = a ? oe.cache : e,
				c = a ? e[s] : e[s] && s;
			if (c && l[c] && (i || l[c].data) || void 0 !== n || "string" != typeof t) return c || (c = a ? e[s] = Y.pop() || oe.guid++ : s), l[c] || (l[c] = a ? {} : {
				toJSON: oe.noop
			}), ("object" == _typeof(t) || "function" == typeof t) && (i ? l[c] = oe.extend(l[c], t) : l[c].data = oe.extend(l[c].data, t)), r = l[c], i || (r.data || (r.data = {}), r = r.data), void 0 !== n && (r[oe.camelCase(t)] = n), "string" == typeof t ? null == (o = r[t]) && (o = r[oe.camelCase(t)]) : o = r, o
		}
	}

	function u(e, t, n) {
		if (oe.acceptData(e)) {
			var i, o, r = e.nodeType,
				s = r ? oe.cache : e,
				a = r ? e[oe.expando] : oe.expando;
			if (s[a]) {
				if (t && (i = n ? s[a] : s[a].data)) {
					oe.isArray(t) ? t = t.concat(oe.map(t, oe.camelCase)) : t in i ? t = [t] : (t = oe.camelCase(t), t = t in i ? [t] : t.split(" ")), o = t.length;
					for (; o--;) delete i[t[o]];
					if (n ? !c(i) : !oe.isEmptyObject(i)) return
				}(n || (delete s[a].data, c(s[a]))) && (r ? oe.cleanData([e], !0) : ne.deleteExpando || s != s.window ? delete s[a] : s[a] = null)
			}
		}
	}

	function p() {
		return !0
	}

	function f() {
		return !1
	}

	function h() {
		try {
			return he.activeElement
		} catch (e) {}
	}

	function m(e) {
		var t = He.split("|"),
			n = e.createDocumentFragment();
		if (n.createElement)
			for (; t.length;) n.createElement(t.pop());
		return n
	}

	function g(e, t) {
		var n, i, o = 0,
			r = _typeof(e.getElementsByTagName) !== Te ? e.getElementsByTagName(t || "*") : _typeof(e.querySelectorAll) !== Te ? e.querySelectorAll(t || "*") : void 0;
		if (!r)
			for (r = [], n = e.childNodes || e; null != (i = n[o]); o++) !t || oe.nodeName(i, t) ? r.push(i) : oe.merge(r, g(i, t));
		return void 0 === t || t && oe.nodeName(e, t) ? oe.merge([e], r) : r
	}

	function v(e) {
		Me.test(e.type) && (e.defaultChecked = e.checked)
	}

	function y(e, t) {
		return oe.nodeName(e, "table") && oe.nodeName(11 !== t.nodeType ? t : t.firstChild, "tr") ? e.getElementsByTagName("tbody")[0] || e.appendChild(e.ownerDocument.createElement("tbody")) : e
	}

	function w(e) {
		return e.type = (null !== oe.find.attr(e, "type")) + "/" + e.type, e
	}

	function b(e) {
		var t = Xe.exec(e.type);
		return t ? e.type = t[1] : e.removeAttribute("type"), e
	}

	function x(e, t) {
		for (var n, i = 0; null != (n = e[i]); i++) oe._data(n, "globalEval", !t || oe._data(t[i], "globalEval"))
	}

	function T(e, t) {
		if (1 === t.nodeType && oe.hasData(e)) {
			var n, i, o, r = oe._data(e),
				s = oe._data(t, r),
				a = r.events;
			if (a) {
				delete s.handle, s.events = {};
				for (n in a)
					for (i = 0, o = a[n].length; o > i; i++) oe.event.add(t, n, a[n][i])
			}
			s.data && (s.data = oe.extend({}, s.data))
		}
	}

	function k(e, t) {
		var n, i, o;
		if (1 === t.nodeType) {
			if (n = t.nodeName.toLowerCase(), !ne.noCloneEvent && t[oe.expando]) {
				o = oe._data(t);
				for (i in o.events) oe.removeEvent(t, i, o.handle);
				t.removeAttribute(oe.expando)
			}
			"script" === n && t.text !== e.text ? (w(t).text = e.text, b(t)) : "object" === n ? (t.parentNode && (t.outerHTML = e.outerHTML), ne.html5Clone && e.innerHTML && !oe.trim(t.innerHTML) && (t.innerHTML = e.innerHTML)) : "input" === n && Me.test(e.type) ? (t.defaultChecked = t.checked = e.checked, t.value !== e.value && (t.value = e.value)) : "option" === n ? t.defaultSelected = t.selected = e.defaultSelected : ("input" === n || "textarea" === n) && (t.defaultValue = e.defaultValue)
		}
	}

	function S(t, n) {
		var i, o = oe(n.createElement(t)).appendTo(n.body),
			r = e.getDefaultComputedStyle && (i = e.getDefaultComputedStyle(o[0])) ? i.display : oe.css(o[0], "display");
		return o.detach(), r
	}

	function C(e) {
		var t = he,
			n = Ze[e];
		return n || (n = S(e, t), "none" !== n && n || (Qe = (Qe || oe("<iframe frameborder='0' width='0' height='0'/>")).appendTo(t.documentElement), t = (Qe[0].contentWindow || Qe[0].contentDocument).document, t.write(), t.close(), n = S(e, t), Qe.detach()), Ze[e] = n), n
	}

	function E(e, t) {
		return {
			get: function() {
				var n = e();
				if (null != n) return n ? void delete this.get : (this.get = t).apply(this, arguments)
			}
		}
	}

	function $(e, t) {
		if (t in e) return t;
		for (var n = t.charAt(0).toUpperCase() + t.slice(1), i = t, o = ut.length; o--;)
			if ((t = ut[o] + n) in e) return t;
		return i
	}

	function A(e, t) {
		for (var n, i, o, r = [], s = 0, a = e.length; a > s; s++) i = e[s], i.style && (r[s] = oe._data(i, "olddisplay"), n = i.style.display, t ? (r[s] || "none" !== n || (i.style.display = ""), "" === i.style.display && $e(i) && (r[s] = oe._data(i, "olddisplay", C(i.nodeName)))) : (o = $e(i), (n && "none" !== n || !o) && oe._data(i, "olddisplay", o ? n : oe.css(i, "display"))));
		for (s = 0; a > s; s++) i = e[s], i.style && (t && "none" !== i.style.display && "" !== i.style.display || (i.style.display = t ? r[s] || "" : "none"));
		return e
	}

	function M(e, t, n) {
		var i = at.exec(t);
		return i ? Math.max(0, i[1] - (n || 0)) + (i[2] || "px") : t
	}

	function _(e, t, n, i, o) {
		for (var r = n === (i ? "border" : "content") ? 4 : "width" === t ? 1 : 0, s = 0; 4 > r; r += 2) "margin" === n && (s += oe.css(e, n + Ee[r], !0, o)), i ? ("content" === n && (s -= oe.css(e, "padding" + Ee[r], !0, o)), "margin" !== n && (s -= oe.css(e, "border" + Ee[r] + "Width", !0, o))) : (s += oe.css(e, "padding" + Ee[r], !0, o), "padding" !== n && (s += oe.css(e, "border" + Ee[r] + "Width", !0, o)));
		return s
	}

	function P(e, t, n) {
		var i = !0,
			o = "width" === t ? e.offsetWidth : e.offsetHeight,
			r = Je(e),
			s = ne.boxSizing && "border-box" === oe.css(e, "boxSizing", !1, r);
		if (0 >= o || null == o) {
			if (o = et(e, t, r), (0 > o || null == o) && (o = e.style[t]), nt.test(o)) return o;
			i = s && (ne.boxSizingReliable() || o === e.style[t]), o = parseFloat(o) || 0
		}
		return o + _(e, t, n || (s ? "border" : "content"), i, r) + "px"
	}

	function N(e, t, n, i, o) {
		return new N.prototype.init(e, t, n, i, o)
	}

	function L() {
		return setTimeout(function() {
			pt = void 0
		}), pt = oe.now()
	}

	function O(e, t) {
		var n, i = {
				height: e
			},
			o = 0;
		for (t = t ? 1 : 0; 4 > o; o += 2 - t) n = Ee[o], i["margin" + n] = i["padding" + n] = e;
		return t && (i.opacity = i.width = e), i
	}

	function H(e, t, n) {
		for (var i, o = (yt[t] || []).concat(yt["*"]), r = 0, s = o.length; s > r; r++)
			if (i = o[r].call(n, t, e)) return i
	}

	function D(e, t, n) {
		var i, o, r, s, a, l, c, d = this,
			u = {},
			p = e.style,
			f = e.nodeType && $e(e),
			h = oe._data(e, "fxshow");
		n.queue || (a = oe._queueHooks(e, "fx"), null == a.unqueued && (a.unqueued = 0, l = a.empty.fire, a.empty.fire = function() {
			a.unqueued || l()
		}), a.unqueued++, d.always(function() {
			d.always(function() {
				a.unqueued--, oe.queue(e, "fx").length || a.empty.fire()
			})
		})), 1 === e.nodeType && ("height" in t || "width" in t) && (n.overflow = [p.overflow, p.overflowX, p.overflowY], c = oe.css(e, "display"), "inline" === ("none" === c ? oe._data(e, "olddisplay") || C(e.nodeName) : c) && "none" === oe.css(e, "float") && (ne.inlineBlockNeedsLayout && "inline" !== C(e.nodeName) ? p.zoom = 1 : p.display = "inline-block")), n.overflow && (p.overflow = "hidden", ne.shrinkWrapBlocks() || d.always(function() {
			p.overflow = n.overflow[0], p.overflowX = n.overflow[1], p.overflowY = n.overflow[2]
		}));
		for (i in t)
			if (o = t[i], ht.exec(o)) {
				if (delete t[i], r = r || "toggle" === o, o === (f ? "hide" : "show")) {
					if ("show" !== o || !h || void 0 === h[i]) continue;
					f = !0
				}
				u[i] = h && h[i] || oe.style(e, i)
			} else c = void 0;
		if (oe.isEmptyObject(u)) "inline" === ("none" === c ? C(e.nodeName) : c) && (p.display = c);
		else {
			h ? "hidden" in h && (f = h.hidden) : h = oe._data(e, "fxshow", {}), r && (h.hidden = !f), f ? oe(e).show() : d.done(function() {
				oe(e).hide()
			}), d.done(function() {
				var t;
				oe._removeData(e, "fxshow");
				for (t in u) oe.style(e, t, u[t])
			});
			for (i in u) s = H(f ? h[i] : 0, i, d), i in h || (h[i] = s.start, f && (s.end = s.start, s.start = "width" === i || "height" === i ? 1 : 0))
		}
	}

	function j(e, t) {
		var n, i, o, r, s;
		for (n in e)
			if (i = oe.camelCase(n), o = t[i], r = e[n], oe.isArray(r) && (o = r[1], r = e[n] = r[0]), n !== i && (e[i] = r, delete e[n]), (s = oe.cssHooks[i]) && "expand" in s) {
				r = s.expand(r), delete e[i];
				for (n in r) n in e || (e[n] = r[n], t[n] = o)
			} else t[i] = o
	}

	function I(e, t, n) {
		var i, o, r = 0,
			s = vt.length,
			a = oe.Deferred().always(function() {
				delete l.elem
			}),
			l = function() {
				if (o) return !1;
				for (var t = pt || L(), n = Math.max(0, c.startTime + c.duration - t), i = n / c.duration || 0, r = 1 - i, s = 0, l = c.tweens.length; l > s; s++) c.tweens[s].run(r);
				return a.notifyWith(e, [c, r, n]), 1 > r && l ? n : (a.resolveWith(e, [c]), !1)
			},
			c = a.promise({
				elem: e,
				props: oe.extend({}, t),
				opts: oe.extend(!0, {
					specialEasing: {}
				}, n),
				originalProperties: t,
				originalOptions: n,
				startTime: pt || L(),
				duration: n.duration,
				tweens: [],
				createTween: function(t, n) {
					var i = oe.Tween(e, c.opts, t, n, c.opts.specialEasing[t] || c.opts.easing);
					return c.tweens.push(i), i
				},
				stop: function(t) {
					var n = 0,
						i = t ? c.tweens.length : 0;
					if (o) return this;
					for (o = !0; i > n; n++) c.tweens[n].run(1);
					return t ? a.resolveWith(e, [c, t]) : a.rejectWith(e, [c, t]), this
				}
			}),
			d = c.props;
		for (j(d, c.opts.specialEasing); s > r; r++)
			if (i = vt[r].call(c, e, d, c.opts)) return i;
		return oe.map(d, H, c), oe.isFunction(c.opts.start) && c.opts.start.call(e, c), oe.fx.timer(oe.extend(l, {
			elem: e,
			anim: c,
			queue: c.opts.queue
		})), c.progress(c.opts.progress).done(c.opts.done, c.opts.complete).fail(c.opts.fail).always(c.opts.always)
	}

	function z(e) {
		return function(t, n) {
			"string" != typeof t && (n = t, t = "*");
			var i, o = 0,
				r = t.toLowerCase().match(ye) || [];
			if (oe.isFunction(n))
				for (; i = r[o++];) "+" === i.charAt(0) ? (i = i.slice(1) || "*", (e[i] = e[i] || []).unshift(n)) : (e[i] = e[i] || []).push(n)
		}
	}

	function F(e, t, n, i) {
		function o(a) {
			var l;
			return r[a] = !0, oe.each(e[a] || [], function(e, a) {
				var c = a(t, n, i);
				return "string" != typeof c || s || r[c] ? s ? !(l = c) : void 0 : (t.dataTypes.unshift(c), o(c), !1)
			}), l
		}
		var r = {},
			s = e === Bt;
		return o(t.dataTypes[0]) || !r["*"] && o("*")
	}

	function q(e, t) {
		var n, i, o = oe.ajaxSettings.flatOptions || {};
		for (i in t) void 0 !== t[i] && ((o[i] ? e : n || (n = {}))[i] = t[i]);
		return n && oe.extend(!0, e, n), e
	}

	function B(e, t, n) {
		for (var i, o, r, s, a = e.contents, l = e.dataTypes;
			"*" === l[0];) l.shift(), void 0 === o && (o = e.mimeType || t.getResponseHeader("Content-Type"));
		if (o)
			for (s in a)
				if (a[s] && a[s].test(o)) {
					l.unshift(s);
					break
				} if (l[0] in n) r = l[0];
		else {
			for (s in n) {
				if (!l[0] || e.converters[s + " " + l[0]]) {
					r = s;
					break
				}
				i || (i = s)
			}
			r = r || i
		}
		return r ? (r !== l[0] && l.unshift(r), n[r]) : void 0
	}

	function R(e, t, n, i) {
		var o, r, s, a, l, c = {},
			d = e.dataTypes.slice();
		if (d[1])
			for (s in e.converters) c[s.toLowerCase()] = e.converters[s];
		for (r = d.shift(); r;)
			if (e.responseFields[r] && (n[e.responseFields[r]] = t), !l && i && e.dataFilter && (t = e.dataFilter(t, e.dataType)), l = r, r = d.shift())
				if ("*" === r) r = l;
				else if ("*" !== l && l !== r) {
			if (!(s = c[l + " " + r] || c["* " + r]))
				for (o in c)
					if (a = o.split(" "), a[1] === r && (s = c[l + " " + a[0]] || c["* " + a[0]])) {
						!0 === s ? s = c[o] : !0 !== c[o] && (r = a[0], d.unshift(a[1]));
						break
					} if (!0 !== s)
				if (s && e.throws) t = s(t);
				else try {
					t = s(t)
				} catch (e) {
					return {
						state: "parsererror",
						error: s ? e : "No conversion from " + l + " to " + r
					}
				}
		}
		return {
			state: "success",
			data: t
		}
	}

	function W(e, t, n, i) {
		var o;
		if (oe.isArray(t)) oe.each(t, function(t, o) {
			n || Ut.test(e) ? i(e, o) : W(e + "[" + ("object" == _typeof(o) ? t : "") + "]", o, n, i)
		});
		else if (n || "object" !== oe.type(t)) i(e, t);
		else
			for (o in t) W(e + "[" + o + "]", t[o], n, i)
	}

	function U() {
		try {
			return new e.XMLHttpRequest
		} catch (e) {}
	}

	function X() {
		try {
			return new e.ActiveXObject("Microsoft.XMLHTTP")
		} catch (e) {}
	}

	function V(e) {
		return oe.isWindow(e) ? e : 9 === e.nodeType && (e.defaultView || e.parentWindow)
	}
	var Y = [],
		G = Y.slice,
		K = Y.concat,
		Q = Y.push,
		Z = Y.indexOf,
		J = {},
		ee = J.toString,
		te = J.hasOwnProperty,
		ne = {},
		ie = "1.11.2",
		oe = function e(t, n) {
			return new e.fn.init(t, n)
		},
		re = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
		se = /^-ms-/,
		ae = /-([\da-z])/gi,
		le = function(e, t) {
			return t.toUpperCase()
		};
	oe.fn = oe.prototype = {
		jquery: ie,
		constructor: oe,
		selector: "",
		length: 0,
		toArray: function() {
			return G.call(this)
		},
		get: function(e) {
			return null != e ? 0 > e ? this[e + this.length] : this[e] : G.call(this)
		},
		pushStack: function(e) {
			var t = oe.merge(this.constructor(), e);
			return t.prevObject = this, t.context = this.context, t
		},
		each: function(e, t) {
			return oe.each(this, e, t)
		},
		map: function(e) {
			return this.pushStack(oe.map(this, function(t, n) {
				return e.call(t, n, t)
			}))
		},
		slice: function() {
			return this.pushStack(G.apply(this, arguments))
		},
		first: function() {
			return this.eq(0)
		},
		last: function() {
			return this.eq(-1)
		},
		eq: function(e) {
			var t = this.length,
				n = +e + (0 > e ? t : 0);
			return this.pushStack(n >= 0 && t > n ? [this[n]] : [])
		},
		end: function() {
			return this.prevObject || this.constructor(null)
		},
		push: Q,
		sort: Y.sort,
		splice: Y.splice
	}, oe.extend = oe.fn.extend = function() {
		var e, t, n, i, o, r, s = arguments[0] || {},
			a = 1,
			l = arguments.length,
			c = !1;
		for ("boolean" == typeof s && (c = s, s = arguments[a] || {}, a++), "object" == _typeof(s) || oe.isFunction(s) || (s = {}), a === l && (s = this, a--); l > a; a++)
			if (null != (o = arguments[a]))
				for (i in o) e = s[i], n = o[i], s !== n && (c && n && (oe.isPlainObject(n) || (t = oe.isArray(n))) ? (t ? (t = !1, r = e && oe.isArray(e) ? e : []) : r = e && oe.isPlainObject(e) ? e : {}, s[i] = oe.extend(c, r, n)) : void 0 !== n && (s[i] = n));
		return s
	}, oe.extend({
		expando: "jQuery" + (ie + Math.random()).replace(/\D/g, ""),
		isReady: !0,
		error: function(e) {
			throw new Error(e)
		},
		noop: function() {},
		isFunction: function(e) {
			return "function" === oe.type(e)
		},
		isArray: Array.isArray || function(e) {
			return "array" === oe.type(e)
		},
		isWindow: function(e) {
			return null != e && e == e.window
		},
		isNumeric: function(e) {
			return !oe.isArray(e) && e - parseFloat(e) + 1 >= 0
		},
		isEmptyObject: function(e) {
			var t;
			for (t in e) return !1;
			return !0
		},
		isPlainObject: function(e) {
			var t;
			if (!e || "object" !== oe.type(e) || e.nodeType || oe.isWindow(e)) return !1;
			try {
				if (e.constructor && !te.call(e, "constructor") && !te.call(e.constructor.prototype, "isPrototypeOf")) return !1
			} catch (e) {
				return !1
			}
			if (ne.ownLast)
				for (t in e) return te.call(e, t);
			for (t in e);
			return void 0 === t || te.call(e, t)
		},
		type: function(e) {
			return null == e ? e + "" : "object" == _typeof(e) || "function" == typeof e ? J[ee.call(e)] || "object" : _typeof(e)
		},
		globalEval: function(t) {
			t && oe.trim(t) && (e.execScript || function(t) {
				e.eval.call(e, t)
			})(t)
		},
		camelCase: function(e) {
			return e.replace(se, "ms-").replace(ae, le)
		},
		nodeName: function(e, t) {
			return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase()
		},
		each: function(e, t, i) {
			var o = 0,
				r = e.length,
				s = n(e);
			if (i) {
				if (s)
					for (; r > o && !1 !== t.apply(e[o], i); o++);
				else
					for (o in e)
						if (!1 === t.apply(e[o], i)) break
			} else if (s)
				for (; r > o && !1 !== t.call(e[o], o, e[o]); o++);
			else
				for (o in e)
					if (!1 === t.call(e[o], o, e[o])) break;
			return e
		},
		trim: function(e) {
			return null == e ? "" : (e + "").replace(re, "")
		},
		makeArray: function(e, t) {
			var i = t || [];
			return null != e && (n(Object(e)) ? oe.merge(i, "string" == typeof e ? [e] : e) : Q.call(i, e)), i
		},
		inArray: function(e, t, n) {
			var i;
			if (t) {
				if (Z) return Z.call(t, e, n);
				for (i = t.length, n = n ? 0 > n ? Math.max(0, i + n) : n : 0; i > n; n++)
					if (n in t && t[n] === e) return n
			}
			return -1
		},
		merge: function(e, t) {
			for (var n = +t.length, i = 0, o = e.length; n > i;) e[o++] = t[i++];
			if (n !== n)
				for (; void 0 !== t[i];) e[o++] = t[i++];
			return e.length = o, e
		},
		grep: function(e, t, n) {
			for (var i = [], o = 0, r = e.length, s = !n; r > o; o++) !t(e[o], o) !== s && i.push(e[o]);
			return i
		},
		map: function(e, t, i) {
			var o, r = 0,
				s = e.length,
				a = n(e),
				l = [];
			if (a)
				for (; s > r; r++) null != (o = t(e[r], r, i)) && l.push(o);
			else
				for (r in e) null != (o = t(e[r], r, i)) && l.push(o);
			return K.apply([], l)
		},
		guid: 1,
		proxy: function(e, t) {
			var n, i, o;
			return "string" == typeof t && (o = e[t], t = e, e = o), oe.isFunction(e) ? (n = G.call(arguments, 2), i = function() {
				return e.apply(t || this, n.concat(G.call(arguments)))
			}, i.guid = e.guid = e.guid || oe.guid++, i) : void 0
		},
		now: function() {
			return +new Date
		},
		support: ne
	}), oe.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function(e, t) {
		J["[object " + t + "]"] = t.toLowerCase()
	});
	var ce = function(e) {
		function t(e, t, n, i) {
			var o, r, s, a, c, u, p, f, h, m;
			if ((t ? t.ownerDocument || t : I) !== _ && M(t), t = t || _, n = n || [], a = t.nodeType, "string" != typeof e || !e || 1 !== a && 9 !== a && 11 !== a) return n;
			if (!i && N) {
				if (11 !== a && (o = ge.exec(e)))
					if (s = o[1]) {
						if (9 === a) {
							if (!(r = t.getElementById(s)) || !r.parentNode) return n;
							if (r.id === s) return n.push(r), n
						} else if (t.ownerDocument && (r = t.ownerDocument.getElementById(s)) && D(t, r) && r.id === s) return n.push(r), n
					} else {
						if (o[2]) return K.apply(n, t.getElementsByTagName(e)), n;
						if ((s = o[3]) && w.getElementsByClassName) return K.apply(n, t.getElementsByClassName(s)), n
					} if (w.qsa && (!L || !L.test(e))) {
					if (f = p = j, h = t, m = 1 !== a && e, 1 === a && "object" !== t.nodeName.toLowerCase()) {
						for (u = k(e), (p = t.getAttribute("id")) ? f = p.replace(ye, "\\$&") : t.setAttribute("id", f), f = "[id='" + f + "'] ", c = u.length; c--;) u[c] = f + d(u[c]);
						h = ve.test(e) && l(t.parentNode) || t, m = u.join(",")
					}
					if (m) try {
						return K.apply(n, h.querySelectorAll(m)), n
					} catch (e) {} finally {
						p || t.removeAttribute("id")
					}
				}
			}
			return C(e.replace(se, "$1"), t, n, i)
		}

		function n() {
			function e(n, i) {
				return t.push(n + " ") > b.cacheLength && delete e[t.shift()], e[n + " "] = i
			}
			var t = [];
			return e
		}

		function i(e) {
			return e[j] = !0, e
		}

		function o(e) {
			var t = _.createElement("div");
			try {
				return !!e(t)
			} catch (e) {
				return !1
			} finally {
				t.parentNode && t.parentNode.removeChild(t), t = null
			}
		}

		function r(e, t) {
			for (var n = e.split("|"), i = e.length; i--;) b.attrHandle[n[i]] = t
		}

		function s(e, t) {
			var n = t && e,
				i = n && 1 === e.nodeType && 1 === t.nodeType && (~t.sourceIndex || U) - (~e.sourceIndex || U);
			if (i) return i;
			if (n)
				for (; n = n.nextSibling;)
					if (n === t) return -1;
			return e ? 1 : -1
		}

		function a(e) {
			return i(function(t) {
				return t = +t, i(function(n, i) {
					for (var o, r = e([], n.length, t), s = r.length; s--;) n[o = r[s]] && (n[o] = !(i[o] = n[o]))
				})
			})
		}

		function l(e) {
			return e && void 0 !== e.getElementsByTagName && e
		}

		function c() {}

		function d(e) {
			for (var t = 0, n = e.length, i = ""; n > t; t++) i += e[t].value;
			return i
		}

		function u(e, t, n) {
			var i = t.dir,
				o = n && "parentNode" === i,
				r = F++;
			return t.first ? function(t, n, r) {
				for (; t = t[i];)
					if (1 === t.nodeType || o) return e(t, n, r)
			} : function(t, n, s) {
				var a, l, c = [z, r];
				if (s) {
					for (; t = t[i];)
						if ((1 === t.nodeType || o) && e(t, n, s)) return !0
				} else
					for (; t = t[i];)
						if (1 === t.nodeType || o) {
							if (l = t[j] || (t[j] = {}), (a = l[i]) && a[0] === z && a[1] === r) return c[2] = a[2];
							if (l[i] = c, c[2] = e(t, n, s)) return !0
						}
			}
		}

		function p(e) {
			return e.length > 1 ? function(t, n, i) {
				for (var o = e.length; o--;)
					if (!e[o](t, n, i)) return !1;
				return !0
			} : e[0]
		}

		function f(e, n, i) {
			for (var o = 0, r = n.length; r > o; o++) t(e, n[o], i);
			return i
		}

		function h(e, t, n, i, o) {
			for (var r, s = [], a = 0, l = e.length, c = null != t; l > a; a++)(r = e[a]) && (!n || n(r, i, o)) && (s.push(r), c && t.push(a));
			return s
		}

		function m(e, t, n, o, r, s) {
			return o && !o[j] && (o = m(o)), r && !r[j] && (r = m(r, s)), i(function(i, s, a, l) {
				var c, d, u, p = [],
					m = [],
					g = s.length,
					v = i || f(t || "*", a.nodeType ? [a] : a, []),
					y = !e || !i && t ? v : h(v, p, e, a, l),
					w = n ? r || (i ? e : g || o) ? [] : s : y;
				if (n && n(y, w, a, l), o)
					for (c = h(w, m), o(c, [], a, l), d = c.length; d--;)(u = c[d]) && (w[m[d]] = !(y[m[d]] = u));
				if (i) {
					if (r || e) {
						if (r) {
							for (c = [], d = w.length; d--;)(u = w[d]) && c.push(y[d] = u);
							r(null, w = [], c, l)
						}
						for (d = w.length; d--;)(u = w[d]) && (c = r ? Z(i, u) : p[d]) > -1 && (i[c] = !(s[c] = u))
					}
				} else w = h(w === s ? w.splice(g, w.length) : w), r ? r(null, s, w, l) : K.apply(s, w)
			})
		}

		function g(e) {
			for (var t, n, i, o = e.length, r = b.relative[e[0].type], s = r || b.relative[" "], a = r ? 1 : 0, l = u(function(e) {
					return e === t
				}, s, !0), c = u(function(e) {
					return Z(t, e) > -1
				}, s, !0), f = [function(e, n, i) {
					var o = !r && (i || n !== E) || ((t = n).nodeType ? l(e, n, i) : c(e, n, i));
					return t = null, o
				}]; o > a; a++)
				if (n = b.relative[e[a].type]) f = [u(p(f), n)];
				else {
					if (n = b.filter[e[a].type].apply(null, e[a].matches), n[j]) {
						for (i = ++a; o > i && !b.relative[e[i].type]; i++);
						return m(a > 1 && p(f), a > 1 && d(e.slice(0, a - 1).concat({
							value: " " === e[a - 2].type ? "*" : ""
						})).replace(se, "$1"), n, i > a && g(e.slice(a, i)), o > i && g(e = e.slice(i)), o > i && d(e))
					}
					f.push(n)
				} return p(f)
		}

		function v(e, n) {
			var o = n.length > 0,
				r = e.length > 0,
				s = function(i, s, a, l, c) {
					var d, u, p, f = 0,
						m = "0",
						g = i && [],
						v = [],
						y = E,
						w = i || r && b.find.TAG("*", c),
						x = z += null == y ? 1 : Math.random() || .1,
						T = w.length;
					for (c && (E = s !== _ && s); m !== T && null != (d = w[m]); m++) {
						if (r && d) {
							for (u = 0; p = e[u++];)
								if (p(d, s, a)) {
									l.push(d);
									break
								} c && (z = x)
						}
						o && ((d = !p && d) && f--, i && g.push(d))
					}
					if (f += m, o && m !== f) {
						for (u = 0; p = n[u++];) p(g, v, s, a);
						if (i) {
							if (f > 0)
								for (; m--;) g[m] || v[m] || (v[m] = Y.call(l));
							v = h(v)
						}
						K.apply(l, v), c && !i && v.length > 0 && f + n.length > 1 && t.uniqueSort(l)
					}
					return c && (z = x, E = y), g
				};
			return o ? i(s) : s
		}
		var y, w, b, x, T, k, S, C, E, $, A, M, _, P, N, L, O, H, D, j = "sizzle" + 1 * new Date,
			I = e.document,
			z = 0,
			F = 0,
			q = n(),
			B = n(),
			R = n(),
			W = function(e, t) {
				return e === t && (A = !0), 0
			},
			U = 1 << 31,
			X = {}.hasOwnProperty,
			V = [],
			Y = V.pop,
			G = V.push,
			K = V.push,
			Q = V.slice,
			Z = function(e, t) {
				for (var n = 0, i = e.length; i > n; n++)
					if (e[n] === t) return n;
				return -1
			},
			J = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
			ee = "[\\x20\\t\\r\\n\\f]",
			te = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
			ne = te.replace("w", "w#"),
			ie = "\\[" + ee + "*(" + te + ")(?:" + ee + "*([*^$|!~]?=)" + ee + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + ne + "))|)" + ee + "*\\]",
			oe = ":(" + te + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + ie + ")*)|.*)\\)|)",
			re = new RegExp(ee + "+", "g"),
			se = new RegExp("^" + ee + "+|((?:^|[^\\\\])(?:\\\\.)*)" + ee + "+$", "g"),
			ae = new RegExp("^" + ee + "*," + ee + "*"),
			le = new RegExp("^" + ee + "*([>+~]|" + ee + ")" + ee + "*"),
			ce = new RegExp("=" + ee + "*([^\\]'\"]*?)" + ee + "*\\]", "g"),
			de = new RegExp(oe),
			ue = new RegExp("^" + ne + "$"),
			pe = {
				ID: new RegExp("^#(" + te + ")"),
				CLASS: new RegExp("^\\.(" + te + ")"),
				TAG: new RegExp("^(" + te.replace("w", "w*") + ")"),
				ATTR: new RegExp("^" + ie),
				PSEUDO: new RegExp("^" + oe),
				CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + ee + "*(even|odd|(([+-]|)(\\d*)n|)" + ee + "*(?:([+-]|)" + ee + "*(\\d+)|))" + ee + "*\\)|)", "i"),
				bool: new RegExp("^(?:" + J + ")$", "i"),
				needsContext: new RegExp("^" + ee + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + ee + "*((?:-\\d)?\\d*)" + ee + "*\\)|)(?=[^-]|$)", "i")
			},
			fe = /^(?:input|select|textarea|button)$/i,
			he = /^h\d$/i,
			me = /^[^{]+\{\s*\[native \w/,
			ge = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
			ve = /[+~]/,
			ye = /'|\\/g,
			we = new RegExp("\\\\([\\da-f]{1,6}" + ee + "?|(" + ee + ")|.)", "ig"),
			be = function(e, t, n) {
				var i = "0x" + t - 65536;
				return i !== i || n ? t : 0 > i ? String.fromCharCode(i + 65536) : String.fromCharCode(i >> 10 | 55296, 1023 & i | 56320)
			},
			xe = function() {
				M()
			};
		try {
			K.apply(V = Q.call(I.childNodes), I.childNodes), V[I.childNodes.length].nodeType
		} catch (e) {
			K = {
				apply: V.length ? function(e, t) {
					G.apply(e, Q.call(t))
				} : function(e, t) {
					for (var n = e.length, i = 0; e[n++] = t[i++];);
					e.length = n - 1
				}
			}
		}
		w = t.support = {}, T = t.isXML = function(e) {
			var t = e && (e.ownerDocument || e).documentElement;
			return !!t && "HTML" !== t.nodeName
		}, M = t.setDocument = function(e) {
			var t, n, i = e ? e.ownerDocument || e : I;
			return i !== _ && 9 === i.nodeType && i.documentElement ? (_ = i, P = i.documentElement, n = i.defaultView, n && n !== n.top && (n.addEventListener ? n.addEventListener("unload", xe, !1) : n.attachEvent && n.attachEvent("onunload", xe)), N = !T(i), w.attributes = o(function(e) {
				return e.className = "i", !e.getAttribute("className")
			}), w.getElementsByTagName = o(function(e) {
				return e.appendChild(i.createComment("")), !e.getElementsByTagName("*").length
			}), w.getElementsByClassName = me.test(i.getElementsByClassName), w.getById = o(function(e) {
				return P.appendChild(e).id = j, !i.getElementsByName || !i.getElementsByName(j).length
			}), w.getById ? (b.find.ID = function(e, t) {
				if (void 0 !== t.getElementById && N) {
					var n = t.getElementById(e);
					return n && n.parentNode ? [n] : []
				}
			}, b.filter.ID = function(e) {
				var t = e.replace(we, be);
				return function(e) {
					return e.getAttribute("id") === t
				}
			}) : (delete b.find.ID, b.filter.ID = function(e) {
				var t = e.replace(we, be);
				return function(e) {
					var n = void 0 !== e.getAttributeNode && e.getAttributeNode("id");
					return n && n.value === t
				}
			}), b.find.TAG = w.getElementsByTagName ? function(e, t) {
				return void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e) : w.qsa ? t.querySelectorAll(e) : void 0
			} : function(e, t) {
				var n, i = [],
					o = 0,
					r = t.getElementsByTagName(e);
				if ("*" === e) {
					for (; n = r[o++];) 1 === n.nodeType && i.push(n);
					return i
				}
				return r
			}, b.find.CLASS = w.getElementsByClassName && function(e, t) {
				return N ? t.getElementsByClassName(e) : void 0
			}, O = [], L = [], (w.qsa = me.test(i.querySelectorAll)) && (o(function(e) {
				P.appendChild(e).innerHTML = "<a id='" + j + "'></a><select id='" + j + "-\f]' msallowcapture=''><option selected=''></option></select>", e.querySelectorAll("[msallowcapture^='']").length && L.push("[*^$]=" + ee + "*(?:''|\"\")"), e.querySelectorAll("[selected]").length || L.push("\\[" + ee + "*(?:value|" + J + ")"), e.querySelectorAll("[id~=" + j + "-]").length || L.push("~="), e.querySelectorAll(":checked").length || L.push(":checked"), e.querySelectorAll("a#" + j + "+*").length || L.push(".#.+[+~]")
			}), o(function(e) {
				var t = i.createElement("input");
				t.setAttribute("type", "hidden"), e.appendChild(t).setAttribute("name", "D"), e.querySelectorAll("[name=d]").length && L.push("name" + ee + "*[*^$|!~]?="), e.querySelectorAll(":enabled").length || L.push(":enabled", ":disabled"), e.querySelectorAll("*,:x"), L.push(",.*:")
			})), (w.matchesSelector = me.test(H = P.matches || P.webkitMatchesSelector || P.mozMatchesSelector || P.oMatchesSelector || P.msMatchesSelector)) && o(function(e) {
				w.disconnectedMatch = H.call(e, "div"), H.call(e, "[s!='']:x"), O.push("!=", oe)
			}), L = L.length && new RegExp(L.join("|")), O = O.length && new RegExp(O.join("|")), t = me.test(P.compareDocumentPosition), D = t || me.test(P.contains) ? function(e, t) {
				var n = 9 === e.nodeType ? e.documentElement : e,
					i = t && t.parentNode;
				return e === i || !(!i || 1 !== i.nodeType || !(n.contains ? n.contains(i) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(i)))
			} : function(e, t) {
				if (t)
					for (; t = t.parentNode;)
						if (t === e) return !0;
				return !1
			}, W = t ? function(e, t) {
				if (e === t) return A = !0, 0;
				var n = !e.compareDocumentPosition - !t.compareDocumentPosition;
				return n || (n = (e.ownerDocument || e) === (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1, 1 & n || !w.sortDetached && t.compareDocumentPosition(e) === n ? e === i || e.ownerDocument === I && D(I, e) ? -1 : t === i || t.ownerDocument === I && D(I, t) ? 1 : $ ? Z($, e) - Z($, t) : 0 : 4 & n ? -1 : 1)
			} : function(e, t) {
				if (e === t) return A = !0, 0;
				var n, o = 0,
					r = e.parentNode,
					a = t.parentNode,
					l = [e],
					c = [t];
				if (!r || !a) return e === i ? -1 : t === i ? 1 : r ? -1 : a ? 1 : $ ? Z($, e) - Z($, t) : 0;
				if (r === a) return s(e, t);
				for (n = e; n = n.parentNode;) l.unshift(n);
				for (n = t; n = n.parentNode;) c.unshift(n);
				for (; l[o] === c[o];) o++;
				return o ? s(l[o], c[o]) : l[o] === I ? -1 : c[o] === I ? 1 : 0
			}, i) : _
		}, t.matches = function(e, n) {
			return t(e, null, null, n)
		}, t.matchesSelector = function(e, n) {
			if ((e.ownerDocument || e) !== _ && M(e), n = n.replace(ce, "='$1']"), !(!w.matchesSelector || !N || O && O.test(n) || L && L.test(n))) try {
				var i = H.call(e, n);
				if (i || w.disconnectedMatch || e.document && 11 !== e.document.nodeType) return i
			} catch (e) {}
			return t(n, _, null, [e]).length > 0
		}, t.contains = function(e, t) {
			return (e.ownerDocument || e) !== _ && M(e), D(e, t)
		}, t.attr = function(e, t) {
			(e.ownerDocument || e) !== _ && M(e);
			var n = b.attrHandle[t.toLowerCase()],
				i = n && X.call(b.attrHandle, t.toLowerCase()) ? n(e, t, !N) : void 0;
			return void 0 !== i ? i : w.attributes || !N ? e.getAttribute(t) : (i = e.getAttributeNode(t)) && i.specified ? i.value : null
		}, t.error = function(e) {
			throw new Error("Syntax error, unrecognized expression: " + e)
		}, t.uniqueSort = function(e) {
			var t, n = [],
				i = 0,
				o = 0;
			if (A = !w.detectDuplicates, $ = !w.sortStable && e.slice(0), e.sort(W), A) {
				for (; t = e[o++];) t === e[o] && (i = n.push(o));
				for (; i--;) e.splice(n[i], 1)
			}
			return $ = null, e
		}, x = t.getText = function(e) {
			var t, n = "",
				i = 0,
				o = e.nodeType;
			if (o) {
				if (1 === o || 9 === o || 11 === o) {
					if ("string" == typeof e.textContent) return e.textContent;
					for (e = e.firstChild; e; e = e.nextSibling) n += x(e)
				} else if (3 === o || 4 === o) return e.nodeValue
			} else
				for (; t = e[i++];) n += x(t);
			return n
		}, b = t.selectors = {
			cacheLength: 50,
			createPseudo: i,
			match: pe,
			attrHandle: {},
			find: {},
			relative: {
				">": {
					dir: "parentNode",
					first: !0
				},
				" ": {
					dir: "parentNode"
				},
				"+": {
					dir: "previousSibling",
					first: !0
				},
				"~": {
					dir: "previousSibling"
				}
			},
			preFilter: {
				ATTR: function(e) {
					return e[1] = e[1].replace(we, be), e[3] = (e[3] || e[4] || e[5] || "").replace(we, be), "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4)
				},
				CHILD: function(e) {
					return e[1] = e[1].toLowerCase(), "nth" === e[1].slice(0, 3) ? (e[3] || t.error(e[0]), e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3])), e[5] = +(e[7] + e[8] || "odd" === e[3])) : e[3] && t.error(e[0]), e
				},
				PSEUDO: function(e) {
					var t, n = !e[6] && e[2];
					return pe.CHILD.test(e[0]) ? null : (e[3] ? e[2] = e[4] || e[5] || "" : n && de.test(n) && (t = k(n, !0)) && (t = n.indexOf(")", n.length - t) - n.length) && (e[0] = e[0].slice(0, t), e[2] = n.slice(0, t)), e.slice(0, 3))
				}
			},
			filter: {
				TAG: function(e) {
					var t = e.replace(we, be).toLowerCase();
					return "*" === e ? function() {
						return !0
					} : function(e) {
						return e.nodeName && e.nodeName.toLowerCase() === t
					}
				},
				CLASS: function(e) {
					var t = q[e + " "];
					return t || (t = new RegExp("(^|" + ee + ")" + e + "(" + ee + "|$)")) && q(e, function(e) {
						return t.test("string" == typeof e.className && e.className || void 0 !== e.getAttribute && e.getAttribute("class") || "")
					})
				},
				ATTR: function(e, n, i) {
					return function(o) {
						var r = t.attr(o, e);
						return null == r ? "!=" === n : !n || (r += "", "=" === n ? r === i : "!=" === n ? r !== i : "^=" === n ? i && 0 === r.indexOf(i) : "*=" === n ? i && r.indexOf(i) > -1 : "$=" === n ? i && r.slice(-i.length) === i : "~=" === n ? (" " + r.replace(re, " ") + " ").indexOf(i) > -1 : "|=" === n && (r === i || r.slice(0, i.length + 1) === i + "-"))
					}
				},
				CHILD: function(e, t, n, i, o) {
					var r = "nth" !== e.slice(0, 3),
						s = "last" !== e.slice(-4),
						a = "of-type" === t;
					return 1 === i && 0 === o ? function(e) {
						return !!e.parentNode
					} : function(t, n, l) {
						var c, d, u, p, f, h, m = r !== s ? "nextSibling" : "previousSibling",
							g = t.parentNode,
							v = a && t.nodeName.toLowerCase(),
							y = !l && !a;
						if (g) {
							if (r) {
								for (; m;) {
									for (u = t; u = u[m];)
										if (a ? u.nodeName.toLowerCase() === v : 1 === u.nodeType) return !1;
									h = m = "only" === e && !h && "nextSibling"
								}
								return !0
							}
							if (h = [s ? g.firstChild : g.lastChild], s && y) {
								for (d = g[j] || (g[j] = {}), c = d[e] || [], f = c[0] === z && c[1], p = c[0] === z && c[2], u = f && g.childNodes[f]; u = ++f && u && u[m] || (p = f = 0) || h.pop();)
									if (1 === u.nodeType && ++p && u === t) {
										d[e] = [z, f, p];
										break
									}
							} else if (y && (c = (t[j] || (t[j] = {}))[e]) && c[0] === z) p = c[1];
							else
								for (;
									(u = ++f && u && u[m] || (p = f = 0) || h.pop()) && ((a ? u.nodeName.toLowerCase() !== v : 1 !== u.nodeType) || !++p || (y && ((u[j] || (u[j] = {}))[e] = [z, p]), u !== t)););
							return (p -= o) === i || p % i == 0 && p / i >= 0
						}
					}
				},
				PSEUDO: function(e, n) {
					var o, r = b.pseudos[e] || b.setFilters[e.toLowerCase()] || t.error("unsupported pseudo: " + e);
					return r[j] ? r(n) : r.length > 1 ? (o = [e, e, "", n], b.setFilters.hasOwnProperty(e.toLowerCase()) ? i(function(e, t) {
						for (var i, o = r(e, n), s = o.length; s--;) i = Z(e, o[s]), e[i] = !(t[i] = o[s])
					}) : function(e) {
						return r(e, 0, o)
					}) : r
				}
			},
			pseudos: {
				not: i(function(e) {
					var t = [],
						n = [],
						o = S(e.replace(se, "$1"));
					return o[j] ? i(function(e, t, n, i) {
						for (var r, s = o(e, null, i, []), a = e.length; a--;)(r = s[a]) && (e[a] = !(t[a] = r))
					}) : function(e, i, r) {
						return t[0] = e, o(t, null, r, n), t[0] = null, !n.pop()
					}
				}),
				has: i(function(e) {
					return function(n) {
						return t(e, n).length > 0
					}
				}),
				contains: i(function(e) {
					return e = e.replace(we, be),
						function(t) {
							return (t.textContent || t.innerText || x(t)).indexOf(e) > -1
						}
				}),
				lang: i(function(e) {
					return ue.test(e || "") || t.error("unsupported lang: " + e), e = e.replace(we, be).toLowerCase(),
						function(t) {
							var n;
							do {
								if (n = N ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang")) return (n = n.toLowerCase()) === e || 0 === n.indexOf(e + "-")
							} while ((t = t.parentNode) && 1 === t.nodeType);
							return !1
						}
				}),
				target: function(t) {
					var n = e.location && e.location.hash;
					return n && n.slice(1) === t.id
				},
				root: function(e) {
					return e === P
				},
				focus: function(e) {
					return e === _.activeElement && (!_.hasFocus || _.hasFocus()) && !!(e.type || e.href || ~e.tabIndex)
				},
				enabled: function(e) {
					return !1 === e.disabled
				},
				disabled: function(e) {
					return !0 === e.disabled
				},
				checked: function(e) {
					var t = e.nodeName.toLowerCase();
					return "input" === t && !!e.checked || "option" === t && !!e.selected
				},
				selected: function(e) {
					return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected
				},
				empty: function(e) {
					for (e = e.firstChild; e; e = e.nextSibling)
						if (e.nodeType < 6) return !1;
					return !0
				},
				parent: function(e) {
					return !b.pseudos.empty(e)
				},
				header: function(e) {
					return he.test(e.nodeName)
				},
				input: function(e) {
					return fe.test(e.nodeName)
				},
				button: function(e) {
					var t = e.nodeName.toLowerCase();
					return "input" === t && "button" === e.type || "button" === t
				},
				text: function(e) {
					var t;
					return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase())
				},
				first: a(function() {
					return [0]
				}),
				last: a(function(e, t) {
					return [t - 1]
				}),
				eq: a(function(e, t, n) {
					return [0 > n ? n + t : n]
				}),
				even: a(function(e, t) {
					for (var n = 0; t > n; n += 2) e.push(n);
					return e
				}),
				odd: a(function(e, t) {
					for (var n = 1; t > n; n += 2) e.push(n);
					return e
				}),
				lt: a(function(e, t, n) {
					for (var i = 0 > n ? n + t : n; --i >= 0;) e.push(i);
					return e
				}),
				gt: a(function(e, t, n) {
					for (var i = 0 > n ? n + t : n; ++i < t;) e.push(i);
					return e
				})
			}
		}, b.pseudos.nth = b.pseudos.eq;
		for (y in {
				radio: !0,
				checkbox: !0,
				file: !0,
				password: !0,
				image: !0
			}) b.pseudos[y] = function(e) {
			return function(t) {
				return "input" === t.nodeName.toLowerCase() && t.type === e
			}
		}(y);
		for (y in {
				submit: !0,
				reset: !0
			}) b.pseudos[y] = function(e) {
			return function(t) {
				var n = t.nodeName.toLowerCase();
				return ("input" === n || "button" === n) && t.type === e
			}
		}(y);
		return c.prototype = b.filters = b.pseudos, b.setFilters = new c, k = t.tokenize = function(e, n) {
			var i, o, r, s, a, l, c, d = B[e + " "];
			if (d) return n ? 0 : d.slice(0);
			for (a = e, l = [], c = b.preFilter; a;) {
				(!i || (o = ae.exec(a))) && (o && (a = a.slice(o[0].length) || a), l.push(r = [])), i = !1, (o = le.exec(a)) && (i = o.shift(), r.push({
					value: i,
					type: o[0].replace(se, " ")
				}), a = a.slice(i.length));
				for (s in b.filter) !(o = pe[s].exec(a)) || c[s] && !(o = c[s](o)) || (i = o.shift(), r.push({
					value: i,
					type: s,
					matches: o
				}), a = a.slice(i.length));
				if (!i) break
			}
			return n ? a.length : a ? t.error(e) : B(e, l).slice(0)
		}, S = t.compile = function(e, t) {
			var n, i = [],
				o = [],
				r = R[e + " "];
			if (!r) {
				for (t || (t = k(e)), n = t.length; n--;) r = g(t[n]), r[j] ? i.push(r) : o.push(r);
				r = R(e, v(o, i)), r.selector = e
			}
			return r
		}, C = t.select = function(e, t, n, i) {
			var o, r, s, a, c, u = "function" == typeof e && e,
				p = !i && k(e = u.selector || e);
			if (n = n || [], 1 === p.length) {
				if (r = p[0] = p[0].slice(0), r.length > 2 && "ID" === (s = r[0]).type && w.getById && 9 === t.nodeType && N && b.relative[r[1].type]) {
					if (!(t = (b.find.ID(s.matches[0].replace(we, be), t) || [])[0])) return n;
					u && (t = t.parentNode), e = e.slice(r.shift().value.length)
				}
				for (o = pe.needsContext.test(e) ? 0 : r.length; o-- && (s = r[o], !b.relative[a = s.type]);)
					if ((c = b.find[a]) && (i = c(s.matches[0].replace(we, be), ve.test(r[0].type) && l(t.parentNode) || t))) {
						if (r.splice(o, 1), !(e = i.length && d(r))) return K.apply(n, i), n;
						break
					}
			}
			return (u || S(e, p))(i, t, !N, n, ve.test(e) && l(t.parentNode) || t), n
		}, w.sortStable = j.split("").sort(W).join("") === j, w.detectDuplicates = !!A, M(), w.sortDetached = o(function(e) {
			return 1 & e.compareDocumentPosition(_.createElement("div"))
		}), o(function(e) {
			return e.innerHTML = "<a href='#'></a>", "#" === e.firstChild.getAttribute("href")
		}) || r("type|href|height|width", function(e, t, n) {
			return n ? void 0 : e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2)
		}), w.attributes && o(function(e) {
			return e.innerHTML = "<input/>", e.firstChild.setAttribute("value", ""), "" === e.firstChild.getAttribute("value")
		}) || r("value", function(e, t, n) {
			return n || "input" !== e.nodeName.toLowerCase() ? void 0 : e.defaultValue
		}), o(function(e) {
			return null == e.getAttribute("disabled")
		}) || r(J, function(e, t, n) {
			var i;
			return n ? void 0 : !0 === e[t] ? t.toLowerCase() : (i = e.getAttributeNode(t)) && i.specified ? i.value : null
		}), t
	}(e);
	oe.find = ce, oe.expr = ce.selectors, oe.expr[":"] = oe.expr.pseudos, oe.unique = ce.uniqueSort, oe.text = ce.getText, oe.isXMLDoc = ce.isXML, oe.contains = ce.contains;
	var de = oe.expr.match.needsContext,
		ue = /^<(\w+)\s*\/?>(?:<\/\1>|)$/,
		pe = /^.[^:#\[\.,]*$/;
	oe.filter = function(e, t, n) {
		var i = t[0];
		return n && (e = ":not(" + e + ")"), 1 === t.length && 1 === i.nodeType ? oe.find.matchesSelector(i, e) ? [i] : [] : oe.find.matches(e, oe.grep(t, function(e) {
			return 1 === e.nodeType
		}))
	}, oe.fn.extend({
		find: function(e) {
			var t, n = [],
				i = this,
				o = i.length;
			if ("string" != typeof e) return this.pushStack(oe(e).filter(function() {
				for (t = 0; o > t; t++)
					if (oe.contains(i[t], this)) return !0
			}));
			for (t = 0; o > t; t++) oe.find(e, i[t], n);
			return n = this.pushStack(o > 1 ? oe.unique(n) : n), n.selector = this.selector ? this.selector + " " + e : e, n
		},
		filter: function(e) {
			return this.pushStack(i(this, e || [], !1))
		},
		not: function(e) {
			return this.pushStack(i(this, e || [], !0))
		},
		is: function(e) {
			return !!i(this, "string" == typeof e && de.test(e) ? oe(e) : e || [], !1).length
		}
	});
	var fe, he = e.document,
		me = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/;
	(oe.fn.init = function(e, t) {
		var n, i;
		if (!e) return this;
		if ("string" == typeof e) {
			if (!(n = "<" === e.charAt(0) && ">" === e.charAt(e.length - 1) && e.length >= 3 ? [null, e, null] : me.exec(e)) || !n[1] && t) return !t || t.jquery ? (t || fe).find(e) : this.constructor(t).find(e);
			if (n[1]) {
				if (t = t instanceof oe ? t[0] : t, oe.merge(this, oe.parseHTML(n[1], t && t.nodeType ? t.ownerDocument || t : he, !0)), ue.test(n[1]) && oe.isPlainObject(t))
					for (n in t) oe.isFunction(this[n]) ? this[n](t[n]) : this.attr(n, t[n]);
				return this
			}
			if ((i = he.getElementById(n[2])) && i.parentNode) {
				if (i.id !== n[2]) return fe.find(e);
				this.length = 1, this[0] = i
			}
			return this.context = he, this.selector = e, this
		}
		return e.nodeType ? (this.context = this[0] = e, this.length = 1, this) : oe.isFunction(e) ? void 0 !== fe.ready ? fe.ready(e) : e(oe) : (void 0 !== e.selector && (this.selector = e.selector, this.context = e.context), oe.makeArray(e, this))
	}).prototype = oe.fn, fe = oe(he);
	var ge = /^(?:parents|prev(?:Until|All))/,
		ve = {
			children: !0,
			contents: !0,
			next: !0,
			prev: !0
		};
	oe.extend({
		dir: function(e, t, n) {
			for (var i = [], o = e[t]; o && 9 !== o.nodeType && (void 0 === n || 1 !== o.nodeType || !oe(o).is(n));) 1 === o.nodeType && i.push(o), o = o[t];
			return i
		},
		sibling: function(e, t) {
			for (var n = []; e; e = e.nextSibling) 1 === e.nodeType && e !== t && n.push(e);
			return n
		}
	}), oe.fn.extend({
		has: function(e) {
			var t, n = oe(e, this),
				i = n.length;
			return this.filter(function() {
				for (t = 0; i > t; t++)
					if (oe.contains(this, n[t])) return !0
			})
		},
		closest: function(e, t) {
			for (var n, i = 0, o = this.length, r = [], s = de.test(e) || "string" != typeof e ? oe(e, t || this.context) : 0; o > i; i++)
				for (n = this[i]; n && n !== t; n = n.parentNode)
					if (n.nodeType < 11 && (s ? s.index(n) > -1 : 1 === n.nodeType && oe.find.matchesSelector(n, e))) {
						r.push(n);
						break
					} return this.pushStack(r.length > 1 ? oe.unique(r) : r)
		},
		index: function(e) {
			return e ? "string" == typeof e ? oe.inArray(this[0], oe(e)) : oe.inArray(e.jquery ? e[0] : e, this) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
		},
		add: function(e, t) {
			return this.pushStack(oe.unique(oe.merge(this.get(), oe(e, t))))
		},
		addBack: function(e) {
			return this.add(null == e ? this.prevObject : this.prevObject.filter(e))
		}
	}), oe.each({
		parent: function(e) {
			var t = e.parentNode;
			return t && 11 !== t.nodeType ? t : null
		},
		parents: function(e) {
			return oe.dir(e, "parentNode")
		},
		parentsUntil: function(e, t, n) {
			return oe.dir(e, "parentNode", n)
		},
		next: function(e) {
			return o(e, "nextSibling")
		},
		prev: function(e) {
			return o(e, "previousSibling")
		},
		nextAll: function(e) {
			return oe.dir(e, "nextSibling")
		},
		prevAll: function(e) {
			return oe.dir(e, "previousSibling")
		},
		nextUntil: function(e, t, n) {
			return oe.dir(e, "nextSibling", n)
		},
		prevUntil: function(e, t, n) {
			return oe.dir(e, "previousSibling", n)
		},
		siblings: function(e) {
			return oe.sibling((e.parentNode || {}).firstChild, e)
		},
		children: function(e) {
			return oe.sibling(e.firstChild)
		},
		contents: function(e) {
			return oe.nodeName(e, "iframe") ? e.contentDocument || e.contentWindow.document : oe.merge([], e.childNodes)
		}
	}, function(e, t) {
		oe.fn[e] = function(n, i) {
			var o = oe.map(this, t, n);
			return "Until" !== e.slice(-5) && (i = n), i && "string" == typeof i && (o = oe.filter(i, o)), this.length > 1 && (ve[e] || (o = oe.unique(o)), ge.test(e) && (o = o.reverse())), this.pushStack(o)
		}
	});
	var ye = /\S+/g,
		we = {};
	oe.Callbacks = function(e) {
		e = "string" == typeof e ? we[e] || r(e) : oe.extend({}, e);
		var t, n, i, o, s, a, l = [],
			c = !e.once && [],
			d = function r(d) {
				for (n = e.memory && d, i = !0, s = a || 0, a = 0, o = l.length, t = !0; l && o > s; s++)
					if (!1 === l[s].apply(d[0], d[1]) && e.stopOnFalse) {
						n = !1;
						break
					} t = !1, l && (c ? c.length && r(c.shift()) : n ? l = [] : u.disable())
			},
			u = {
				add: function() {
					if (l) {
						var i = l.length;
						! function t(n) {
							oe.each(n, function(n, i) {
								var o = oe.type(i);
								"function" === o ? e.unique && u.has(i) || l.push(i) : i && i.length && "string" !== o && t(i)
							})
						}(arguments), t ? o = l.length : n && (a = i, d(n))
					}
					return this
				},
				remove: function() {
					return l && oe.each(arguments, function(e, n) {
						for (var i;
							(i = oe.inArray(n, l, i)) > -1;) l.splice(i, 1), t && (o >= i && o--, s >= i && s--)
					}), this
				},
				has: function(e) {
					return e ? oe.inArray(e, l) > -1 : !(!l || !l.length)
				},
				empty: function() {
					return l = [], o = 0, this
				},
				disable: function() {
					return l = c = n = void 0, this
				},
				disabled: function() {
					return !l
				},
				lock: function() {
					return c = void 0, n || u.disable(), this
				},
				locked: function() {
					return !c
				},
				fireWith: function(e, n) {
					return !l || i && !c || (n = n || [], n = [e, n.slice ? n.slice() : n], t ? c.push(n) : d(n)), this
				},
				fire: function() {
					return u.fireWith(this, arguments), this
				},
				fired: function() {
					return !!i
				}
			};
		return u
	}, oe.extend({
		Deferred: function(e) {
			var t = [
					["resolve", "done", oe.Callbacks("once memory"), "resolved"],
					["reject", "fail", oe.Callbacks("once memory"), "rejected"],
					["notify", "progress", oe.Callbacks("memory")]
				],
				n = "pending",
				i = {
					state: function() {
						return n
					},
					always: function() {
						return o.done(arguments).fail(arguments), this
					},
					then: function() {
						var e = arguments;
						return oe.Deferred(function(n) {
							oe.each(t, function(t, r) {
								var s = oe.isFunction(e[t]) && e[t];
								o[r[1]](function() {
									var e = s && s.apply(this, arguments);
									e && oe.isFunction(e.promise) ? e.promise().done(n.resolve).fail(n.reject).progress(n.notify) : n[r[0] + "With"](this === i ? n.promise() : this, s ? [e] : arguments)
								})
							}), e = null
						}).promise()
					},
					promise: function(e) {
						return null != e ? oe.extend(e, i) : i
					}
				},
				o = {};
			return i.pipe = i.then, oe.each(t, function(e, r) {
				var s = r[2],
					a = r[3];
				i[r[1]] = s.add, a && s.add(function() {
					n = a
				}, t[1 ^ e][2].disable, t[2][2].lock), o[r[0]] = function() {
					return o[r[0] + "With"](this === o ? i : this, arguments), this
				}, o[r[0] + "With"] = s.fireWith
			}), i.promise(o), e && e.call(o, o), o
		},
		when: function(e) {
			var t, n, i, o = 0,
				r = G.call(arguments),
				s = r.length,
				a = 1 !== s || e && oe.isFunction(e.promise) ? s : 0,
				l = 1 === a ? e : oe.Deferred(),
				c = function(e, n, i) {
					return function(o) {
						n[e] = this, i[e] = arguments.length > 1 ? G.call(arguments) : o, i === t ? l.notifyWith(n, i) : --a || l.resolveWith(n, i)
					}
				};
			if (s > 1)
				for (t = new Array(s), n = new Array(s), i = new Array(s); s > o; o++) r[o] && oe.isFunction(r[o].promise) ? r[o].promise().done(c(o, i, r)).fail(l.reject).progress(c(o, n, t)) : --a;
			return a || l.resolveWith(i, r), l.promise()
		}
	});
	var be;
	oe.fn.ready = function(e) {
		return oe.ready.promise().done(e), this
	}, oe.extend({
		isReady: !1,
		readyWait: 1,
		holdReady: function(e) {
			e ? oe.readyWait++ : oe.ready(!0)
		},
		ready: function(e) {
			if (!0 === e ? !--oe.readyWait : !oe.isReady) {
				if (!he.body) return setTimeout(oe.ready);
				oe.isReady = !0, !0 !== e && --oe.readyWait > 0 || (be.resolveWith(he, [oe]), oe.fn.triggerHandler && (oe(he).triggerHandler("ready"), oe(he).off("ready")))
			}
		}
	}), oe.ready.promise = function(t) {
		if (!be)
			if (be = oe.Deferred(), "complete" === he.readyState) setTimeout(oe.ready);
			else if (he.addEventListener) he.addEventListener("DOMContentLoaded", a, !1), e.addEventListener("load", a, !1);
		else {
			he.attachEvent("onreadystatechange", a), e.attachEvent("onload", a);
			var n = !1;
			try {
				n = null == e.frameElement && he.documentElement
			} catch (e) {}
			n && n.doScroll && function e() {
				if (!oe.isReady) {
					try {
						n.doScroll("left")
					} catch (t) {
						return setTimeout(e, 50)
					}
					s(), oe.ready()
				}
			}()
		}
		return be.promise(t)
	};
	var xe, Te = "undefined";
	for (xe in oe(ne)) break;
	ne.ownLast = "0" !== xe, ne.inlineBlockNeedsLayout = !1, oe(function() {
			var e, t, n, i;
			(n = he.getElementsByTagName("body")[0]) && n.style && (t = he.createElement("div"), i = he.createElement("div"), i.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px", n.appendChild(i).appendChild(t), _typeof(t.style.zoom) !== Te && (t.style.cssText = "display:inline;margin:0;border:0;padding:1px;width:1px;zoom:1", ne.inlineBlockNeedsLayout = e = 3 === t.offsetWidth, e && (n.style.zoom = 1)), n.removeChild(i))
		}),
		function() {
			var e = he.createElement("div");
			if (null == ne.deleteExpando) {
				ne.deleteExpando = !0;
				try {
					delete e.test
				} catch (e) {
					ne.deleteExpando = !1
				}
			}
			e = null
		}(), oe.acceptData = function(e) {
			var t = oe.noData[(e.nodeName + " ").toLowerCase()],
				n = +e.nodeType || 1;
			return (1 === n || 9 === n) && (!t || !0 !== t && e.getAttribute("classid") === t)
		};
	var ke = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		Se = /([A-Z])/g;
	oe.extend({
		cache: {},
		noData: {
			"applet ": !0,
			"embed ": !0,
			"object ": "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"
		},
		hasData: function(e) {
			return !!(e = e.nodeType ? oe.cache[e[oe.expando]] : e[oe.expando]) && !c(e)
		},
		data: function(e, t, n) {
			return d(e, t, n)
		},
		removeData: function(e, t) {
			return u(e, t)
		},
		_data: function(e, t, n) {
			return d(e, t, n, !0)
		},
		_removeData: function(e, t) {
			return u(e, t, !0)
		}
	}), oe.fn.extend({
		data: function(e, t) {
			var n, i, o, r = this[0],
				s = r && r.attributes;
			if (void 0 === e) {
				if (this.length && (o = oe.data(r), 1 === r.nodeType && !oe._data(r, "parsedAttrs"))) {
					for (n = s.length; n--;) s[n] && (i = s[n].name, 0 === i.indexOf("data-") && (i = oe.camelCase(i.slice(5)), l(r, i, o[i])));
					oe._data(r, "parsedAttrs", !0)
				}
				return o
			}
			return "object" == _typeof(e) ? this.each(function() {
				oe.data(this, e)
			}) : arguments.length > 1 ? this.each(function() {
				oe.data(this, e, t)
			}) : r ? l(r, e, oe.data(r, e)) : void 0
		},
		removeData: function(e) {
			return this.each(function() {
				oe.removeData(this, e)
			})
		}
	}), oe.extend({
		queue: function(e, t, n) {
			var i;
			return e ? (t = (t || "fx") + "queue", i = oe._data(e, t), n && (!i || oe.isArray(n) ? i = oe._data(e, t, oe.makeArray(n)) : i.push(n)), i || []) : void 0
		},
		dequeue: function(e, t) {
			t = t || "fx";
			var n = oe.queue(e, t),
				i = n.length,
				o = n.shift(),
				r = oe._queueHooks(e, t),
				s = function() {
					oe.dequeue(e, t)
				};
			"inprogress" === o && (o = n.shift(), i--), o && ("fx" === t && n.unshift("inprogress"), delete r.stop, o.call(e, s, r)), !i && r && r.empty.fire()
		},
		_queueHooks: function(e, t) {
			var n = t + "queueHooks";
			return oe._data(e, n) || oe._data(e, n, {
				empty: oe.Callbacks("once memory").add(function() {
					oe._removeData(e, t + "queue"), oe._removeData(e, n)
				})
			})
		}
	}), oe.fn.extend({
		queue: function(e, t) {
			var n = 2;
			return "string" != typeof e && (t = e, e = "fx", n--), arguments.length < n ? oe.queue(this[0], e) : void 0 === t ? this : this.each(function() {
				var n = oe.queue(this, e, t);
				oe._queueHooks(this, e), "fx" === e && "inprogress" !== n[0] && oe.dequeue(this, e)
			})
		},
		dequeue: function(e) {
			return this.each(function() {
				oe.dequeue(this, e)
			})
		},
		clearQueue: function(e) {
			return this.queue(e || "fx", [])
		},
		promise: function(e, t) {
			var n, i = 1,
				o = oe.Deferred(),
				r = this,
				s = this.length,
				a = function() {
					--i || o.resolveWith(r, [r])
				};
			for ("string" != typeof e && (t = e, e = void 0), e = e || "fx"; s--;)(n = oe._data(r[s], e + "queueHooks")) && n.empty && (i++, n.empty.add(a));
			return a(), o.promise(t)
		}
	});
	var Ce = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
		Ee = ["Top", "Right", "Bottom", "Left"],
		$e = function(e, t) {
			return e = t || e, "none" === oe.css(e, "display") || !oe.contains(e.ownerDocument, e)
		},
		Ae = oe.access = function(e, t, n, i, o, r, s) {
			var a = 0,
				l = e.length,
				c = null == n;
			if ("object" === oe.type(n)) {
				o = !0;
				for (a in n) oe.access(e, t, a, n[a], !0, r, s)
			} else if (void 0 !== i && (o = !0, oe.isFunction(i) || (s = !0), c && (s ? (t.call(e, i), t = null) : (c = t, t = function(e, t, n) {
					return c.call(oe(e), n)
				})), t))
				for (; l > a; a++) t(e[a], n, s ? i : i.call(e[a], a, t(e[a], n)));
			return o ? e : c ? t.call(e) : l ? t(e[0], n) : r
		},
		Me = /^(?:checkbox|radio)$/i;
	! function() {
		var e = he.createElement("input"),
			t = he.createElement("div"),
			n = he.createDocumentFragment();
		if (t.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>", ne.leadingWhitespace = 3 === t.firstChild.nodeType, ne.tbody = !t.getElementsByTagName("tbody").length, ne.htmlSerialize = !!t.getElementsByTagName("link").length, ne.html5Clone = "<:nav></:nav>" !== he.createElement("nav").cloneNode(!0).outerHTML, e.type = "checkbox", e.checked = !0, n.appendChild(e), ne.appendChecked = e.checked, t.innerHTML = "<textarea>x</textarea>", ne.noCloneChecked = !!t.cloneNode(!0).lastChild.defaultValue, n.appendChild(t), t.innerHTML = "<input type='radio' checked='checked' name='t'/>", ne.checkClone = t.cloneNode(!0).cloneNode(!0).lastChild.checked, ne.noCloneEvent = !0, t.attachEvent && (t.attachEvent("onclick", function() {
				ne.noCloneEvent = !1
			}), t.cloneNode(!0).click()), null == ne.deleteExpando) {
			ne.deleteExpando = !0;
			try {
				delete t.test
			} catch (e) {
				ne.deleteExpando = !1
			}
		}
	}(),
	function() {
		var t, n, i = he.createElement("div");
		for (t in {
				submit: !0,
				change: !0,
				focusin: !0
			}) n = "on" + t, (ne[t + "Bubbles"] = n in e) || (i.setAttribute(n, "t"), ne[t + "Bubbles"] = !1 === i.attributes[n].expando);
		i = null
	}();
	var _e = /^(?:input|select|textarea)$/i,
		Pe = /^key/,
		Ne = /^(?:mouse|pointer|contextmenu)|click/,
		Le = /^(?:focusinfocus|focusoutblur)$/,
		Oe = /^([^.]*)(?:\.(.+)|)$/;
	oe.event = {
		global: {},
		add: function(e, t, n, i, o) {
			var r, s, a, l, c, d, u, p, f, h, m, g = oe._data(e);
			if (g) {
				for (n.handler && (l = n, n = l.handler, o = l.selector), n.guid || (n.guid = oe.guid++), (s = g.events) || (s = g.events = {}), (d = g.handle) || (d = g.handle = function(e) {
						return _typeof(oe) === Te || e && oe.event.triggered === e.type ? void 0 : oe.event.dispatch.apply(d.elem, arguments)
					}, d.elem = e), t = (t || "").match(ye) || [""], a = t.length; a--;) r = Oe.exec(t[a]) || [], f = m = r[1], h = (r[2] || "").split(".").sort(), f && (c = oe.event.special[f] || {}, f = (o ? c.delegateType : c.bindType) || f, c = oe.event.special[f] || {}, u = oe.extend({
					type: f,
					origType: m,
					data: i,
					handler: n,
					guid: n.guid,
					selector: o,
					needsContext: o && oe.expr.match.needsContext.test(o),
					namespace: h.join(".")
				}, l), (p = s[f]) || (p = s[f] = [], p.delegateCount = 0, c.setup && !1 !== c.setup.call(e, i, h, d) || (e.addEventListener ? e.addEventListener(f, d, !1) : e.attachEvent && e.attachEvent("on" + f, d))), c.add && (c.add.call(e, u), u.handler.guid || (u.handler.guid = n.guid)), o ? p.splice(p.delegateCount++, 0, u) : p.push(u), oe.event.global[f] = !0);
				e = null
			}
		},
		remove: function(e, t, n, i, o) {
			var r, s, a, l, c, d, u, p, f, h, m, g = oe.hasData(e) && oe._data(e);
			if (g && (d = g.events)) {
				for (t = (t || "").match(ye) || [""], c = t.length; c--;)
					if (a = Oe.exec(t[c]) || [], f = m = a[1], h = (a[2] || "").split(".").sort(), f) {
						for (u = oe.event.special[f] || {}, f = (i ? u.delegateType : u.bindType) || f, p = d[f] || [], a = a[2] && new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)"), l = r = p.length; r--;) s = p[r], !o && m !== s.origType || n && n.guid !== s.guid || a && !a.test(s.namespace) || i && i !== s.selector && ("**" !== i || !s.selector) || (p.splice(r, 1), s.selector && p.delegateCount--, u.remove && u.remove.call(e, s));
						l && !p.length && (u.teardown && !1 !== u.teardown.call(e, h, g.handle) || oe.removeEvent(e, f, g.handle), delete d[f])
					} else
						for (f in d) oe.event.remove(e, f + t[c], n, i, !0);
				oe.isEmptyObject(d) && (delete g.handle, oe._removeData(e, "events"))
			}
		},
		trigger: function(t, n, i, o) {
			var r, s, a, l, c, d, u, p = [i || he],
				f = te.call(t, "type") ? t.type : t,
				h = te.call(t, "namespace") ? t.namespace.split(".") : [];
			if (a = d = i = i || he, 3 !== i.nodeType && 8 !== i.nodeType && !Le.test(f + oe.event.triggered) && (f.indexOf(".") >= 0 && (h = f.split("."), f = h.shift(), h.sort()), s = f.indexOf(":") < 0 && "on" + f, t = t[oe.expando] ? t : new oe.Event(f, "object" == _typeof(t) && t), t.isTrigger = o ? 2 : 3, t.namespace = h.join("."), t.namespace_re = t.namespace ? new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, t.result = void 0, t.target || (t.target = i), n = null == n ? [t] : oe.makeArray(n, [t]), c = oe.event.special[f] || {}, o || !c.trigger || !1 !== c.trigger.apply(i, n))) {
				if (!o && !c.noBubble && !oe.isWindow(i)) {
					for (l = c.delegateType || f, Le.test(l + f) || (a = a.parentNode); a; a = a.parentNode) p.push(a), d = a;
					d === (i.ownerDocument || he) && p.push(d.defaultView || d.parentWindow || e)
				}
				for (u = 0;
					(a = p[u++]) && !t.isPropagationStopped();) t.type = u > 1 ? l : c.bindType || f, r = (oe._data(a, "events") || {})[t.type] && oe._data(a, "handle"), r && r.apply(a, n), (r = s && a[s]) && r.apply && oe.acceptData(a) && (t.result = r.apply(a, n), !1 === t.result && t.preventDefault());
				if (t.type = f, !o && !t.isDefaultPrevented() && (!c._default || !1 === c._default.apply(p.pop(), n)) && oe.acceptData(i) && s && i[f] && !oe.isWindow(i)) {
					d = i[s], d && (i[s] = null), oe.event.triggered = f;
					try {
						i[f]()
					} catch (e) {}
					oe.event.triggered = void 0, d && (i[s] = d)
				}
				return t.result
			}
		},
		dispatch: function(e) {
			e = oe.event.fix(e);
			var t, n, i, o, r, s = [],
				a = G.call(arguments),
				l = (oe._data(this, "events") || {})[e.type] || [],
				c = oe.event.special[e.type] || {};
			if (a[0] = e, e.delegateTarget = this, !c.preDispatch || !1 !== c.preDispatch.call(this, e)) {
				for (s = oe.event.handlers.call(this, e, l), t = 0;
					(o = s[t++]) && !e.isPropagationStopped();)
					for (e.currentTarget = o.elem, r = 0;
						(i = o.handlers[r++]) && !e.isImmediatePropagationStopped();)(!e.namespace_re || e.namespace_re.test(i.namespace)) && (e.handleObj = i, e.data = i.data, void 0 !== (n = ((oe.event.special[i.origType] || {}).handle || i.handler).apply(o.elem, a)) && !1 === (e.result = n) && (e.preventDefault(), e.stopPropagation()));
				return c.postDispatch && c.postDispatch.call(this, e), e.result
			}
		},
		handlers: function(e, t) {
			var n, i, o, r, s = [],
				a = t.delegateCount,
				l = e.target;
			if (a && l.nodeType && (!e.button || "click" !== e.type))
				for (; l != this; l = l.parentNode || this)
					if (1 === l.nodeType && (!0 !== l.disabled || "click" !== e.type)) {
						for (o = [], r = 0; a > r; r++) i = t[r], n = i.selector + " ", void 0 === o[n] && (o[n] = i.needsContext ? oe(n, this).index(l) >= 0 : oe.find(n, this, null, [l]).length), o[n] && o.push(i);
						o.length && s.push({
							elem: l,
							handlers: o
						})
					} return a < t.length && s.push({
				elem: this,
				handlers: t.slice(a)
			}), s
		},
		fix: function(e) {
			if (e[oe.expando]) return e;
			var t, n, i, o = e.type,
				r = e,
				s = this.fixHooks[o];
			for (s || (this.fixHooks[o] = s = Ne.test(o) ? this.mouseHooks : Pe.test(o) ? this.keyHooks : {}), i = s.props ? this.props.concat(s.props) : this.props, e = new oe.Event(r), t = i.length; t--;) n = i[t], e[n] = r[n];
			return e.target || (e.target = r.srcElement || he), 3 === e.target.nodeType && (e.target = e.target.parentNode), e.metaKey = !!e.metaKey, s.filter ? s.filter(e, r) : e
		},
		props: "altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),
		fixHooks: {},
		keyHooks: {
			props: "char charCode key keyCode".split(" "),
			filter: function(e, t) {
				return null == e.which && (e.which = null != t.charCode ? t.charCode : t.keyCode), e
			}
		},
		mouseHooks: {
			props: "button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
			filter: function(e, t) {
				var n, i, o, r = t.button,
					s = t.fromElement;
				return null == e.pageX && null != t.clientX && (i = e.target.ownerDocument || he, o = i.documentElement, n = i.body, e.pageX = t.clientX + (o && o.scrollLeft || n && n.scrollLeft || 0) - (o && o.clientLeft || n && n.clientLeft || 0), e.pageY = t.clientY + (o && o.scrollTop || n && n.scrollTop || 0) - (o && o.clientTop || n && n.clientTop || 0)), !e.relatedTarget && s && (e.relatedTarget = s === e.target ? t.toElement : s), e.which || void 0 === r || (e.which = 1 & r ? 1 : 2 & r ? 3 : 4 & r ? 2 : 0), e
			}
		},
		special: {
			load: {
				noBubble: !0
			},
			focus: {
				trigger: function() {
					if (this !== h() && this.focus) try {
						return this.focus(), !1
					} catch (e) {}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					return this === h() && this.blur ? (this.blur(), !1) : void 0
				},
				delegateType: "focusout"
			},
			click: {
				trigger: function() {
					return oe.nodeName(this, "input") && "checkbox" === this.type && this.click ? (this.click(), !1) : void 0
				},
				_default: function(e) {
					return oe.nodeName(e.target, "a")
				}
			},
			beforeunload: {
				postDispatch: function(e) {
					void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result)
				}
			}
		},
		simulate: function(e, t, n, i) {
			var o = oe.extend(new oe.Event, n, {
				type: e,
				isSimulated: !0,
				originalEvent: {}
			});
			i ? oe.event.trigger(o, null, t) : oe.event.dispatch.call(t, o), o.isDefaultPrevented() && n.preventDefault()
		}
	}, oe.removeEvent = he.removeEventListener ? function(e, t, n) {
		e.removeEventListener && e.removeEventListener(t, n, !1)
	} : function(e, t, n) {
		var i = "on" + t;
		e.detachEvent && (_typeof(e[i]) === Te && (e[i] = null), e.detachEvent(i, n))
	}, oe.Event = function(e, t) {
		return this instanceof oe.Event ? (e && e.type ? (this.originalEvent = e, this.type = e.type, this.isDefaultPrevented = e.defaultPrevented || void 0 === e.defaultPrevented && !1 === e.returnValue ? p : f) : this.type = e, t && oe.extend(this, t), this.timeStamp = e && e.timeStamp || oe.now(), void(this[oe.expando] = !0)) : new oe.Event(e, t)
	}, oe.Event.prototype = {
		isDefaultPrevented: f,
		isPropagationStopped: f,
		isImmediatePropagationStopped: f,
		preventDefault: function() {
			var e = this.originalEvent;
			this.isDefaultPrevented = p, e && (e.preventDefault ? e.preventDefault() : e.returnValue = !1)
		},
		stopPropagation: function() {
			var e = this.originalEvent;
			this.isPropagationStopped = p, e && (e.stopPropagation && e.stopPropagation(), e.cancelBubble = !0)
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
			this.isImmediatePropagationStopped = p, e && e.stopImmediatePropagation && e.stopImmediatePropagation(), this.stopPropagation()
		}
	}, oe.each({
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function(e, t) {
		oe.event.special[e] = {
			delegateType: t,
			bindType: t,
			handle: function(e) {
				var n, i = this,
					o = e.relatedTarget,
					r = e.handleObj;
				return (!o || o !== i && !oe.contains(i, o)) && (e.type = r.origType, n = r.handler.apply(this, arguments), e.type = t), n
			}
		}
	}), ne.submitBubbles || (oe.event.special.submit = {
		setup: function() {
			return !oe.nodeName(this, "form") && void oe.event.add(this, "click._submit keypress._submit", function(e) {
				var t = e.target,
					n = oe.nodeName(t, "input") || oe.nodeName(t, "button") ? t.form : void 0;
				n && !oe._data(n, "submitBubbles") && (oe.event.add(n, "submit._submit", function(e) {
					e._submit_bubble = !0
				}), oe._data(n, "submitBubbles", !0))
			})
		},
		postDispatch: function(e) {
			e._submit_bubble && (delete e._submit_bubble, this.parentNode && !e.isTrigger && oe.event.simulate("submit", this.parentNode, e, !0))
		},
		teardown: function() {
			return !oe.nodeName(this, "form") && void oe.event.remove(this, "._submit")
		}
	}), ne.changeBubbles || (oe.event.special.change = {
		setup: function() {
			return _e.test(this.nodeName) ? (("checkbox" === this.type || "radio" === this.type) && (oe.event.add(this, "propertychange._change", function(e) {
				"checked" === e.originalEvent.propertyName && (this._just_changed = !0)
			}), oe.event.add(this, "click._change", function(e) {
				this._just_changed && !e.isTrigger && (this._just_changed = !1), oe.event.simulate("change", this, e, !0)
			})), !1) : void oe.event.add(this, "beforeactivate._change", function(e) {
				var t = e.target;
				_e.test(t.nodeName) && !oe._data(t, "changeBubbles") && (oe.event.add(t, "change._change", function(e) {
					!this.parentNode || e.isSimulated || e.isTrigger || oe.event.simulate("change", this.parentNode, e, !0)
				}), oe._data(t, "changeBubbles", !0))
			})
		},
		handle: function(e) {
			var t = e.target;
			return this !== t || e.isSimulated || e.isTrigger || "radio" !== t.type && "checkbox" !== t.type ? e.handleObj.handler.apply(this, arguments) : void 0
		},
		teardown: function() {
			return oe.event.remove(this, "._change"), !_e.test(this.nodeName)
		}
	}), ne.focusinBubbles || oe.each({
		focus: "focusin",
		blur: "focusout"
	}, function(e, t) {
		var n = function(e) {
			oe.event.simulate(t, e.target, oe.event.fix(e), !0)
		};
		oe.event.special[t] = {
			setup: function() {
				var i = this.ownerDocument || this,
					o = oe._data(i, t);
				o || i.addEventListener(e, n, !0), oe._data(i, t, (o || 0) + 1)
			},
			teardown: function() {
				var i = this.ownerDocument || this,
					o = oe._data(i, t) - 1;
				o ? oe._data(i, t, o) : (i.removeEventListener(e, n, !0), oe._removeData(i, t))
			}
		}
	}), oe.fn.extend({
		on: function(e, t, n, i, o) {
			var r, s;
			if ("object" == _typeof(e)) {
				"string" != typeof t && (n = n || t, t = void 0);
				for (r in e) this.on(r, t, n, e[r], o);
				return this
			}
			if (null == n && null == i ? (i = t, n = t = void 0) : null == i && ("string" == typeof t ? (i = n, n = void 0) : (i = n, n = t, t = void 0)), !1 === i) i = f;
			else if (!i) return this;
			return 1 === o && (s = i, i = function(e) {
				return oe().off(e), s.apply(this, arguments)
			}, i.guid = s.guid || (s.guid = oe.guid++)), this.each(function() {
				oe.event.add(this, e, i, n, t)
			})
		},
		one: function(e, t, n, i) {
			return this.on(e, t, n, i, 1)
		},
		off: function(e, t, n) {
			var i, o;
			if (e && e.preventDefault && e.handleObj) return i = e.handleObj, oe(e.delegateTarget).off(i.namespace ? i.origType + "." + i.namespace : i.origType, i.selector, i.handler), this;
			if ("object" == _typeof(e)) {
				for (o in e) this.off(o, t, e[o]);
				return this
			}
			return (!1 === t || "function" == typeof t) && (n = t, t = void 0), !1 === n && (n = f), this.each(function() {
				oe.event.remove(this, e, n, t)
			})
		},
		trigger: function(e, t) {
			return this.each(function() {
				oe.event.trigger(e, t, this)
			})
		},
		triggerHandler: function(e, t) {
			var n = this[0];
			return n ? oe.event.trigger(e, t, n, !0) : void 0
		}
	});
	var He = "abbr|article|aside|audio|bdi|canvas|data|datalist|details|figcaption|figure|footer|header|hgroup|mark|meter|nav|output|progress|section|summary|time|video",
		De = / jQuery\d+="(?:null|\d+)"/g,
		je = new RegExp("<(?:" + He + ")[\\s/>]", "i"),
		Ie = /^\s+/,
		ze = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,
		Fe = /<([\w:]+)/,
		qe = /<tbody/i,
		Be = /<|&#?\w+;/,
		Re = /<(?:script|style|link)/i,
		We = /checked\s*(?:[^=]|=\s*.checked.)/i,
		Ue = /^$|\/(?:java|ecma)script/i,
		Xe = /^true\/(.*)/,
		Ve = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,
		Ye = {
			option: [1, "<select multiple='multiple'>", "</select>"],
			legend: [1, "<fieldset>", "</fieldset>"],
			area: [1, "<map>", "</map>"],
			param: [1, "<object>", "</object>"],
			thead: [1, "<table>", "</table>"],
			tr: [2, "<table><tbody>", "</tbody></table>"],
			col: [2, "<table><tbody></tbody><colgroup>", "</colgroup></table>"],
			td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
			_default: ne.htmlSerialize ? [0, "", ""] : [1, "X<div>", "</div>"]
		},
		Ge = m(he),
		Ke = Ge.appendChild(he.createElement("div"));
	Ye.optgroup = Ye.option, Ye.tbody = Ye.tfoot = Ye.colgroup = Ye.caption = Ye.thead, Ye.th = Ye.td, oe.extend({
		clone: function(e, t, n) {
			var i, o, r, s, a, l = oe.contains(e.ownerDocument, e);
			if (ne.html5Clone || oe.isXMLDoc(e) || !je.test("<" + e.nodeName + ">") ? r = e.cloneNode(!0) : (Ke.innerHTML = e.outerHTML, Ke.removeChild(r = Ke.firstChild)), !(ne.noCloneEvent && ne.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType || oe.isXMLDoc(e)))
				for (i = g(r), a = g(e), s = 0; null != (o = a[s]); ++s) i[s] && k(o, i[s]);
			if (t)
				if (n)
					for (a = a || g(e), i = i || g(r), s = 0; null != (o = a[s]); s++) T(o, i[s]);
				else T(e, r);
			return i = g(r, "script"), i.length > 0 && x(i, !l && g(e, "script")), i = a = o = null, r
		},
		buildFragment: function(e, t, n, i) {
			for (var o, r, s, a, l, c, d, u = e.length, p = m(t), f = [], h = 0; u > h; h++)
				if ((r = e[h]) || 0 === r)
					if ("object" === oe.type(r)) oe.merge(f, r.nodeType ? [r] : r);
					else if (Be.test(r)) {
				for (a = a || p.appendChild(t.createElement("div")), l = (Fe.exec(r) || ["", ""])[1].toLowerCase(), d = Ye[l] || Ye._default, a.innerHTML = d[1] + r.replace(ze, "<$1></$2>") + d[2], o = d[0]; o--;) a = a.lastChild;
				if (!ne.leadingWhitespace && Ie.test(r) && f.push(t.createTextNode(Ie.exec(r)[0])), !ne.tbody)
					for (r = "table" !== l || qe.test(r) ? "<table>" !== d[1] || qe.test(r) ? 0 : a : a.firstChild, o = r && r.childNodes.length; o--;) oe.nodeName(c = r.childNodes[o], "tbody") && !c.childNodes.length && r.removeChild(c);
				for (oe.merge(f, a.childNodes), a.textContent = ""; a.firstChild;) a.removeChild(a.firstChild);
				a = p.lastChild
			} else f.push(t.createTextNode(r));
			for (a && p.removeChild(a), ne.appendChecked || oe.grep(g(f, "input"), v), h = 0; r = f[h++];)
				if ((!i || -1 === oe.inArray(r, i)) && (s = oe.contains(r.ownerDocument, r), a = g(p.appendChild(r), "script"), s && x(a), n))
					for (o = 0; r = a[o++];) Ue.test(r.type || "") && n.push(r);
			return a = null, p
		},
		cleanData: function(e, t) {
			for (var n, i, o, r, s = 0, a = oe.expando, l = oe.cache, c = ne.deleteExpando, d = oe.event.special; null != (n = e[s]); s++)
				if ((t || oe.acceptData(n)) && (o = n[a], r = o && l[o])) {
					if (r.events)
						for (i in r.events) d[i] ? oe.event.remove(n, i) : oe.removeEvent(n, i, r.handle);
					l[o] && (delete l[o], c ? delete n[a] : _typeof(n.removeAttribute) !== Te ? n.removeAttribute(a) : n[a] = null, Y.push(o))
				}
		}
	}), oe.fn.extend({
		text: function(e) {
			return Ae(this, function(e) {
				return void 0 === e ? oe.text(this) : this.empty().append((this[0] && this[0].ownerDocument || he).createTextNode(e))
			}, null, e, arguments.length)
		},
		append: function() {
			return this.domManip(arguments, function(e) {
				if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
					y(this, e).appendChild(e)
				}
			})
		},
		prepend: function() {
			return this.domManip(arguments, function(e) {
				if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
					var t = y(this, e);
					t.insertBefore(e, t.firstChild)
				}
			})
		},
		before: function() {
			return this.domManip(arguments, function(e) {
				this.parentNode && this.parentNode.insertBefore(e, this)
			})
		},
		after: function() {
			return this.domManip(arguments, function(e) {
				this.parentNode && this.parentNode.insertBefore(e, this.nextSibling)
			})
		},
		remove: function(e, t) {
			for (var n, i = e ? oe.filter(e, this) : this, o = 0; null != (n = i[o]); o++) t || 1 !== n.nodeType || oe.cleanData(g(n)), n.parentNode && (t && oe.contains(n.ownerDocument, n) && x(g(n, "script")), n.parentNode.removeChild(n));
			return this
		},
		empty: function() {
			for (var e, t = 0; null != (e = this[t]); t++) {
				for (1 === e.nodeType && oe.cleanData(g(e, !1)); e.firstChild;) e.removeChild(e.firstChild);
				e.options && oe.nodeName(e, "select") && (e.options.length = 0)
			}
			return this
		},
		clone: function(e, t) {
			return e = null != e && e, t = null == t ? e : t, this.map(function() {
				return oe.clone(this, e, t)
			})
		},
		html: function(e) {
			return Ae(this, function(e) {
				var t = this[0] || {},
					n = 0,
					i = this.length;
				if (void 0 === e) return 1 === t.nodeType ? t.innerHTML.replace(De, "") : void 0;
				if (!("string" != typeof e || Re.test(e) || !ne.htmlSerialize && je.test(e) || !ne.leadingWhitespace && Ie.test(e) || Ye[(Fe.exec(e) || ["", ""])[1].toLowerCase()])) {
					e = e.replace(ze, "<$1></$2>");
					try {
						for (; i > n; n++) t = this[n] || {}, 1 === t.nodeType && (oe.cleanData(g(t, !1)), t.innerHTML = e);
						t = 0
					} catch (e) {}
				}
				t && this.empty().append(e)
			}, null, e, arguments.length)
		},
		replaceWith: function() {
			var e = arguments[0];
			return this.domManip(arguments, function(t) {
				e = this.parentNode, oe.cleanData(g(this)), e && e.replaceChild(t, this)
			}), e && (e.length || e.nodeType) ? this : this.remove()
		},
		detach: function(e) {
			return this.remove(e, !0)
		},
		domManip: function(e, t) {
			e = K.apply([], e);
			var n, i, o, r, s, a, l = 0,
				c = this.length,
				d = this,
				u = c - 1,
				p = e[0],
				f = oe.isFunction(p);
			if (f || c > 1 && "string" == typeof p && !ne.checkClone && We.test(p)) return this.each(function(n) {
				var i = d.eq(n);
				f && (e[0] = p.call(this, n, i.html())), i.domManip(e, t)
			});
			if (c && (a = oe.buildFragment(e, this[0].ownerDocument, !1, this), n = a.firstChild, 1 === a.childNodes.length && (a = n), n)) {
				for (r = oe.map(g(a, "script"), w), o = r.length; c > l; l++) i = a, l !== u && (i = oe.clone(i, !0, !0), o && oe.merge(r, g(i, "script"))), t.call(this[l], i, l);
				if (o)
					for (s = r[r.length - 1].ownerDocument, oe.map(r, b), l = 0; o > l; l++) i = r[l], Ue.test(i.type || "") && !oe._data(i, "globalEval") && oe.contains(s, i) && (i.src ? oe._evalUrl && oe._evalUrl(i.src) : oe.globalEval((i.text || i.textContent || i.innerHTML || "").replace(Ve, "")));
				a = n = null
			}
			return this
		}
	}), oe.each({
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function(e, t) {
		oe.fn[e] = function(e) {
			for (var n, i = 0, o = [], r = oe(e), s = r.length - 1; s >= i; i++) n = i === s ? this : this.clone(!0), oe(r[i])[t](n), Q.apply(o, n.get());
			return this.pushStack(o)
		}
	});
	var Qe, Ze = {};
	! function() {
		var e;
		ne.shrinkWrapBlocks = function() {
			if (null != e) return e;
			e = !1;
			var t, n, i;
			return n = he.getElementsByTagName("body")[0], n && n.style ? (t = he.createElement("div"), i = he.createElement("div"), i.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px", n.appendChild(i).appendChild(t), _typeof(t.style.zoom) !== Te && (t.style.cssText = "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:1px;width:1px;zoom:1", t.appendChild(he.createElement("div")).style.width = "5px", e = 3 !== t.offsetWidth), n.removeChild(i), e) : void 0
		}
	}();
	var Je, et, tt = /^margin/,
		nt = new RegExp("^(" + Ce + ")(?!px)[a-z%]+$", "i"),
		it = /^(top|right|bottom|left)$/;
	e.getComputedStyle ? (Je = function(t) {
		return t.ownerDocument.defaultView.opener ? t.ownerDocument.defaultView.getComputedStyle(t, null) : e.getComputedStyle(t, null)
	}, et = function(e, t, n) {
		var i, o, r, s, a = e.style;
		return n = n || Je(e), s = n ? n.getPropertyValue(t) || n[t] : void 0, n && ("" !== s || oe.contains(e.ownerDocument, e) || (s = oe.style(e, t)), nt.test(s) && tt.test(t) && (i = a.width, o = a.minWidth, r = a.maxWidth, a.minWidth = a.maxWidth = a.width = s, s = n.width, a.width = i, a.minWidth = o, a.maxWidth = r)), void 0 === s ? s : s + ""
	}) : he.documentElement.currentStyle && (Je = function(e) {
		return e.currentStyle
	}, et = function(e, t, n) {
		var i, o, r, s, a = e.style;
		return n = n || Je(e), s = n ? n[t] : void 0, null == s && a && a[t] && (s = a[t]), nt.test(s) && !it.test(t) && (i = a.left, o = e.runtimeStyle, r = o && o.left, r && (o.left = e.currentStyle.left), a.left = "fontSize" === t ? "1em" : s, s = a.pixelLeft + "px", a.left = i, r && (o.left = r)), void 0 === s ? s : s + "" || "auto"
	}), ! function() {
		var t, n, i, o, r, s, a;
		if (t = he.createElement("div"), t.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>", i = t.getElementsByTagName("a")[0], n = i && i.style) {
			var l = function() {
				var t, n, i, l;
				(n = he.getElementsByTagName("body")[0]) && n.style && (t = he.createElement("div"), i = he.createElement("div"), i.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px", n.appendChild(i).appendChild(t), t.style.cssText = "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;display:block;margin-top:1%;top:1%;border:1px;padding:1px;width:4px;position:absolute", o = r = !1, a = !0, e.getComputedStyle && (o = "1%" !== (e.getComputedStyle(t, null) || {}).top, r = "4px" === (e.getComputedStyle(t, null) || {
					width: "4px"
				}).width, l = t.appendChild(he.createElement("div")), l.style.cssText = t.style.cssText = "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0", l.style.marginRight = l.style.width = "0", t.style.width = "1px", a = !parseFloat((e.getComputedStyle(l, null) || {}).marginRight), t.removeChild(l)), t.innerHTML = "<table><tr><td></td><td>t</td></tr></table>", l = t.getElementsByTagName("td"), l[0].style.cssText = "margin:0;border:0;padding:0;display:none", s = 0 === l[0].offsetHeight, s && (l[0].style.display = "", l[1].style.display = "none", s = 0 === l[0].offsetHeight), n.removeChild(i))
			};
			n.cssText = "float:left;opacity:.5", ne.opacity = "0.5" === n.opacity, ne.cssFloat = !!n.cssFloat, t.style.backgroundClip = "content-box", t.cloneNode(!0).style.backgroundClip = "", ne.clearCloneStyle = "content-box" === t.style.backgroundClip, ne.boxSizing = "" === n.boxSizing || "" === n.MozBoxSizing || "" === n.WebkitBoxSizing, oe.extend(ne, {
				reliableHiddenOffsets: function() {
					return null == s && l(), s
				},
				boxSizingReliable: function() {
					return null == r && l(), r
				},
				pixelPosition: function() {
					return null == o && l(), o
				},
				reliableMarginRight: function() {
					return null == a && l(), a
				}
			})
		}
	}(), oe.swap = function(e, t, n, i) {
		var o, r, s = {};
		for (r in t) s[r] = e.style[r], e.style[r] = t[r];
		o = n.apply(e, i || []);
		for (r in t) e.style[r] = s[r];
		return o
	};
	var ot = /alpha\([^)]*\)/i,
		rt = /opacity\s*=\s*([^)]*)/,
		st = /^(none|table(?!-c[ea]).+)/,
		at = new RegExp("^(" + Ce + ")(.*)$", "i"),
		lt = new RegExp("^([+-])=(" + Ce + ")", "i"),
		ct = {
			position: "absolute",
			visibility: "hidden",
			display: "block"
		},
		dt = {
			letterSpacing: "0",
			fontWeight: "400"
		},
		ut = ["Webkit", "O", "Moz", "ms"];
	oe.extend({
		cssHooks: {
			opacity: {
				get: function(e, t) {
					if (t) {
						var n = et(e, "opacity");
						return "" === n ? "1" : n
					}
				}
			}
		},
		cssNumber: {
			columnCount: !0,
			fillOpacity: !0,
			flexGrow: !0,
			flexShrink: !0,
			fontWeight: !0,
			lineHeight: !0,
			opacity: !0,
			order: !0,
			orphans: !0,
			widows: !0,
			zIndex: !0,
			zoom: !0
		},
		cssProps: {
			float: ne.cssFloat ? "cssFloat" : "styleFloat"
		},
		style: function(e, t, n, i) {
			if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
				var o, r, s, a = oe.camelCase(t),
					l = e.style;
				if (t = oe.cssProps[a] || (oe.cssProps[a] = $(l, a)), s = oe.cssHooks[t] || oe.cssHooks[a], void 0 === n) return s && "get" in s && void 0 !== (o = s.get(e, !1, i)) ? o : l[t];
				if (r = _typeof(n), "string" === r && (o = lt.exec(n)) && (n = (o[1] + 1) * o[2] + parseFloat(oe.css(e, t)), r = "number"), null != n && n === n && ("number" !== r || oe.cssNumber[a] || (n += "px"), ne.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (l[t] = "inherit"), !(s && "set" in s && void 0 === (n = s.set(e, n, i))))) try {
					l[t] = n
				} catch (e) {}
			}
		},
		css: function(e, t, n, i) {
			var o, r, s, a = oe.camelCase(t);
			return t = oe.cssProps[a] || (oe.cssProps[a] = $(e.style, a)), s = oe.cssHooks[t] || oe.cssHooks[a], s && "get" in s && (r = s.get(e, !0, n)), void 0 === r && (r = et(e, t, i)), "normal" === r && t in dt && (r = dt[t]), "" === n || n ? (o = parseFloat(r), !0 === n || oe.isNumeric(o) ? o || 0 : r) : r
		}
	}), oe.each(["height", "width"], function(e, t) {
		oe.cssHooks[t] = {
			get: function(e, n, i) {
				return n ? st.test(oe.css(e, "display")) && 0 === e.offsetWidth ? oe.swap(e, ct, function() {
					return P(e, t, i)
				}) : P(e, t, i) : void 0
			},
			set: function(e, n, i) {
				var o = i && Je(e);
				return M(e, n, i ? _(e, t, i, ne.boxSizing && "border-box" === oe.css(e, "boxSizing", !1, o), o) : 0)
			}
		}
	}), ne.opacity || (oe.cssHooks.opacity = {
		get: function(e, t) {
			return rt.test((t && e.currentStyle ? e.currentStyle.filter : e.style.filter) || "") ? .01 * parseFloat(RegExp.$1) + "" : t ? "1" : ""
		},
		set: function(e, t) {
			var n = e.style,
				i = e.currentStyle,
				o = oe.isNumeric(t) ? "alpha(opacity=" + 100 * t + ")" : "",
				r = i && i.filter || n.filter || "";
			n.zoom = 1, (t >= 1 || "" === t) && "" === oe.trim(r.replace(ot, "")) && n.removeAttribute && (n.removeAttribute("filter"), "" === t || i && !i.filter) || (n.filter = ot.test(r) ? r.replace(ot, o) : r + " " + o)
		}
	}), oe.cssHooks.marginRight = E(ne.reliableMarginRight, function(e, t) {
		return t ? oe.swap(e, {
			display: "inline-block"
		}, et, [e, "marginRight"]) : void 0
	}), oe.each({
		margin: "",
		padding: "",
		border: "Width"
	}, function(e, t) {
		oe.cssHooks[e + t] = {
			expand: function(n) {
				for (var i = 0, o = {}, r = "string" == typeof n ? n.split(" ") : [n]; 4 > i; i++) o[e + Ee[i] + t] = r[i] || r[i - 2] || r[0];
				return o
			}
		}, tt.test(e) || (oe.cssHooks[e + t].set = M)
	}), oe.fn.extend({
		css: function(e, t) {
			return Ae(this, function(e, t, n) {
				var i, o, r = {},
					s = 0;
				if (oe.isArray(t)) {
					for (i = Je(e), o = t.length; o > s; s++) r[t[s]] = oe.css(e, t[s], !1, i);
					return r
				}
				return void 0 !== n ? oe.style(e, t, n) : oe.css(e, t)
			}, e, t, arguments.length > 1)
		},
		show: function() {
			return A(this, !0)
		},
		hide: function() {
			return A(this)
		},
		toggle: function(e) {
			return "boolean" == typeof e ? e ? this.show() : this.hide() : this.each(function() {
				$e(this) ? oe(this).show() : oe(this).hide()
			})
		}
	}), oe.Tween = N, N.prototype = {
		constructor: N,
		init: function(e, t, n, i, o, r) {
			this.elem = e, this.prop = n, this.easing = o || "swing", this.options = t, this.start = this.now = this.cur(), this.end = i, this.unit = r || (oe.cssNumber[n] ? "" : "px")
		},
		cur: function() {
			var e = N.propHooks[this.prop];
			return e && e.get ? e.get(this) : N.propHooks._default.get(this)
		},
		run: function(e) {
			var t, n = N.propHooks[this.prop];
			return this.pos = t = this.options.duration ? oe.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration) : e, this.now = (this.end - this.start) * t + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), n && n.set ? n.set(this) : N.propHooks._default.set(this), this
		}
	}, N.prototype.init.prototype = N.prototype, N.propHooks = {
		_default: {
			get: function(e) {
				var t;
				return null == e.elem[e.prop] || e.elem.style && null != e.elem.style[e.prop] ? (t = oe.css(e.elem, e.prop, ""), t && "auto" !== t ? t : 0) : e.elem[e.prop]
			},
			set: function(e) {
				oe.fx.step[e.prop] ? oe.fx.step[e.prop](e) : e.elem.style && (null != e.elem.style[oe.cssProps[e.prop]] || oe.cssHooks[e.prop]) ? oe.style(e.elem, e.prop, e.now + e.unit) : e.elem[e.prop] = e.now
			}
		}
	}, N.propHooks.scrollTop = N.propHooks.scrollLeft = {
		set: function(e) {
			e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now)
		}
	}, oe.easing = {
		linear: function(e) {
			return e
		},
		swing: function(e) {
			return .5 - Math.cos(e * Math.PI) / 2
		}
	}, oe.fx = N.prototype.init, oe.fx.step = {};
	var pt, ft, ht = /^(?:toggle|show|hide)$/,
		mt = new RegExp("^(?:([+-])=|)(" + Ce + ")([a-z%]*)$", "i"),
		gt = /queueHooks$/,
		vt = [D],
		yt = {
			"*": [function(e, t) {
				var n = this.createTween(e, t),
					i = n.cur(),
					o = mt.exec(t),
					r = o && o[3] || (oe.cssNumber[e] ? "" : "px"),
					s = (oe.cssNumber[e] || "px" !== r && +i) && mt.exec(oe.css(n.elem, e)),
					a = 1,
					l = 20;
				if (s && s[3] !== r) {
					r = r || s[3], o = o || [], s = +i || 1;
					do {
						a = a || ".5", s /= a, oe.style(n.elem, e, s + r)
					} while (a !== (a = n.cur() / i) && 1 !== a && --l)
				}
				return o && (s = n.start = +s || +i || 0, n.unit = r, n.end = o[1] ? s + (o[1] + 1) * o[2] : +o[2]), n
			}]
		};
	oe.Animation = oe.extend(I, {
			tweener: function(e, t) {
				oe.isFunction(e) ? (t = e, e = ["*"]) : e = e.split(" ");
				for (var n, i = 0, o = e.length; o > i; i++) n = e[i], yt[n] = yt[n] || [], yt[n].unshift(t)
			},
			prefilter: function(e, t) {
				t ? vt.unshift(e) : vt.push(e)
			}
		}), oe.speed = function(e, t, n) {
			var i = e && "object" == _typeof(e) ? oe.extend({}, e) : {
				complete: n || !n && t || oe.isFunction(e) && e,
				duration: e,
				easing: n && t || t && !oe.isFunction(t) && t
			};
			return i.duration = oe.fx.off ? 0 : "number" == typeof i.duration ? i.duration : i.duration in oe.fx.speeds ? oe.fx.speeds[i.duration] : oe.fx.speeds._default, (null == i.queue || !0 === i.queue) && (i.queue = "fx"), i.old = i.complete, i.complete = function() {
				oe.isFunction(i.old) && i.old.call(this), i.queue && oe.dequeue(this, i.queue)
			}, i
		}, oe.fn.extend({
			fadeTo: function(e, t, n, i) {
				return this.filter($e).css("opacity", 0).show().end().animate({
					opacity: t
				}, e, n, i)
			},
			animate: function(e, t, n, i) {
				var o = oe.isEmptyObject(e),
					r = oe.speed(t, n, i),
					s = function() {
						var t = I(this, oe.extend({}, e), r);
						(o || oe._data(this, "finish")) && t.stop(!0)
					};
				return s.finish = s, o || !1 === r.queue ? this.each(s) : this.queue(r.queue, s)
			},
			stop: function(e, t, n) {
				var i = function(e) {
					var t = e.stop;
					delete e.stop, t(n)
				};
				return "string" != typeof e && (n = t, t = e, e = void 0), t && !1 !== e && this.queue(e || "fx", []), this.each(function() {
					var t = !0,
						o = null != e && e + "queueHooks",
						r = oe.timers,
						s = oe._data(this);
					if (o) s[o] && s[o].stop && i(s[o]);
					else
						for (o in s) s[o] && s[o].stop && gt.test(o) && i(s[o]);
					for (o = r.length; o--;) r[o].elem !== this || null != e && r[o].queue !== e || (r[o].anim.stop(n), t = !1, r.splice(o, 1));
					(t || !n) && oe.dequeue(this, e)
				})
			},
			finish: function(e) {
				return !1 !== e && (e = e || "fx"), this.each(function() {
					var t, n = oe._data(this),
						i = n[e + "queue"],
						o = n[e + "queueHooks"],
						r = oe.timers,
						s = i ? i.length : 0;
					for (n.finish = !0, oe.queue(this, e, []), o && o.stop && o.stop.call(this, !0), t = r.length; t--;) r[t].elem === this && r[t].queue === e && (r[t].anim.stop(!0), r.splice(t, 1));
					for (t = 0; s > t; t++) i[t] && i[t].finish && i[t].finish.call(this);
					delete n.finish
				})
			}
		}), oe.each(["toggle", "show", "hide"], function(e, t) {
			var n = oe.fn[t];
			oe.fn[t] = function(e, i, o) {
				return null == e || "boolean" == typeof e ? n.apply(this, arguments) : this.animate(O(t, !0), e, i, o)
			}
		}), oe.each({
			slideDown: O("show"),
			slideUp: O("hide"),
			slideToggle: O("toggle"),
			fadeIn: {
				opacity: "show"
			},
			fadeOut: {
				opacity: "hide"
			},
			fadeToggle: {
				opacity: "toggle"
			}
		}, function(e, t) {
			oe.fn[e] = function(e, n, i) {
				return this.animate(t, e, n, i)
			}
		}), oe.timers = [], oe.fx.tick = function() {
			var e, t = oe.timers,
				n = 0;
			for (pt = oe.now(); n < t.length; n++)(e = t[n])() || t[n] !== e || t.splice(n--, 1);
			t.length || oe.fx.stop(), pt = void 0
		}, oe.fx.timer = function(e) {
			oe.timers.push(e), e() ? oe.fx.start() : oe.timers.pop()
		}, oe.fx.interval = 13, oe.fx.start = function() {
			ft || (ft = setInterval(oe.fx.tick, oe.fx.interval))
		}, oe.fx.stop = function() {
			clearInterval(ft), ft = null
		}, oe.fx.speeds = {
			slow: 600,
			fast: 200,
			_default: 400
		}, oe.fn.delay = function(e, t) {
			return e = oe.fx ? oe.fx.speeds[e] || e : e, t = t || "fx", this.queue(t, function(t, n) {
				var i = setTimeout(t, e);
				n.stop = function() {
					clearTimeout(i)
				}
			})
		},
		function() {
			var e, t, n, i, o;
			t = he.createElement("div"), t.setAttribute("className", "t"), t.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>", i = t.getElementsByTagName("a")[0], n = he.createElement("select"), o = n.appendChild(he.createElement("option")), e = t.getElementsByTagName("input")[0], i.style.cssText = "top:1px", ne.getSetAttribute = "t" !== t.className, ne.style = /top/.test(i.getAttribute("style")), ne.hrefNormalized = "/a" === i.getAttribute("href"), ne.checkOn = !!e.value, ne.optSelected = o.selected, ne.enctype = !!he.createElement("form").enctype, n.disabled = !0, ne.optDisabled = !o.disabled, e = he.createElement("input"), e.setAttribute("value", ""), ne.input = "" === e.getAttribute("value"), e.value = "t", e.setAttribute("type", "radio"), ne.radioValue = "t" === e.value
		}();
	var wt = /\r/g;
	oe.fn.extend({
		val: function(e) {
			var t, n, i, o = this[0];
			return arguments.length ? (i = oe.isFunction(e), this.each(function(n) {
				var o;
				1 === this.nodeType && (o = i ? e.call(this, n, oe(this).val()) : e, null == o ? o = "" : "number" == typeof o ? o += "" : oe.isArray(o) && (o = oe.map(o, function(e) {
					return null == e ? "" : e + ""
				})), (t = oe.valHooks[this.type] || oe.valHooks[this.nodeName.toLowerCase()]) && "set" in t && void 0 !== t.set(this, o, "value") || (this.value = o))
			})) : o ? (t = oe.valHooks[o.type] || oe.valHooks[o.nodeName.toLowerCase()], t && "get" in t && void 0 !== (n = t.get(o, "value")) ? n : (n = o.value, "string" == typeof n ? n.replace(wt, "") : null == n ? "" : n)) : void 0
		}
	}), oe.extend({
		valHooks: {
			option: {
				get: function(e) {
					var t = oe.find.attr(e, "value");
					return null != t ? t : oe.trim(oe.text(e))
				}
			},
			select: {
				get: function(e) {
					for (var t, n, i = e.options, o = e.selectedIndex, r = "select-one" === e.type || 0 > o, s = r ? null : [], a = r ? o + 1 : i.length, l = 0 > o ? a : r ? o : 0; a > l; l++)
						if (n = i[l], !(!n.selected && l !== o || (ne.optDisabled ? n.disabled : null !== n.getAttribute("disabled")) || n.parentNode.disabled && oe.nodeName(n.parentNode, "optgroup"))) {
							if (t = oe(n).val(), r) return t;
							s.push(t)
						} return s
				},
				set: function(e, t) {
					for (var n, i, o = e.options, r = oe.makeArray(t), s = o.length; s--;)
						if (i = o[s], oe.inArray(oe.valHooks.option.get(i), r) >= 0) try {
							i.selected = n = !0
						} catch (e) {
							i.scrollHeight
						} else i.selected = !1;
					return n || (e.selectedIndex = -1), o
				}
			}
		}
	}), oe.each(["radio", "checkbox"], function() {
		oe.valHooks[this] = {
			set: function(e, t) {
				return oe.isArray(t) ? e.checked = oe.inArray(oe(e).val(), t) >= 0 : void 0
			}
		}, ne.checkOn || (oe.valHooks[this].get = function(e) {
			return null === e.getAttribute("value") ? "on" : e.value
		})
	});
	var bt, xt, Tt = oe.expr.attrHandle,
		kt = /^(?:checked|selected)$/i,
		St = ne.getSetAttribute,
		Ct = ne.input;
	oe.fn.extend({
		attr: function(e, t) {
			return Ae(this, oe.attr, e, t, arguments.length > 1)
		},
		removeAttr: function(e) {
			return this.each(function() {
				oe.removeAttr(this, e)
			})
		}
	}), oe.extend({
		attr: function(e, t, n) {
			var i, o, r = e.nodeType;
			if (e && 3 !== r && 8 !== r && 2 !== r) return _typeof(e.getAttribute) === Te ? oe.prop(e, t, n) : (1 === r && oe.isXMLDoc(e) || (t = t.toLowerCase(), i = oe.attrHooks[t] || (oe.expr.match.bool.test(t) ? xt : bt)), void 0 === n ? i && "get" in i && null !== (o = i.get(e, t)) ? o : (o = oe.find.attr(e, t), null == o ? void 0 : o) : null !== n ? i && "set" in i && void 0 !== (o = i.set(e, n, t)) ? o : (e.setAttribute(t, n + ""), n) : void oe.removeAttr(e, t))
		},
		removeAttr: function(e, t) {
			var n, i, o = 0,
				r = t && t.match(ye);
			if (r && 1 === e.nodeType)
				for (; n = r[o++];) i = oe.propFix[n] || n, oe.expr.match.bool.test(n) ? Ct && St || !kt.test(n) ? e[i] = !1 : e[oe.camelCase("default-" + n)] = e[i] = !1 : oe.attr(e, n, ""), e.removeAttribute(St ? n : i)
		},
		attrHooks: {
			type: {
				set: function(e, t) {
					if (!ne.radioValue && "radio" === t && oe.nodeName(e, "input")) {
						var n = e.value;
						return e.setAttribute("type", t), n && (e.value = n), t
					}
				}
			}
		}
	}), xt = {
		set: function(e, t, n) {
			return !1 === t ? oe.removeAttr(e, n) : Ct && St || !kt.test(n) ? e.setAttribute(!St && oe.propFix[n] || n, n) : e[oe.camelCase("default-" + n)] = e[n] = !0, n
		}
	}, oe.each(oe.expr.match.bool.source.match(/\w+/g), function(e, t) {
		var n = Tt[t] || oe.find.attr;
		Tt[t] = Ct && St || !kt.test(t) ? function(e, t, i) {
			var o, r;
			return i || (r = Tt[t], Tt[t] = o, o = null != n(e, t, i) ? t.toLowerCase() : null, Tt[t] = r), o
		} : function(e, t, n) {
			return n ? void 0 : e[oe.camelCase("default-" + t)] ? t.toLowerCase() : null
		}
	}), Ct && St || (oe.attrHooks.value = {
		set: function(e, t, n) {
			return oe.nodeName(e, "input") ? void(e.defaultValue = t) : bt && bt.set(e, t, n)
		}
	}), St || (bt = {
		set: function(e, t, n) {
			var i = e.getAttributeNode(n);
			return i || e.setAttributeNode(i = e.ownerDocument.createAttribute(n)), i.value = t += "", "value" === n || t === e.getAttribute(n) ? t : void 0
		}
	}, Tt.id = Tt.name = Tt.coords = function(e, t, n) {
		var i;
		return n ? void 0 : (i = e.getAttributeNode(t)) && "" !== i.value ? i.value : null
	}, oe.valHooks.button = {
		get: function(e, t) {
			var n = e.getAttributeNode(t);
			return n && n.specified ? n.value : void 0
		},
		set: bt.set
	}, oe.attrHooks.contenteditable = {
		set: function(e, t, n) {
			bt.set(e, "" !== t && t, n)
		}
	}, oe.each(["width", "height"], function(e, t) {
		oe.attrHooks[t] = {
			set: function(e, n) {
				return "" === n ? (e.setAttribute(t, "auto"), n) : void 0
			}
		}
	})), ne.style || (oe.attrHooks.style = {
		get: function(e) {
			return e.style.cssText || void 0
		},
		set: function(e, t) {
			return e.style.cssText = t + ""
		}
	});
	var Et = /^(?:input|select|textarea|button|object)$/i,
		$t = /^(?:a|area)$/i;
	oe.fn.extend({
		prop: function(e, t) {
			return Ae(this, oe.prop, e, t, arguments.length > 1)
		},
		removeProp: function(e) {
			return e = oe.propFix[e] || e, this.each(function() {
				try {
					this[e] = void 0, delete this[e]
				} catch (e) {}
			})
		}
	}), oe.extend({
		propFix: {
			for: "htmlFor",
			class: "className"
		},
		prop: function(e, t, n) {
			var i, o, r, s = e.nodeType;
			if (e && 3 !== s && 8 !== s && 2 !== s) return r = 1 !== s || !oe.isXMLDoc(e), r && (t = oe.propFix[t] || t, o = oe.propHooks[t]), void 0 !== n ? o && "set" in o && void 0 !== (i = o.set(e, n, t)) ? i : e[t] = n : o && "get" in o && null !== (i = o.get(e, t)) ? i : e[t]
		},
		propHooks: {
			tabIndex: {
				get: function(e) {
					var t = oe.find.attr(e, "tabindex");
					return t ? parseInt(t, 10) : Et.test(e.nodeName) || $t.test(e.nodeName) && e.href ? 0 : -1
				}
			}
		}
	}), ne.hrefNormalized || oe.each(["href", "src"], function(e, t) {
		oe.propHooks[t] = {
			get: function(e) {
				return e.getAttribute(t, 4)
			}
		}
	}), ne.optSelected || (oe.propHooks.selected = {
		get: function(e) {
			var t = e.parentNode;
			return t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex), null
		}
	}), oe.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() {
		oe.propFix[this.toLowerCase()] = this
	}), ne.enctype || (oe.propFix.enctype = "encoding");
	var At = /[\t\r\n\f]/g;
	oe.fn.extend({
		addClass: function(e) {
			var t, n, i, o, r, s, a = 0,
				l = this.length,
				c = "string" == typeof e && e;
			if (oe.isFunction(e)) return this.each(function(t) {
				oe(this).addClass(e.call(this, t, this.className))
			});
			if (c)
				for (t = (e || "").match(ye) || []; l > a; a++)
					if (n = this[a], i = 1 === n.nodeType && (n.className ? (" " + n.className + " ").replace(At, " ") : " ")) {
						for (r = 0; o = t[r++];) i.indexOf(" " + o + " ") < 0 && (i += o + " ");
						s = oe.trim(i), n.className !== s && (n.className = s)
					} return this
		},
		removeClass: function(e) {
			var t, n, i, o, r, s, a = 0,
				l = this.length,
				c = 0 === arguments.length || "string" == typeof e && e;
			if (oe.isFunction(e)) return this.each(function(t) {
				oe(this).removeClass(e.call(this, t, this.className))
			});
			if (c)
				for (t = (e || "").match(ye) || []; l > a; a++)
					if (n = this[a], i = 1 === n.nodeType && (n.className ? (" " + n.className + " ").replace(At, " ") : "")) {
						for (r = 0; o = t[r++];)
							for (; i.indexOf(" " + o + " ") >= 0;) i = i.replace(" " + o + " ", " ");
						s = e ? oe.trim(i) : "", n.className !== s && (n.className = s)
					} return this
		},
		toggleClass: function(e, t) {
			var n = _typeof(e);
			return "boolean" == typeof t && "string" === n ? t ? this.addClass(e) : this.removeClass(e) : this.each(oe.isFunction(e) ? function(n) {
				oe(this).toggleClass(e.call(this, n, this.className, t), t)
			} : function() {
				if ("string" === n)
					for (var t, i = 0, o = oe(this), r = e.match(ye) || []; t = r[i++];) o.hasClass(t) ? o.removeClass(t) : o.addClass(t);
				else(n === Te || "boolean" === n) && (this.className && oe._data(this, "__className__", this.className), this.className = this.className || !1 === e ? "" : oe._data(this, "__className__") || "")
			})
		},
		hasClass: function(e) {
			for (var t = " " + e + " ", n = 0, i = this.length; i > n; n++)
				if (1 === this[n].nodeType && (" " + this[n].className + " ").replace(At, " ").indexOf(t) >= 0) return !0;
			return !1
		}
	}), oe.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "), function(e, t) {
		oe.fn[t] = function(e, n) {
			return arguments.length > 0 ? this.on(t, null, e, n) : this.trigger(t)
		}
	}), oe.fn.extend({
		hover: function(e, t) {
			return this.mouseenter(e).mouseleave(t || e)
		},
		bind: function(e, t, n) {
			return this.on(e, null, t, n)
		},
		unbind: function(e, t) {
			return this.off(e, null, t)
		},
		delegate: function(e, t, n, i) {
			return this.on(t, e, n, i)
		},
		undelegate: function(e, t, n) {
			return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n)
		}
	});
	var Mt = oe.now(),
		_t = /\?/,
		Pt = /(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g;
	oe.parseJSON = function(t) {
		if (e.JSON && e.JSON.parse) return e.JSON.parse(t + "");
		var n, i = null,
			o = oe.trim(t + "");
		return o && !oe.trim(o.replace(Pt, function(e, t, o, r) {
			return n && t && (i = 0), 0 === i ? e : (n = o || t, i += !r - !o, "")
		})) ? Function("return " + o)() : oe.error("Invalid JSON: " + t)
	}, oe.parseXML = function(t) {
		var n, i;
		if (!t || "string" != typeof t) return null;
		try {
			e.DOMParser ? (i = new DOMParser, n = i.parseFromString(t, "text/xml")) : (n = new ActiveXObject("Microsoft.XMLDOM"), n.async = "false", n.loadXML(t))
		} catch (e) {
			n = void 0
		}
		return n && n.documentElement && !n.getElementsByTagName("parsererror").length || oe.error("Invalid XML: " + t), n
	};
	var Nt, Lt, Ot = /#.*$/,
		Ht = /([?&])_=[^&]*/,
		Dt = /^(.*?):[ \t]*([^\r\n]*)\r?$/gm,
		jt = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		It = /^(?:GET|HEAD)$/,
		zt = /^\/\//,
		Ft = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,
		qt = {},
		Bt = {},
		Rt = "*/".concat("*");
	try {
		Lt = location.href
	} catch (e) {
		Lt = he.createElement("a"), Lt.href = "", Lt = Lt.href
	}
	Nt = Ft.exec(Lt.toLowerCase()) || [], oe.extend({
		active: 0,
		lastModified: {},
		etag: {},
		ajaxSettings: {
			url: Lt,
			type: "GET",
			isLocal: jt.test(Nt[1]),
			global: !0,
			processData: !0,
			async: !0,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
			accepts: {
				"*": Rt,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
			contents: {
				xml: /xml/,
				html: /html/,
				json: /json/
			},
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
			converters: {
				"* text": String,
				"text html": !0,
				"text json": oe.parseJSON,
				"text xml": oe.parseXML
			},
			flatOptions: {
				url: !0,
				context: !0
			}
		},
		ajaxSetup: function(e, t) {
			return t ? q(q(e, oe.ajaxSettings), t) : q(oe.ajaxSettings, e)
		},
		ajaxPrefilter: z(qt),
		ajaxTransport: z(Bt),
		ajax: function(e, t) {
			function n(e, t, n, i) {
				var o, d, v, y, b, T = t;
				2 !== w && (w = 2, a && clearTimeout(a), c = void 0, s = i || "", x.readyState = e > 0 ? 4 : 0, o = e >= 200 && 300 > e || 304 === e, n && (y = B(u, x, n)), y = R(u, y, x, o), o ? (u.ifModified && (b = x.getResponseHeader("Last-Modified"), b && (oe.lastModified[r] = b), (b = x.getResponseHeader("etag")) && (oe.etag[r] = b)), 204 === e || "HEAD" === u.type ? T = "nocontent" : 304 === e ? T = "notmodified" : (T = y.state, d = y.data, v = y.error, o = !v)) : (v = T, (e || !T) && (T = "error", 0 > e && (e = 0))), x.status = e, x.statusText = (t || T) + "", o ? h.resolveWith(p, [d, T, x]) : h.rejectWith(p, [x, T, v]), x.statusCode(g), g = void 0, l && f.trigger(o ? "ajaxSuccess" : "ajaxError", [x, u, o ? d : v]), m.fireWith(p, [x, T]), l && (f.trigger("ajaxComplete", [x, u]), --oe.active || oe.event.trigger("ajaxStop")))
			}
			"object" == _typeof(e) && (t = e, e = void 0), t = t || {};
			var i, o, r, s, a, l, c, d, u = oe.ajaxSetup({}, t),
				p = u.context || u,
				f = u.context && (p.nodeType || p.jquery) ? oe(p) : oe.event,
				h = oe.Deferred(),
				m = oe.Callbacks("once memory"),
				g = u.statusCode || {},
				v = {},
				y = {},
				w = 0,
				b = "canceled",
				x = {
					readyState: 0,
					getResponseHeader: function(e) {
						var t;
						if (2 === w) {
							if (!d)
								for (d = {}; t = Dt.exec(s);) d[t[1].toLowerCase()] = t[2];
							t = d[e.toLowerCase()]
						}
						return null == t ? null : t
					},
					getAllResponseHeaders: function() {
						return 2 === w ? s : null
					},
					setRequestHeader: function(e, t) {
						var n = e.toLowerCase();
						return w || (e = y[n] = y[n] || e, v[e] = t), this
					},
					overrideMimeType: function(e) {
						return w || (u.mimeType = e), this
					},
					statusCode: function(e) {
						var t;
						if (e)
							if (2 > w)
								for (t in e) g[t] = [g[t], e[t]];
							else x.always(e[x.status]);
						return this
					},
					abort: function(e) {
						var t = e || b;
						return c && c.abort(t), n(0, t), this
					}
				};
			if (h.promise(x).complete = m.add, x.success = x.done, x.error = x.fail, u.url = ((e || u.url || Lt) + "").replace(Ot, "").replace(zt, Nt[1] + "//"), u.type = t.method || t.type || u.method || u.type, u.dataTypes = oe.trim(u.dataType || "*").toLowerCase().match(ye) || [""], null == u.crossDomain && (i = Ft.exec(u.url.toLowerCase()), u.crossDomain = !(!i || i[1] === Nt[1] && i[2] === Nt[2] && (i[3] || ("http:" === i[1] ? "80" : "443")) === (Nt[3] || ("http:" === Nt[1] ? "80" : "443")))), u.data && u.processData && "string" != typeof u.data && (u.data = oe.param(u.data, u.traditional)), F(qt, u, t, x), 2 === w) return x;
			l = oe.event && u.global, l && 0 == oe.active++ && oe.event.trigger("ajaxStart"), u.type = u.type.toUpperCase(), u.hasContent = !It.test(u.type), r = u.url, u.hasContent || (u.data && (r = u.url += (_t.test(r) ? "&" : "?") + u.data, delete u.data), !1 === u.cache && (u.url = Ht.test(r) ? r.replace(Ht, "$1_=" + Mt++) : r + (_t.test(r) ? "&" : "?") + "_=" + Mt++)), u.ifModified && (oe.lastModified[r] && x.setRequestHeader("If-Modified-Since", oe.lastModified[r]), oe.etag[r] && x.setRequestHeader("If-None-Match", oe.etag[r])), (u.data && u.hasContent && !1 !== u.contentType || t.contentType) && x.setRequestHeader("Content-Type", u.contentType), x.setRequestHeader("Accept", u.dataTypes[0] && u.accepts[u.dataTypes[0]] ? u.accepts[u.dataTypes[0]] + ("*" !== u.dataTypes[0] ? ", " + Rt + "; q=0.01" : "") : u.accepts["*"]);
			for (o in u.headers) x.setRequestHeader(o, u.headers[o]);
			if (u.beforeSend && (!1 === u.beforeSend.call(p, x, u) || 2 === w)) return x.abort();
			b = "abort";
			for (o in {
					success: 1,
					error: 1,
					complete: 1
				}) x[o](u[o]);
			if (c = F(Bt, u, t, x)) {
				x.readyState = 1, l && f.trigger("ajaxSend", [x, u]), u.async && u.timeout > 0 && (a = setTimeout(function() {
					x.abort("timeout")
				}, u.timeout));
				try {
					w = 1, c.send(v, n)
				} catch (e) {
					if (!(2 > w)) throw e;
					n(-1, e)
				}
			} else n(-1, "No Transport");
			return x
		},
		getJSON: function(e, t, n) {
			return oe.get(e, t, n, "json")
		},
		getScript: function(e, t) {
			return oe.get(e, void 0, t, "script")
		}
	}), oe.each(["get", "post"], function(e, t) {
		oe[t] = function(e, n, i, o) {
			return oe.isFunction(n) && (o = o || i, i = n, n = void 0), oe.ajax({
				url: e,
				type: t,
				dataType: o,
				data: n,
				success: i
			})
		}
	}), oe._evalUrl = function(e) {
		return oe.ajax({
			url: e,
			type: "GET",
			dataType: "script",
			async: !1,
			global: !1,
			throws: !0
		})
	}, oe.fn.extend({
		wrapAll: function(e) {
			if (oe.isFunction(e)) return this.each(function(t) {
				oe(this).wrapAll(e.call(this, t))
			});
			if (this[0]) {
				var t = oe(e, this[0].ownerDocument).eq(0).clone(!0);
				this[0].parentNode && t.insertBefore(this[0]), t.map(function() {
					for (var e = this; e.firstChild && 1 === e.firstChild.nodeType;) e = e.firstChild;
					return e
				}).append(this)
			}
			return this
		},
		wrapInner: function(e) {
			return this.each(oe.isFunction(e) ? function(t) {
				oe(this).wrapInner(e.call(this, t))
			} : function() {
				var t = oe(this),
					n = t.contents();
				n.length ? n.wrapAll(e) : t.append(e)
			})
		},
		wrap: function(e) {
			var t = oe.isFunction(e);
			return this.each(function(n) {
				oe(this).wrapAll(t ? e.call(this, n) : e)
			})
		},
		unwrap: function() {
			return this.parent().each(function() {
				oe.nodeName(this, "body") || oe(this).replaceWith(this.childNodes)
			}).end()
		}
	}), oe.expr.filters.hidden = function(e) {
		return e.offsetWidth <= 0 && e.offsetHeight <= 0 || !ne.reliableHiddenOffsets() && "none" === (e.style && e.style.display || oe.css(e, "display"))
	}, oe.expr.filters.visible = function(e) {
		return !oe.expr.filters.hidden(e)
	};
	var Wt = /%20/g,
		Ut = /\[\]$/,
		Xt = /\r?\n/g,
		Vt = /^(?:submit|button|image|reset|file)$/i,
		Yt = /^(?:input|select|textarea|keygen)/i;
	oe.param = function(e, t) {
		var n, i = [],
			o = function(e, t) {
				t = oe.isFunction(t) ? t() : null == t ? "" : t, i[i.length] = encodeURIComponent(e) + "=" + encodeURIComponent(t)
			};
		if (void 0 === t && (t = oe.ajaxSettings && oe.ajaxSettings.traditional), oe.isArray(e) || e.jquery && !oe.isPlainObject(e)) oe.each(e, function() {
			o(this.name, this.value)
		});
		else
			for (n in e) W(n, e[n], t, o);
		return i.join("&").replace(Wt, "+")
	}, oe.fn.extend({
		serialize: function() {
			return oe.param(this.serializeArray())
		},
		serializeArray: function() {
			return this.map(function() {
				var e = oe.prop(this, "elements");
				return e ? oe.makeArray(e) : this
			}).filter(function() {
				var e = this.type;
				return this.name && !oe(this).is(":disabled") && Yt.test(this.nodeName) && !Vt.test(e) && (this.checked || !Me.test(e))
			}).map(function(e, t) {
				var n = oe(this).val();
				return null == n ? null : oe.isArray(n) ? oe.map(n, function(e) {
					return {
						name: t.name,
						value: e.replace(Xt, "\r\n")
					}
				}) : {
					name: t.name,
					value: n.replace(Xt, "\r\n")
				}
			}).get()
		}
	}), oe.ajaxSettings.xhr = void 0 !== e.ActiveXObject ? function() {
		return !this.isLocal && /^(get|post|head|put|delete|options)$/i.test(this.type) && U() || X()
	} : U;
	var Gt = 0,
		Kt = {},
		Qt = oe.ajaxSettings.xhr();
	e.attachEvent && e.attachEvent("onunload", function() {
		for (var e in Kt) Kt[e](void 0, !0)
	}), ne.cors = !!Qt && "withCredentials" in Qt, (Qt = ne.ajax = !!Qt) && oe.ajaxTransport(function(e) {
		if (!e.crossDomain || ne.cors) {
			var t;
			return {
				send: function(n, i) {
					var o, r = e.xhr(),
						s = ++Gt;
					if (r.open(e.type, e.url, e.async, e.username, e.password), e.xhrFields)
						for (o in e.xhrFields) r[o] = e.xhrFields[o];
					e.mimeType && r.overrideMimeType && r.overrideMimeType(e.mimeType), e.crossDomain || n["X-Requested-With"] || (n["X-Requested-With"] = "XMLHttpRequest");
					for (o in n) void 0 !== n[o] && r.setRequestHeader(o, n[o] + "");
					r.send(e.hasContent && e.data || null), t = function(n, o) {
						var a, l, c;
						if (t && (o || 4 === r.readyState))
							if (delete Kt[s], t = void 0, r.onreadystatechange = oe.noop, o) 4 !== r.readyState && r.abort();
							else {
								c = {}, a = r.status, "string" == typeof r.responseText && (c.text = r.responseText);
								try {
									l = r.statusText
								} catch (e) {
									l = ""
								}
								a || !e.isLocal || e.crossDomain ? 1223 === a && (a = 204) : a = c.text ? 200 : 404
							} c && i(a, l, c, r.getAllResponseHeaders())
					}, e.async ? 4 === r.readyState ? setTimeout(t) : r.onreadystatechange = Kt[s] = t : t()
				},
				abort: function() {
					t && t(void 0, !0)
				}
			}
		}
	}), oe.ajaxSetup({
		accepts: {
			script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /(?:java|ecma)script/
		},
		converters: {
			"text script": function(e) {
				return oe.globalEval(e), e
			}
		}
	}), oe.ajaxPrefilter("script", function(e) {
		void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET", e.global = !1)
	}), oe.ajaxTransport("script", function(e) {
		if (e.crossDomain) {
			var t, n = he.head || oe("head")[0] || he.documentElement;
			return {
				send: function(i, o) {
					t = he.createElement("script"), t.async = !0, e.scriptCharset && (t.charset = e.scriptCharset), t.src = e.url, t.onload = t.onreadystatechange = function(e, n) {
						(n || !t.readyState || /loaded|complete/.test(t.readyState)) && (t.onload = t.onreadystatechange = null, t.parentNode && t.parentNode.removeChild(t), t = null, n || o(200, "success"))
					}, n.insertBefore(t, n.firstChild)
				},
				abort: function() {
					t && t.onload(void 0, !0)
				}
			}
		}
	});
	var Zt = [],
		Jt = /(=)\?(?=&|$)|\?\?/;
	oe.ajaxSetup({
		jsonp: "callback",
		jsonpCallback: function() {
			var e = Zt.pop() || oe.expando + "_" + Mt++;
			return this[e] = !0, e
		}
	}), oe.ajaxPrefilter("json jsonp", function(t, n, i) {
		var o, r, s, a = !1 !== t.jsonp && (Jt.test(t.url) ? "url" : "string" == typeof t.data && !(t.contentType || "").indexOf("application/x-www-form-urlencoded") && Jt.test(t.data) && "data");
		return a || "jsonp" === t.dataTypes[0] ? (o = t.jsonpCallback = oe.isFunction(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback, a ? t[a] = t[a].replace(Jt, "$1" + o) : !1 !== t.jsonp && (t.url += (_t.test(t.url) ? "&" : "?") + t.jsonp + "=" + o), t.converters["script json"] = function() {
			return s || oe.error(o + " was not called"), s[0]
		}, t.dataTypes[0] = "json", r = e[o], e[o] = function() {
			s = arguments
		}, i.always(function() {
			e[o] = r, t[o] && (t.jsonpCallback = n.jsonpCallback, Zt.push(o)), s && oe.isFunction(r) && r(s[0]), s = r = void 0
		}), "script") : void 0
	}), oe.parseHTML = function(e, t, n) {
		if (!e || "string" != typeof e) return null;
		"boolean" == typeof t && (n = t, t = !1), t = t || he;
		var i = ue.exec(e),
			o = !n && [];
		return i ? [t.createElement(i[1])] : (i = oe.buildFragment([e], t, o), o && o.length && oe(o).remove(), oe.merge([], i.childNodes))
	};
	var en = oe.fn.load;
	oe.fn.load = function(e, t, n) {
		if ("string" != typeof e && en) return en.apply(this, arguments);
		var i, o, r, s = this,
			a = e.indexOf(" ");
		return a >= 0 && (i = oe.trim(e.slice(a, e.length)), e = e.slice(0, a)), oe.isFunction(t) ? (n = t, t = void 0) : t && "object" == _typeof(t) && (r = "POST"), s.length > 0 && oe.ajax({
			url: e,
			type: r,
			dataType: "html",
			data: t
		}).done(function(e) {
			o = arguments, s.html(i ? oe("<div>").append(oe.parseHTML(e)).find(i) : e)
		}).complete(n && function(e, t) {
			s.each(n, o || [e.responseText, t, e])
		}), this
	}, oe.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(e, t) {
		oe.fn[t] = function(e) {
			return this.on(t, e)
		}
	}), oe.expr.filters.animated = function(e) {
		return oe.grep(oe.timers, function(t) {
			return e === t.elem
		}).length
	};
	var tn = e.document.documentElement;
	oe.offset = {
		setOffset: function(e, t, n) {
			var i, o, r, s, a, l, c, d = oe.css(e, "position"),
				u = oe(e),
				p = {};
			"static" === d && (e.style.position = "relative"), a = u.offset(), r = oe.css(e, "top"),
				l = oe.css(e, "left"), c = ("absolute" === d || "fixed" === d) && oe.inArray("auto", [r, l]) > -1, c ? (i = u.position(), s = i.top, o = i.left) : (s = parseFloat(r) || 0, o = parseFloat(l) || 0), oe.isFunction(t) && (t = t.call(e, n, a)), null != t.top && (p.top = t.top - a.top + s), null != t.left && (p.left = t.left - a.left + o), "using" in t ? t.using.call(e, p) : u.css(p)
		}
	}, oe.fn.extend({
		offset: function(e) {
			if (arguments.length) return void 0 === e ? this : this.each(function(t) {
				oe.offset.setOffset(this, e, t)
			});
			var t, n, i = {
					top: 0,
					left: 0
				},
				o = this[0],
				r = o && o.ownerDocument;
			return r ? (t = r.documentElement, oe.contains(t, o) ? (_typeof(o.getBoundingClientRect) !== Te && (i = o.getBoundingClientRect()), n = V(r), {
				top: i.top + (n.pageYOffset || t.scrollTop) - (t.clientTop || 0),
				left: i.left + (n.pageXOffset || t.scrollLeft) - (t.clientLeft || 0)
			}) : i) : void 0
		},
		position: function() {
			if (this[0]) {
				var e, t, n = {
						top: 0,
						left: 0
					},
					i = this[0];
				return "fixed" === oe.css(i, "position") ? t = i.getBoundingClientRect() : (e = this.offsetParent(), t = this.offset(), oe.nodeName(e[0], "html") || (n = e.offset()), n.top += oe.css(e[0], "borderTopWidth", !0), n.left += oe.css(e[0], "borderLeftWidth", !0)), {
					top: t.top - n.top - oe.css(i, "marginTop", !0),
					left: t.left - n.left - oe.css(i, "marginLeft", !0)
				}
			}
		},
		offsetParent: function() {
			return this.map(function() {
				for (var e = this.offsetParent || tn; e && !oe.nodeName(e, "html") && "static" === oe.css(e, "position");) e = e.offsetParent;
				return e || tn
			})
		}
	}), oe.each({
		scrollLeft: "pageXOffset",
		scrollTop: "pageYOffset"
	}, function(e, t) {
		var n = /Y/.test(t);
		oe.fn[e] = function(i) {
			return Ae(this, function(e, i, o) {
				var r = V(e);
				return void 0 === o ? r ? t in r ? r[t] : r.document.documentElement[i] : e[i] : void(r ? r.scrollTo(n ? oe(r).scrollLeft() : o, n ? o : oe(r).scrollTop()) : e[i] = o)
			}, e, i, arguments.length, null)
		}
	}), oe.each(["top", "left"], function(e, t) {
		oe.cssHooks[t] = E(ne.pixelPosition, function(e, n) {
			return n ? (n = et(e, t), nt.test(n) ? oe(e).position()[t] + "px" : n) : void 0
		})
	}), oe.each({
		Height: "height",
		Width: "width"
	}, function(e, t) {
		oe.each({
			padding: "inner" + e,
			content: t,
			"": "outer" + e
		}, function(n, i) {
			oe.fn[i] = function(i, o) {
				var r = arguments.length && (n || "boolean" != typeof i),
					s = n || (!0 === i || !0 === o ? "margin" : "border");
				return Ae(this, function(t, n, i) {
					var o;
					return oe.isWindow(t) ? t.document.documentElement["client" + e] : 9 === t.nodeType ? (o = t.documentElement, Math.max(t.body["scroll" + e], o["scroll" + e], t.body["offset" + e], o["offset" + e], o["client" + e])) : void 0 === i ? oe.css(t, n, s) : oe.style(t, n, i, s)
				}, t, r ? i : void 0, r, null)
			}
		})
	}), oe.fn.size = function() {
		return this.length
	}, oe.fn.andSelf = oe.fn.addBack, "function" == typeof define && define.amd && define("jquery", [], function() {
		return oe
	});
	var nn = e.jQuery,
		on = e.$;
	return oe.noConflict = function(t) {
		return e.$ === oe && (e.$ = on), t && e.jQuery === oe && (e.jQuery = nn), oe
	}, _typeof(t) === Te && (e.jQuery = e.$ = oe), oe
}),
function(e) {
	"function" == typeof define && define.amd ? define(["jquery"], e) : "undefined" != typeof exports ? module.exports = e(require("jquery")) : e(jQuery)
}(function(e) {
	var t = window.Slick || {};
	(t = function() {
		var t = 0;
		return function(n, i) {
			var o, r = this;
			r.defaults = {
				accessibility: !0,
				adaptiveHeight: !1,
				appendArrows: e(n),
				appendDots: e(n),
				arrows: !0,
				asNavFor: null,
				prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
				nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
				autoplay: !1,
				autoplaySpeed: 3e3,
				centerMode: !1,
				centerPadding: "50px",
				cssEase: "ease",
				customPaging: function(t, n) {
					return e('<button type="button" />').text(n + 1)
				},
				dots: !1,
				dotsClass: "slick-dots",
				draggable: !0,
				easing: "linear",
				edgeFriction: .35,
				fade: !1,
				focusOnSelect: !1,
				focusOnChange: !1,
				infinite: !0,
				initialSlide: 0,
				lazyLoad: "ondemand",
				mobileFirst: !1,
				pauseOnHover: !0,
				pauseOnFocus: !0,
				pauseOnDotsHover: !1,
				respondTo: "window",
				responsive: null,
				rows: 1,
				rtl: !1,
				slide: "",
				slidesPerRow: 1,
				slidesToShow: 1,
				slidesToScroll: 1,
				speed: 500,
				swipe: !0,
				swipeToSlide: !1,
				touchMove: !0,
				touchThreshold: 5,
				useCSS: !0,
				useTransform: !0,
				variableWidth: !1,
				vertical: !1,
				verticalSwiping: !1,
				waitForAnimate: !0,
				zIndex: 1e3
			}, r.initials = {
				animating: !1,
				dragging: !1,
				autoPlayTimer: null,
				currentDirection: 0,
				currentLeft: null,
				currentSlide: 0,
				direction: 1,
				$dots: null,
				listWidth: null,
				listHeight: null,
				loadIndex: 0,
				$nextArrow: null,
				$prevArrow: null,
				scrolling: !1,
				slideCount: null,
				slideWidth: null,
				$slideTrack: null,
				$slides: null,
				sliding: !1,
				slideOffset: 0,
				swipeLeft: null,
				swiping: !1,
				$list: null,
				touchObject: {},
				transformsEnabled: !1,
				unslicked: !1
			}, e.extend(r, r.initials), r.activeBreakpoint = null, r.animType = null, r.animProp = null, r.breakpoints = [], r.breakpointSettings = [], r.cssTransitions = !1, r.focussed = !1, r.interrupted = !1, r.hidden = "hidden", r.paused = !0, r.positionProp = null, r.respondTo = null, r.rowCount = 1, r.shouldClick = !0, r.$slider = e(n), r.$slidesCache = null, r.transformType = null, r.transitionType = null, r.visibilityChange = "visibilitychange", r.windowWidth = 0, r.windowTimer = null, o = e(n).data("slick") || {}, r.options = e.extend({}, r.defaults, i, o), r.currentSlide = r.options.initialSlide, r.originalSettings = r.options, void 0 !== document.mozHidden ? (r.hidden = "mozHidden", r.visibilityChange = "mozvisibilitychange") : void 0 !== document.webkitHidden && (r.hidden = "webkitHidden", r.visibilityChange = "webkitvisibilitychange"), r.autoPlay = e.proxy(r.autoPlay, r), r.autoPlayClear = e.proxy(r.autoPlayClear, r), r.autoPlayIterator = e.proxy(r.autoPlayIterator, r), r.changeSlide = e.proxy(r.changeSlide, r), r.clickHandler = e.proxy(r.clickHandler, r), r.selectHandler = e.proxy(r.selectHandler, r), r.setPosition = e.proxy(r.setPosition, r), r.swipeHandler = e.proxy(r.swipeHandler, r), r.dragHandler = e.proxy(r.dragHandler, r), r.keyHandler = e.proxy(r.keyHandler, r), r.instanceUid = t++, r.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/, r.registerBreakpoints(), r.init(!0)
		}
	}()).prototype.activateADA = function() {
		this.$slideTrack.find(".slick-active").attr({
			"aria-hidden": "false"
		}).find("a, input, button, select").attr({
			tabindex: "0"
		})
	}, t.prototype.addSlide = t.prototype.slickAdd = function(t, n, i) {
		var o = this;
		if ("boolean" == typeof n) i = n, n = null;
		else if (n < 0 || n >= o.slideCount) return !1;
		o.unload(), "number" == typeof n ? 0 === n && 0 === o.$slides.length ? e(t).appendTo(o.$slideTrack) : i ? e(t).insertBefore(o.$slides.eq(n)) : e(t).insertAfter(o.$slides.eq(n)) : !0 === i ? e(t).prependTo(o.$slideTrack) : e(t).appendTo(o.$slideTrack), o.$slides = o.$slideTrack.children(this.options.slide), o.$slideTrack.children(this.options.slide).detach(), o.$slideTrack.append(o.$slides), o.$slides.each(function(t, n) {
			e(n).attr("data-slick-index", t)
		}), o.$slidesCache = o.$slides, o.reinit()
	}, t.prototype.animateHeight = function() {
		var e = this;
		if (1 === e.options.slidesToShow && !0 === e.options.adaptiveHeight && !1 === e.options.vertical) {
			var t = e.$slides.eq(e.currentSlide).outerHeight(!0);
			e.$list.animate({
				height: t
			}, e.options.speed)
		}
	}, t.prototype.animateSlide = function(t, n) {
		var i = {},
			o = this;
		o.animateHeight(), !0 === o.options.rtl && !1 === o.options.vertical && (t = -t), !1 === o.transformsEnabled ? !1 === o.options.vertical ? o.$slideTrack.animate({
			left: t
		}, o.options.speed, o.options.easing, n) : o.$slideTrack.animate({
			top: t
		}, o.options.speed, o.options.easing, n) : !1 === o.cssTransitions ? (!0 === o.options.rtl && (o.currentLeft = -o.currentLeft), e({
			animStart: o.currentLeft
		}).animate({
			animStart: t
		}, {
			duration: o.options.speed,
			easing: o.options.easing,
			step: function(e) {
				e = Math.ceil(e), !1 === o.options.vertical ? (i[o.animType] = "translate(" + e + "px, 0px)", o.$slideTrack.css(i)) : (i[o.animType] = "translate(0px," + e + "px)", o.$slideTrack.css(i))
			},
			complete: function() {
				n && n.call()
			}
		})) : (o.applyTransition(), t = Math.ceil(t), !1 === o.options.vertical ? i[o.animType] = "translate3d(" + t + "px, 0px, 0px)" : i[o.animType] = "translate3d(0px," + t + "px, 0px)", o.$slideTrack.css(i), n && setTimeout(function() {
			o.disableTransition(), n.call()
		}, o.options.speed))
	}, t.prototype.getNavTarget = function() {
		var t = this,
			n = t.options.asNavFor;
		return n && null !== n && (n = e(n).not(t.$slider)), n
	}, t.prototype.asNavFor = function(t) {
		var n = this.getNavTarget();
		null !== n && "object" == _typeof(n) && n.each(function() {
			var n = e(this).slick("getSlick");
			n.unslicked || n.slideHandler(t, !0)
		})
	}, t.prototype.applyTransition = function(e) {
		var t = this,
			n = {};
		!1 === t.options.fade ? n[t.transitionType] = t.transformType + " " + t.options.speed + "ms " + t.options.cssEase : n[t.transitionType] = "opacity " + t.options.speed + "ms " + t.options.cssEase, !1 === t.options.fade ? t.$slideTrack.css(n) : t.$slides.eq(e).css(n)
	}, t.prototype.autoPlay = function() {
		var e = this;
		e.autoPlayClear(), e.slideCount > e.options.slidesToShow && (e.autoPlayTimer = setInterval(e.autoPlayIterator, e.options.autoplaySpeed))
	}, t.prototype.autoPlayClear = function() {
		var e = this;
		e.autoPlayTimer && clearInterval(e.autoPlayTimer)
	}, t.prototype.autoPlayIterator = function() {
		var e = this,
			t = e.currentSlide + e.options.slidesToScroll;
		e.paused || e.interrupted || e.focussed || (!1 === e.options.infinite && (1 === e.direction && e.currentSlide + 1 === e.slideCount - 1 ? e.direction = 0 : 0 === e.direction && (t = e.currentSlide - e.options.slidesToScroll, e.currentSlide - 1 == 0 && (e.direction = 1))), e.slideHandler(t))
	}, t.prototype.buildArrows = function() {
		var t = this;
		!0 === t.options.arrows && (t.$prevArrow = e(t.options.prevArrow).addClass("slick-arrow"), t.$nextArrow = e(t.options.nextArrow).addClass("slick-arrow"), t.slideCount > t.options.slidesToShow ? (t.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), t.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.prependTo(t.options.appendArrows), t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.appendTo(t.options.appendArrows), !0 !== t.options.infinite && t.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true")) : t.$prevArrow.add(t.$nextArrow).addClass("slick-hidden").attr({
			"aria-disabled": "true",
			tabindex: "-1"
		}))
	}, t.prototype.buildDots = function() {
		var t, n, i = this;
		if (!0 === i.options.dots) {
			for (i.$slider.addClass("slick-dotted"), n = e("<ul />").addClass(i.options.dotsClass), t = 0; t <= i.getDotCount(); t += 1) n.append(e("<li />").append(i.options.customPaging.call(this, i, t)));
			i.$dots = n.appendTo(i.options.appendDots), i.$dots.find("li").first().addClass("slick-active")
		}
	}, t.prototype.buildOut = function() {
		var t = this;
		t.$slides = t.$slider.children(t.options.slide + ":not(.slick-cloned)").addClass("slick-slide"), t.slideCount = t.$slides.length, t.$slides.each(function(t, n) {
			e(n).attr("data-slick-index", t).data("originalStyling", e(n).attr("style") || "")
		}), t.$slider.addClass("slick-slider"), t.$slideTrack = 0 === t.slideCount ? e('<div class="slick-track"/>').appendTo(t.$slider) : t.$slides.wrapAll('<div class="slick-track"/>').parent(), t.$list = t.$slideTrack.wrap('<div class="slick-list"/>').parent(), t.$slideTrack.css("opacity", 0), !0 !== t.options.centerMode && !0 !== t.options.swipeToSlide || (t.options.slidesToScroll = 1), e("img[data-lazy]", t.$slider).not("[src]").addClass("slick-loading"), t.setupInfinite(), t.buildArrows(), t.buildDots(), t.updateDots(), t.setSlideClasses("number" == typeof t.currentSlide ? t.currentSlide : 0), !0 === t.options.draggable && t.$list.addClass("draggable")
	}, t.prototype.buildRows = function() {
		var e, t, n, i, o, r, s, a = this;
		if (i = document.createDocumentFragment(), r = a.$slider.children(), a.options.rows > 1) {
			for (s = a.options.slidesPerRow * a.options.rows, o = Math.ceil(r.length / s), e = 0; e < o; e++) {
				var l = document.createElement("div");
				for (t = 0; t < a.options.rows; t++) {
					var c = document.createElement("div");
					for (n = 0; n < a.options.slidesPerRow; n++) {
						var d = e * s + (t * a.options.slidesPerRow + n);
						r.get(d) && c.appendChild(r.get(d))
					}
					l.appendChild(c)
				}
				i.appendChild(l)
			}
			a.$slider.empty().append(i), a.$slider.children().children().children().css({
				width: 100 / a.options.slidesPerRow + "%",
				display: "inline-block"
			})
		}
	}, t.prototype.checkResponsive = function(t, n) {
		var i, o, r, s = this,
			a = !1,
			l = s.$slider.width(),
			c = window.innerWidth || e(window).width();
		if ("window" === s.respondTo ? r = c : "slider" === s.respondTo ? r = l : "min" === s.respondTo && (r = Math.min(c, l)), s.options.responsive && s.options.responsive.length && null !== s.options.responsive) {
			o = null;
			for (i in s.breakpoints) s.breakpoints.hasOwnProperty(i) && (!1 === s.originalSettings.mobileFirst ? r < s.breakpoints[i] && (o = s.breakpoints[i]) : r > s.breakpoints[i] && (o = s.breakpoints[i]));
			null !== o ? null !== s.activeBreakpoint ? (o !== s.activeBreakpoint || n) && (s.activeBreakpoint = o, "unslick" === s.breakpointSettings[o] ? s.unslick(o) : (s.options = e.extend({}, s.originalSettings, s.breakpointSettings[o]), !0 === t && (s.currentSlide = s.options.initialSlide), s.refresh(t)), a = o) : (s.activeBreakpoint = o, "unslick" === s.breakpointSettings[o] ? s.unslick(o) : (s.options = e.extend({}, s.originalSettings, s.breakpointSettings[o]), !0 === t && (s.currentSlide = s.options.initialSlide), s.refresh(t)), a = o) : null !== s.activeBreakpoint && (s.activeBreakpoint = null, s.options = s.originalSettings, !0 === t && (s.currentSlide = s.options.initialSlide), s.refresh(t), a = o), t || !1 === a || s.$slider.trigger("breakpoint", [s, a])
		}
	}, t.prototype.changeSlide = function(t, n) {
		var i, o, r, s = this,
			a = e(t.currentTarget);
		switch (a.is("a") && t.preventDefault(), a.is("li") || (a = a.closest("li")), r = s.slideCount % s.options.slidesToScroll != 0, i = r ? 0 : (s.slideCount - s.currentSlide) % s.options.slidesToScroll, t.data.message) {
			case "previous":
				o = 0 === i ? s.options.slidesToScroll : s.options.slidesToShow - i, s.slideCount > s.options.slidesToShow && s.slideHandler(s.currentSlide - o, !1, n);
				break;
			case "next":
				o = 0 === i ? s.options.slidesToScroll : i, s.slideCount > s.options.slidesToShow && s.slideHandler(s.currentSlide + o, !1, n);
				break;
			case "index":
				var l = 0 === t.data.index ? 0 : t.data.index || a.index() * s.options.slidesToScroll;
				s.slideHandler(s.checkNavigable(l), !1, n), a.children().trigger("focus");
				break;
			default:
				return
		}
	}, t.prototype.checkNavigable = function(e) {
		var t, n;
		if (t = this.getNavigableIndexes(), n = 0, e > t[t.length - 1]) e = t[t.length - 1];
		else
			for (var i in t) {
				if (e < t[i]) {
					e = n;
					break
				}
				n = t[i]
			}
		return e
	}, t.prototype.cleanUpEvents = function() {
		var t = this;
		t.options.dots && null !== t.$dots && (e("li", t.$dots).off("click.slick", t.changeSlide).off("mouseenter.slick", e.proxy(t.interrupt, t, !0)).off("mouseleave.slick", e.proxy(t.interrupt, t, !1)), !0 === t.options.accessibility && t.$dots.off("keydown.slick", t.keyHandler)), t.$slider.off("focus.slick blur.slick"), !0 === t.options.arrows && t.slideCount > t.options.slidesToShow && (t.$prevArrow && t.$prevArrow.off("click.slick", t.changeSlide), t.$nextArrow && t.$nextArrow.off("click.slick", t.changeSlide), !0 === t.options.accessibility && (t.$prevArrow && t.$prevArrow.off("keydown.slick", t.keyHandler), t.$nextArrow && t.$nextArrow.off("keydown.slick", t.keyHandler))), t.$list.off("touchstart.slick mousedown.slick", t.swipeHandler), t.$list.off("touchmove.slick mousemove.slick", t.swipeHandler), t.$list.off("touchend.slick mouseup.slick", t.swipeHandler), t.$list.off("touchcancel.slick mouseleave.slick", t.swipeHandler), t.$list.off("click.slick", t.clickHandler), e(document).off(t.visibilityChange, t.visibility), t.cleanUpSlideEvents(), !0 === t.options.accessibility && t.$list.off("keydown.slick", t.keyHandler), !0 === t.options.focusOnSelect && e(t.$slideTrack).children().off("click.slick", t.selectHandler), e(window).off("orientationchange.slick.slick-" + t.instanceUid, t.orientationChange), e(window).off("resize.slick.slick-" + t.instanceUid, t.resize), e("[draggable!=true]", t.$slideTrack).off("dragstart", t.preventDefault), e(window).off("load.slick.slick-" + t.instanceUid, t.setPosition)
	}, t.prototype.cleanUpSlideEvents = function() {
		var t = this;
		t.$list.off("mouseenter.slick", e.proxy(t.interrupt, t, !0)), t.$list.off("mouseleave.slick", e.proxy(t.interrupt, t, !1))
	}, t.prototype.cleanUpRows = function() {
		var e, t = this;
		t.options.rows > 1 && ((e = t.$slides.children().children()).removeAttr("style"), t.$slider.empty().append(e))
	}, t.prototype.clickHandler = function(e) {
		!1 === this.shouldClick && (e.stopImmediatePropagation(), e.stopPropagation(), e.preventDefault())
	}, t.prototype.destroy = function(t) {
		var n = this;
		n.autoPlayClear(), n.touchObject = {}, n.cleanUpEvents(), e(".slick-cloned", n.$slider).detach(), n.$dots && n.$dots.remove(), n.$prevArrow && n.$prevArrow.length && (n.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), n.htmlExpr.test(n.options.prevArrow) && n.$prevArrow.remove()), n.$nextArrow && n.$nextArrow.length && (n.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), n.htmlExpr.test(n.options.nextArrow) && n.$nextArrow.remove()), n.$slides && (n.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function() {
			e(this).attr("style", e(this).data("originalStyling"))
		}), n.$slideTrack.children(this.options.slide).detach(), n.$slideTrack.detach(), n.$list.detach(), n.$slider.append(n.$slides)), n.cleanUpRows(), n.$slider.removeClass("slick-slider"), n.$slider.removeClass("slick-initialized"), n.$slider.removeClass("slick-dotted"), n.unslicked = !0, t || n.$slider.trigger("destroy", [n])
	}, t.prototype.disableTransition = function(e) {
		var t = this,
			n = {};
		n[t.transitionType] = "", !1 === t.options.fade ? t.$slideTrack.css(n) : t.$slides.eq(e).css(n)
	}, t.prototype.fadeSlide = function(e, t) {
		var n = this;
		!1 === n.cssTransitions ? (n.$slides.eq(e).css({
			zIndex: n.options.zIndex
		}), n.$slides.eq(e).animate({
			opacity: 1
		}, n.options.speed, n.options.easing, t)) : (n.applyTransition(e), n.$slides.eq(e).css({
			opacity: 1,
			zIndex: n.options.zIndex
		}), t && setTimeout(function() {
			n.disableTransition(e), t.call()
		}, n.options.speed))
	}, t.prototype.fadeSlideOut = function(e) {
		var t = this;
		!1 === t.cssTransitions ? t.$slides.eq(e).animate({
			opacity: 0,
			zIndex: t.options.zIndex - 2
		}, t.options.speed, t.options.easing) : (t.applyTransition(e), t.$slides.eq(e).css({
			opacity: 0,
			zIndex: t.options.zIndex - 2
		}))
	}, t.prototype.filterSlides = t.prototype.slickFilter = function(e) {
		var t = this;
		null !== e && (t.$slidesCache = t.$slides, t.unload(), t.$slideTrack.children(this.options.slide).detach(), t.$slidesCache.filter(e).appendTo(t.$slideTrack), t.reinit())
	}, t.prototype.focusHandler = function() {
		var t = this;
		t.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*", function(n) {
			n.stopImmediatePropagation();
			var i = e(this);
			setTimeout(function() {
				t.options.pauseOnFocus && (t.focussed = i.is(":focus"), t.autoPlay())
			}, 0)
		})
	}, t.prototype.getCurrent = t.prototype.slickCurrentSlide = function() {
		return this.currentSlide
	}, t.prototype.getDotCount = function() {
		var e = this,
			t = 0,
			n = 0,
			i = 0;
		if (!0 === e.options.infinite)
			if (e.slideCount <= e.options.slidesToShow) ++i;
			else
				for (; t < e.slideCount;) ++i, t = n + e.options.slidesToScroll, n += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
		else if (!0 === e.options.centerMode) i = e.slideCount;
		else if (e.options.asNavFor)
			for (; t < e.slideCount;) ++i, t = n + e.options.slidesToScroll, n += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
		else i = 1 + Math.ceil((e.slideCount - e.options.slidesToShow) / e.options.slidesToScroll);
		return i - 1
	}, t.prototype.getLeft = function(e) {
		var t, n, i, o, r = this,
			s = 0;
		return r.slideOffset = 0, n = r.$slides.first().outerHeight(!0), !0 === r.options.infinite ? (r.slideCount > r.options.slidesToShow && (r.slideOffset = r.slideWidth * r.options.slidesToShow * -1, o = -1, !0 === r.options.vertical && !0 === r.options.centerMode && (2 === r.options.slidesToShow ? o = -1.5 : 1 === r.options.slidesToShow && (o = -2)), s = n * r.options.slidesToShow * o), r.slideCount % r.options.slidesToScroll != 0 && e + r.options.slidesToScroll > r.slideCount && r.slideCount > r.options.slidesToShow && (e > r.slideCount ? (r.slideOffset = (r.options.slidesToShow - (e - r.slideCount)) * r.slideWidth * -1, s = (r.options.slidesToShow - (e - r.slideCount)) * n * -1) : (r.slideOffset = r.slideCount % r.options.slidesToScroll * r.slideWidth * -1, s = r.slideCount % r.options.slidesToScroll * n * -1))) : e + r.options.slidesToShow > r.slideCount && (r.slideOffset = (e + r.options.slidesToShow - r.slideCount) * r.slideWidth, s = (e + r.options.slidesToShow - r.slideCount) * n), r.slideCount <= r.options.slidesToShow && (r.slideOffset = 0, s = 0), !0 === r.options.centerMode && r.slideCount <= r.options.slidesToShow ? r.slideOffset = r.slideWidth * Math.floor(r.options.slidesToShow) / 2 - r.slideWidth * r.slideCount / 2 : !0 === r.options.centerMode && !0 === r.options.infinite ? r.slideOffset += r.slideWidth * Math.floor(r.options.slidesToShow / 2) - r.slideWidth : !0 === r.options.centerMode && (r.slideOffset = 0, r.slideOffset += r.slideWidth * Math.floor(r.options.slidesToShow / 2)), t = !1 === r.options.vertical ? e * r.slideWidth * -1 + r.slideOffset : e * n * -1 + s, !0 === r.options.variableWidth && (i = r.slideCount <= r.options.slidesToShow || !1 === r.options.infinite ? r.$slideTrack.children(".slick-slide").eq(e) : r.$slideTrack.children(".slick-slide").eq(e + r.options.slidesToShow), t = !0 === r.options.rtl ? i[0] ? -1 * (r.$slideTrack.width() - i[0].offsetLeft - i.width()) : 0 : i[0] ? -1 * i[0].offsetLeft : 0, !0 === r.options.centerMode && (i = r.slideCount <= r.options.slidesToShow || !1 === r.options.infinite ? r.$slideTrack.children(".slick-slide").eq(e) : r.$slideTrack.children(".slick-slide").eq(e + r.options.slidesToShow + 1), t = !0 === r.options.rtl ? i[0] ? -1 * (r.$slideTrack.width() - i[0].offsetLeft - i.width()) : 0 : i[0] ? -1 * i[0].offsetLeft : 0, t += (r.$list.width() - i.outerWidth()) / 2)), t
	}, t.prototype.getOption = t.prototype.slickGetOption = function(e) {
		return this.options[e]
	}, t.prototype.getNavigableIndexes = function() {
		var e, t = this,
			n = 0,
			i = 0,
			o = [];
		for (!1 === t.options.infinite ? e = t.slideCount : (n = -1 * t.options.slidesToScroll, i = -1 * t.options.slidesToScroll, e = 2 * t.slideCount); n < e;) o.push(n), n = i + t.options.slidesToScroll, i += t.options.slidesToScroll <= t.options.slidesToShow ? t.options.slidesToScroll : t.options.slidesToShow;
		return o
	}, t.prototype.getSlick = function() {
		return this
	}, t.prototype.getSlideCount = function() {
		var t, n, i = this;
		return n = !0 === i.options.centerMode ? i.slideWidth * Math.floor(i.options.slidesToShow / 2) : 0, !0 === i.options.swipeToSlide ? (i.$slideTrack.find(".slick-slide").each(function(o, r) {
			if (r.offsetLeft - n + e(r).outerWidth() / 2 > -1 * i.swipeLeft) return t = r, !1
		}), Math.abs(e(t).attr("data-slick-index") - i.currentSlide) || 1) : i.options.slidesToScroll
	}, t.prototype.goTo = t.prototype.slickGoTo = function(e, t) {
		this.changeSlide({
			data: {
				message: "index",
				index: parseInt(e)
			}
		}, t)
	}, t.prototype.init = function(t) {
		var n = this;
		e(n.$slider).hasClass("slick-initialized") || (e(n.$slider).addClass("slick-initialized"), n.buildRows(), n.buildOut(), n.setProps(), n.startLoad(), n.loadSlider(), n.initializeEvents(), n.updateArrows(), n.updateDots(), n.checkResponsive(!0), n.focusHandler()), t && n.$slider.trigger("init", [n]), !0 === n.options.accessibility && n.initADA(), n.options.autoplay && (n.paused = !1, n.autoPlay())
	}, t.prototype.initADA = function() {
		var t = this,
			n = Math.ceil(t.slideCount / t.options.slidesToShow),
			i = t.getNavigableIndexes().filter(function(e) {
				return e >= 0 && e < t.slideCount
			});
		t.$slides.add(t.$slideTrack.find(".slick-cloned")).attr({
			"aria-hidden": "true",
			tabindex: "-1"
		}).find("a, input, button, select").attr({
			tabindex: "-1"
		}), null !== t.$dots && (t.$slides.not(t.$slideTrack.find(".slick-cloned")).each(function(n) {
			var o = i.indexOf(n);
			e(this).attr({
				role: "tabpanel",
				id: "slick-slide" + t.instanceUid + n,
				tabindex: -1
			}), -1 !== o && e(this).attr({
				"aria-describedby": "slick-slide-control" + t.instanceUid + o
			})
		}), t.$dots.attr("role", "tablist").find("li").each(function(o) {
			var r = i[o];
			e(this).attr({
				role: "presentation"
			}), e(this).find("button").first().attr({
				role: "tab",
				id: "slick-slide-control" + t.instanceUid + o,
				"aria-controls": "slick-slide" + t.instanceUid + r,
				"aria-label": o + 1 + " of " + n,
				"aria-selected": null,
				tabindex: "-1"
			})
		}).eq(t.currentSlide).find("button").attr({
			"aria-selected": "true",
			tabindex: "0"
		}).end());
		for (var o = t.currentSlide, r = o + t.options.slidesToShow; o < r; o++) t.$slides.eq(o).attr("tabindex", 0);
		t.activateADA()
	}, t.prototype.initArrowEvents = function() {
		var e = this;
		!0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow.off("click.slick").on("click.slick", {
			message: "previous"
		}, e.changeSlide), e.$nextArrow.off("click.slick").on("click.slick", {
			message: "next"
		}, e.changeSlide), !0 === e.options.accessibility && (e.$prevArrow.on("keydown.slick", e.keyHandler), e.$nextArrow.on("keydown.slick", e.keyHandler)))
	}, t.prototype.initDotEvents = function() {
		var t = this;
		!0 === t.options.dots && (e("li", t.$dots).on("click.slick", {
			message: "index"
		}, t.changeSlide), !0 === t.options.accessibility && t.$dots.on("keydown.slick", t.keyHandler)), !0 === t.options.dots && !0 === t.options.pauseOnDotsHover && e("li", t.$dots).on("mouseenter.slick", e.proxy(t.interrupt, t, !0)).on("mouseleave.slick", e.proxy(t.interrupt, t, !1))
	}, t.prototype.initSlideEvents = function() {
		var t = this;
		t.options.pauseOnHover && (t.$list.on("mouseenter.slick", e.proxy(t.interrupt, t, !0)), t.$list.on("mouseleave.slick", e.proxy(t.interrupt, t, !1)))
	}, t.prototype.initializeEvents = function() {
		var t = this;
		t.initArrowEvents(), t.initDotEvents(), t.initSlideEvents(), t.$list.on("touchstart.slick mousedown.slick", {
			action: "start"
		}, t.swipeHandler), t.$list.on("touchmove.slick mousemove.slick", {
			action: "move"
		}, t.swipeHandler), t.$list.on("touchend.slick mouseup.slick", {
			action: "end"
		}, t.swipeHandler), t.$list.on("touchcancel.slick mouseleave.slick", {
			action: "end"
		}, t.swipeHandler), t.$list.on("click.slick", t.clickHandler), e(document).on(t.visibilityChange, e.proxy(t.visibility, t)), !0 === t.options.accessibility && t.$list.on("keydown.slick", t.keyHandler), !0 === t.options.focusOnSelect && e(t.$slideTrack).children().on("click.slick", t.selectHandler), e(window).on("orientationchange.slick.slick-" + t.instanceUid, e.proxy(t.orientationChange, t)), e(window).on("resize.slick.slick-" + t.instanceUid, e.proxy(t.resize, t)), e("[draggable!=true]", t.$slideTrack).on("dragstart", t.preventDefault), e(window).on("load.slick.slick-" + t.instanceUid, t.setPosition), e(t.setPosition)
	}, t.prototype.initUI = function() {
		var e = this;
		!0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow.show(), e.$nextArrow.show()), !0 === e.options.dots && e.slideCount > e.options.slidesToShow && e.$dots.show()
	}, t.prototype.keyHandler = function(e) {
		var t = this;
		e.target.tagName.match("TEXTAREA|INPUT|SELECT") || (37 === e.keyCode && !0 === t.options.accessibility ? t.changeSlide({
			data: {
				message: !0 === t.options.rtl ? "next" : "previous"
			}
		}) : 39 === e.keyCode && !0 === t.options.accessibility && t.changeSlide({
			data: {
				message: !0 === t.options.rtl ? "previous" : "next"
			}
		}))
	}, t.prototype.lazyLoad = function() {
		function t(t) {
			e("img[data-lazy]", t).each(function() {
				var t = e(this),
					n = e(this).attr("data-lazy"),
					i = e(this).attr("data-srcset"),
					o = e(this).attr("data-sizes") || r.$slider.attr("data-sizes"),
					s = document.createElement("img");
				s.onload = function() {
					t.animate({
						opacity: 0
					}, 100, function() {
						i && (t.attr("srcset", i), o && t.attr("sizes", o)), t.attr("src", n).animate({
							opacity: 1
						}, 200, function() {
							t.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")
						}), r.$slider.trigger("lazyLoaded", [r, t, n])
					})
				}, s.onerror = function() {
					t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), r.$slider.trigger("lazyLoadError", [r, t, n])
				}, s.src = n
			})
		}
		var n, i, o, r = this;
		if (!0 === r.options.centerMode ? !0 === r.options.infinite ? o = (i = r.currentSlide + (r.options.slidesToShow / 2 + 1)) + r.options.slidesToShow + 2 : (i = Math.max(0, r.currentSlide - (r.options.slidesToShow / 2 + 1)), o = r.options.slidesToShow / 2 + 1 + 2 + r.currentSlide) : (i = r.options.infinite ? r.options.slidesToShow + r.currentSlide : r.currentSlide, o = Math.ceil(i + r.options.slidesToShow), !0 === r.options.fade && (i > 0 && i--, o <= r.slideCount && o++)), n = r.$slider.find(".slick-slide").slice(i, o), "anticipated" === r.options.lazyLoad)
			for (var s = i - 1, a = o, l = r.$slider.find(".slick-slide"), c = 0; c < r.options.slidesToScroll; c++) s < 0 && (s = r.slideCount - 1), n = (n = n.add(l.eq(s))).add(l.eq(a)), s--, a++;
		t(n), r.slideCount <= r.options.slidesToShow ? t(r.$slider.find(".slick-slide")) : r.currentSlide >= r.slideCount - r.options.slidesToShow ? t(r.$slider.find(".slick-cloned").slice(0, r.options.slidesToShow)) : 0 === r.currentSlide && t(r.$slider.find(".slick-cloned").slice(-1 * r.options.slidesToShow))
	}, t.prototype.loadSlider = function() {
		var e = this;
		e.setPosition(), e.$slideTrack.css({
			opacity: 1
		}), e.$slider.removeClass("slick-loading"), e.initUI(), "progressive" === e.options.lazyLoad && e.progressiveLazyLoad()
	}, t.prototype.next = t.prototype.slickNext = function() {
		this.changeSlide({
			data: {
				message: "next"
			}
		})
	}, t.prototype.orientationChange = function() {
		var e = this;
		e.checkResponsive(), e.setPosition()
	}, t.prototype.pause = t.prototype.slickPause = function() {
		var e = this;
		e.autoPlayClear(), e.paused = !0
	}, t.prototype.play = t.prototype.slickPlay = function() {
		var e = this;
		e.autoPlay(), e.options.autoplay = !0, e.paused = !1, e.focussed = !1, e.interrupted = !1
	}, t.prototype.postSlide = function(t) {
		var n = this;
		n.unslicked || (n.$slider.trigger("afterChange", [n, t]), n.animating = !1, n.slideCount > n.options.slidesToShow && n.setPosition(), n.swipeLeft = null, n.options.autoplay && n.autoPlay(), !0 === n.options.accessibility && (n.initADA(), n.options.focusOnChange && e(n.$slides.get(n.currentSlide)).attr("tabindex", 0).focus()))
	}, t.prototype.prev = t.prototype.slickPrev = function() {
		this.changeSlide({
			data: {
				message: "previous"
			}
		})
	}, t.prototype.preventDefault = function(e) {
		e.preventDefault()
	}, t.prototype.progressiveLazyLoad = function(t) {
		t = t || 1;
		var n, i, o, r, s, a = this,
			l = e("img[data-lazy]", a.$slider);
		l.length ? (n = l.first(), i = n.attr("data-lazy"), o = n.attr("data-srcset"), r = n.attr("data-sizes") || a.$slider.attr("data-sizes"), (s = document.createElement("img")).onload = function() {
			o && (n.attr("srcset", o), r && n.attr("sizes", r)), n.attr("src", i).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"), !0 === a.options.adaptiveHeight && a.setPosition(), a.$slider.trigger("lazyLoaded", [a, n, i]), a.progressiveLazyLoad()
		}, s.onerror = function() {
			t < 3 ? setTimeout(function() {
				a.progressiveLazyLoad(t + 1)
			}, 500) : (n.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), a.$slider.trigger("lazyLoadError", [a, n, i]), a.progressiveLazyLoad())
		}, s.src = i) : a.$slider.trigger("allImagesLoaded", [a])
	}, t.prototype.refresh = function(t) {
		var n, i, o = this;
		i = o.slideCount - o.options.slidesToShow, !o.options.infinite && o.currentSlide > i && (o.currentSlide = i), o.slideCount <= o.options.slidesToShow && (o.currentSlide = 0), n = o.currentSlide, o.destroy(!0), e.extend(o, o.initials, {
			currentSlide: n
		}), o.init(), t || o.changeSlide({
			data: {
				message: "index",
				index: n
			}
		}, !1)
	}, t.prototype.registerBreakpoints = function() {
		var t, n, i, o = this,
			r = o.options.responsive || null;
		if ("array" === e.type(r) && r.length) {
			o.respondTo = o.options.respondTo || "window";
			for (t in r)
				if (i = o.breakpoints.length - 1, r.hasOwnProperty(t)) {
					for (n = r[t].breakpoint; i >= 0;) o.breakpoints[i] && o.breakpoints[i] === n && o.breakpoints.splice(i, 1), i--;
					o.breakpoints.push(n), o.breakpointSettings[n] = r[t].settings
				} o.breakpoints.sort(function(e, t) {
				return o.options.mobileFirst ? e - t : t - e
			})
		}
	}, t.prototype.reinit = function() {
		var t = this;
		t.$slides = t.$slideTrack.children(t.options.slide).addClass("slick-slide"), t.slideCount = t.$slides.length, t.currentSlide >= t.slideCount && 0 !== t.currentSlide && (t.currentSlide = t.currentSlide - t.options.slidesToScroll), t.slideCount <= t.options.slidesToShow && (t.currentSlide = 0), t.registerBreakpoints(), t.setProps(), t.setupInfinite(), t.buildArrows(), t.updateArrows(), t.initArrowEvents(), t.buildDots(), t.updateDots(), t.initDotEvents(), t.cleanUpSlideEvents(), t.initSlideEvents(), t.checkResponsive(!1, !0), !0 === t.options.focusOnSelect && e(t.$slideTrack).children().on("click.slick", t.selectHandler), t.setSlideClasses("number" == typeof t.currentSlide ? t.currentSlide : 0), t.setPosition(), t.focusHandler(), t.paused = !t.options.autoplay, t.autoPlay(), t.$slider.trigger("reInit", [t])
	}, t.prototype.resize = function() {
		var t = this;
		e(window).width() !== t.windowWidth && (clearTimeout(t.windowDelay), t.windowDelay = window.setTimeout(function() {
			t.windowWidth = e(window).width(), t.checkResponsive(), t.unslicked || t.setPosition()
		}, 50))
	}, t.prototype.removeSlide = t.prototype.slickRemove = function(e, t, n) {
		var i = this;
		if (e = "boolean" == typeof e ? !0 === (t = e) ? 0 : i.slideCount - 1 : !0 === t ? --e : e, i.slideCount < 1 || e < 0 || e > i.slideCount - 1) return !1;
		i.unload(), !0 === n ? i.$slideTrack.children().remove() : i.$slideTrack.children(this.options.slide).eq(e).remove(), i.$slides = i.$slideTrack.children(this.options.slide), i.$slideTrack.children(this.options.slide).detach(), i.$slideTrack.append(i.$slides), i.$slidesCache = i.$slides, i.reinit()
	}, t.prototype.setCSS = function(e) {
		var t, n, i = this,
			o = {};
		!0 === i.options.rtl && (e = -e), t = "left" == i.positionProp ? Math.ceil(e) + "px" : "0px", n = "top" == i.positionProp ? Math.ceil(e) + "px" : "0px", o[i.positionProp] = e, !1 === i.transformsEnabled ? i.$slideTrack.css(o) : (o = {}, !1 === i.cssTransitions ? (o[i.animType] = "translate(" + t + ", " + n + ")", i.$slideTrack.css(o)) : (o[i.animType] = "translate3d(" + t + ", " + n + ", 0px)", i.$slideTrack.css(o)))
	}, t.prototype.setDimensions = function() {
		var e = this;
		!1 === e.options.vertical ? !0 === e.options.centerMode && e.$list.css({
				padding: "0px " + e.options.centerPadding
			}) : (e.$list.height(e.$slides.first().outerHeight(!0) * e.options.slidesToShow), !0 === e.options.centerMode && e.$list.css({
				padding: e.options.centerPadding + " 0px"
			})), e.listWidth = e.$list.width(), e.listHeight = e.$list.height(),
			!1 === e.options.vertical && !1 === e.options.variableWidth ? (e.slideWidth = Math.ceil(e.listWidth / e.options.slidesToShow), e.$slideTrack.width(Math.ceil(e.slideWidth * e.$slideTrack.children(".slick-slide").length))) : !0 === e.options.variableWidth ? e.$slideTrack.width(5e3 * e.slideCount) : (e.slideWidth = Math.ceil(e.listWidth), e.$slideTrack.height(Math.ceil(e.$slides.first().outerHeight(!0) * e.$slideTrack.children(".slick-slide").length)));
		var t = e.$slides.first().outerWidth(!0) - e.$slides.first().width();
		!1 === e.options.variableWidth && e.$slideTrack.children(".slick-slide").width(e.slideWidth - t)
	}, t.prototype.setFade = function() {
		var t, n = this;
		n.$slides.each(function(i, o) {
			t = n.slideWidth * i * -1, !0 === n.options.rtl ? e(o).css({
				position: "relative",
				right: t,
				top: 0,
				zIndex: n.options.zIndex - 2,
				opacity: 0
			}) : e(o).css({
				position: "relative",
				left: t,
				top: 0,
				zIndex: n.options.zIndex - 2,
				opacity: 0
			})
		}), n.$slides.eq(n.currentSlide).css({
			zIndex: n.options.zIndex - 1,
			opacity: 1
		})
	}, t.prototype.setHeight = function() {
		var e = this;
		if (1 === e.options.slidesToShow && !0 === e.options.adaptiveHeight && !1 === e.options.vertical) {
			var t = e.$slides.eq(e.currentSlide).outerHeight(!0);
			e.$list.css("height", t)
		}
	}, t.prototype.setOption = t.prototype.slickSetOption = function() {
		var t, n, i, o, r, s = this,
			a = !1;
		if ("object" === e.type(arguments[0]) ? (i = arguments[0], a = arguments[1], r = "multiple") : "string" === e.type(arguments[0]) && (i = arguments[0], o = arguments[1], a = arguments[2], "responsive" === arguments[0] && "array" === e.type(arguments[1]) ? r = "responsive" : void 0 !== arguments[1] && (r = "single")), "single" === r) s.options[i] = o;
		else if ("multiple" === r) e.each(i, function(e, t) {
			s.options[e] = t
		});
		else if ("responsive" === r)
			for (n in o)
				if ("array" !== e.type(s.options.responsive)) s.options.responsive = [o[n]];
				else {
					for (t = s.options.responsive.length - 1; t >= 0;) s.options.responsive[t].breakpoint === o[n].breakpoint && s.options.responsive.splice(t, 1), t--;
					s.options.responsive.push(o[n])
				} a && (s.unload(), s.reinit())
	}, t.prototype.setPosition = function() {
		var e = this;
		e.setDimensions(), e.setHeight(), !1 === e.options.fade ? e.setCSS(e.getLeft(e.currentSlide)) : e.setFade(), e.$slider.trigger("setPosition", [e])
	}, t.prototype.setProps = function() {
		var e = this,
			t = document.body.style;
		e.positionProp = !0 === e.options.vertical ? "top" : "left", "top" === e.positionProp ? e.$slider.addClass("slick-vertical") : e.$slider.removeClass("slick-vertical"), void 0 === t.WebkitTransition && void 0 === t.MozTransition && void 0 === t.msTransition || !0 === e.options.useCSS && (e.cssTransitions = !0), e.options.fade && ("number" == typeof e.options.zIndex ? e.options.zIndex < 3 && (e.options.zIndex = 3) : e.options.zIndex = e.defaults.zIndex), void 0 !== t.OTransform && (e.animType = "OTransform", e.transformType = "-o-transform", e.transitionType = "OTransition", void 0 === t.perspectiveProperty && void 0 === t.webkitPerspective && (e.animType = !1)), void 0 !== t.MozTransform && (e.animType = "MozTransform", e.transformType = "-moz-transform", e.transitionType = "MozTransition", void 0 === t.perspectiveProperty && void 0 === t.MozPerspective && (e.animType = !1)), void 0 !== t.webkitTransform && (e.animType = "webkitTransform", e.transformType = "-webkit-transform", e.transitionType = "webkitTransition", void 0 === t.perspectiveProperty && void 0 === t.webkitPerspective && (e.animType = !1)), void 0 !== t.msTransform && (e.animType = "msTransform", e.transformType = "-ms-transform", e.transitionType = "msTransition", void 0 === t.msTransform && (e.animType = !1)), void 0 !== t.transform && !1 !== e.animType && (e.animType = "transform", e.transformType = "transform", e.transitionType = "transition"), e.transformsEnabled = e.options.useTransform && null !== e.animType && !1 !== e.animType
	}, t.prototype.setSlideClasses = function(e) {
		var t, n, i, o, r = this;
		if (n = r.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true"), r.$slides.eq(e).addClass("slick-current"), !0 === r.options.centerMode) {
			var s = r.options.slidesToShow % 2 == 0 ? 1 : 0;
			t = Math.floor(r.options.slidesToShow / 2), !0 === r.options.infinite && (e >= t && e <= r.slideCount - 1 - t ? r.$slides.slice(e - t + s, e + t + 1).addClass("slick-active").attr("aria-hidden", "false") : (i = r.options.slidesToShow + e, n.slice(i - t + 1 + s, i + t + 2).addClass("slick-active").attr("aria-hidden", "false")), 0 === e ? n.eq(n.length - 1 - r.options.slidesToShow).addClass("slick-center") : e === r.slideCount - 1 && n.eq(r.options.slidesToShow).addClass("slick-center")), r.$slides.eq(e).addClass("slick-center")
		} else e >= 0 && e <= r.slideCount - r.options.slidesToShow ? r.$slides.slice(e, e + r.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false") : n.length <= r.options.slidesToShow ? n.addClass("slick-active").attr("aria-hidden", "false") : (o = r.slideCount % r.options.slidesToShow, i = !0 === r.options.infinite ? r.options.slidesToShow + e : e, r.options.slidesToShow == r.options.slidesToScroll && r.slideCount - e < r.options.slidesToShow ? n.slice(i - (r.options.slidesToShow - o), i + o).addClass("slick-active").attr("aria-hidden", "false") : n.slice(i, i + r.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false"));
		"ondemand" !== r.options.lazyLoad && "anticipated" !== r.options.lazyLoad || r.lazyLoad()
	}, t.prototype.setupInfinite = function() {
		var t, n, i, o = this;
		if (!0 === o.options.fade && (o.options.centerMode = !1), !0 === o.options.infinite && !1 === o.options.fade && (n = null, o.slideCount > o.options.slidesToShow)) {
			for (i = !0 === o.options.centerMode ? o.options.slidesToShow + 1 : o.options.slidesToShow, t = o.slideCount; t > o.slideCount - i; t -= 1) n = t - 1, e(o.$slides[n]).clone(!0).attr("id", "").attr("data-slick-index", n - o.slideCount).prependTo(o.$slideTrack).addClass("slick-cloned");
			for (t = 0; t < i + o.slideCount; t += 1) n = t, e(o.$slides[n]).clone(!0).attr("id", "").attr("data-slick-index", n + o.slideCount).appendTo(o.$slideTrack).addClass("slick-cloned");
			o.$slideTrack.find(".slick-cloned").find("[id]").each(function() {
				e(this).attr("id", "")
			})
		}
	}, t.prototype.interrupt = function(e) {
		var t = this;
		e || t.autoPlay(), t.interrupted = e
	}, t.prototype.selectHandler = function(t) {
		var n = this,
			i = e(t.target).is(".slick-slide") ? e(t.target) : e(t.target).parents(".slick-slide"),
			o = parseInt(i.attr("data-slick-index"));
		o || (o = 0), n.slideCount <= n.options.slidesToShow ? n.slideHandler(o, !1, !0) : n.slideHandler(o)
	}, t.prototype.slideHandler = function(e, t, n) {
		var i, o, r, s, a, l = null,
			c = this;
		if (t = t || !1, !(!0 === c.animating && !0 === c.options.waitForAnimate || !0 === c.options.fade && c.currentSlide === e))
			if (!1 === t && c.asNavFor(e), i = e, l = c.getLeft(i), s = c.getLeft(c.currentSlide), c.currentLeft = null === c.swipeLeft ? s : c.swipeLeft, !1 === c.options.infinite && !1 === c.options.centerMode && (e < 0 || e > c.getDotCount() * c.options.slidesToScroll)) !1 === c.options.fade && (i = c.currentSlide, !0 !== n ? c.animateSlide(s, function() {
				c.postSlide(i)
			}) : c.postSlide(i));
			else if (!1 === c.options.infinite && !0 === c.options.centerMode && (e < 0 || e > c.slideCount - c.options.slidesToScroll)) !1 === c.options.fade && (i = c.currentSlide, !0 !== n ? c.animateSlide(s, function() {
			c.postSlide(i)
		}) : c.postSlide(i));
		else {
			if (c.options.autoplay && clearInterval(c.autoPlayTimer), o = i < 0 ? c.slideCount % c.options.slidesToScroll != 0 ? c.slideCount - c.slideCount % c.options.slidesToScroll : c.slideCount + i : i >= c.slideCount ? c.slideCount % c.options.slidesToScroll != 0 ? 0 : i - c.slideCount : i, c.animating = !0, c.$slider.trigger("beforeChange", [c, c.currentSlide, o]), r = c.currentSlide, c.currentSlide = o, c.setSlideClasses(c.currentSlide), c.options.asNavFor && (a = (a = c.getNavTarget()).slick("getSlick")).slideCount <= a.options.slidesToShow && a.setSlideClasses(c.currentSlide), c.updateDots(), c.updateArrows(), !0 === c.options.fade) return !0 !== n ? (c.fadeSlideOut(r), c.fadeSlide(o, function() {
				c.postSlide(o)
			})) : c.postSlide(o), void c.animateHeight();
			!0 !== n ? c.animateSlide(l, function() {
				c.postSlide(o)
			}) : c.postSlide(o)
		}
	}, t.prototype.startLoad = function() {
		var e = this;
		!0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow.hide(), e.$nextArrow.hide()), !0 === e.options.dots && e.slideCount > e.options.slidesToShow && e.$dots.hide(), e.$slider.addClass("slick-loading")
	}, t.prototype.swipeDirection = function() {
		var e, t, n, i, o = this;
		return e = o.touchObject.startX - o.touchObject.curX, t = o.touchObject.startY - o.touchObject.curY, n = Math.atan2(t, e), (i = Math.round(180 * n / Math.PI)) < 0 && (i = 360 - Math.abs(i)), i <= 45 && i >= 0 ? !1 === o.options.rtl ? "left" : "right" : i <= 360 && i >= 315 ? !1 === o.options.rtl ? "left" : "right" : i >= 135 && i <= 225 ? !1 === o.options.rtl ? "right" : "left" : !0 === o.options.verticalSwiping ? i >= 35 && i <= 135 ? "down" : "up" : "vertical"
	}, t.prototype.swipeEnd = function(e) {
		var t, n, i = this;
		if (i.dragging = !1, i.swiping = !1, i.scrolling) return i.scrolling = !1, !1;
		if (i.interrupted = !1, i.shouldClick = !(i.touchObject.swipeLength > 10), void 0 === i.touchObject.curX) return !1;
		if (!0 === i.touchObject.edgeHit && i.$slider.trigger("edge", [i, i.swipeDirection()]), i.touchObject.swipeLength >= i.touchObject.minSwipe) {
			switch (n = i.swipeDirection()) {
				case "left":
				case "down":
					t = i.options.swipeToSlide ? i.checkNavigable(i.currentSlide + i.getSlideCount()) : i.currentSlide + i.getSlideCount(), i.currentDirection = 0;
					break;
				case "right":
				case "up":
					t = i.options.swipeToSlide ? i.checkNavigable(i.currentSlide - i.getSlideCount()) : i.currentSlide - i.getSlideCount(), i.currentDirection = 1
			}
			"vertical" != n && (i.slideHandler(t), i.touchObject = {}, i.$slider.trigger("swipe", [i, n]))
		} else i.touchObject.startX !== i.touchObject.curX && (i.slideHandler(i.currentSlide), i.touchObject = {})
	}, t.prototype.swipeHandler = function(e) {
		var t = this;
		if (!(!1 === t.options.swipe || "ontouchend" in document && !1 === t.options.swipe || !1 === t.options.draggable && -1 !== e.type.indexOf("mouse"))) switch (t.touchObject.fingerCount = e.originalEvent && void 0 !== e.originalEvent.touches ? e.originalEvent.touches.length : 1, t.touchObject.minSwipe = t.listWidth / t.options.touchThreshold, !0 === t.options.verticalSwiping && (t.touchObject.minSwipe = t.listHeight / t.options.touchThreshold), e.data.action) {
			case "start":
				t.swipeStart(e);
				break;
			case "move":
				t.swipeMove(e);
				break;
			case "end":
				t.swipeEnd(e)
		}
	}, t.prototype.swipeMove = function(e) {
		var t, n, i, o, r, s, a = this;
		return r = void 0 !== e.originalEvent ? e.originalEvent.touches : null, !(!a.dragging || a.scrolling || r && 1 !== r.length) && (t = a.getLeft(a.currentSlide), a.touchObject.curX = void 0 !== r ? r[0].pageX : e.clientX, a.touchObject.curY = void 0 !== r ? r[0].pageY : e.clientY, a.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(a.touchObject.curX - a.touchObject.startX, 2))), s = Math.round(Math.sqrt(Math.pow(a.touchObject.curY - a.touchObject.startY, 2))), !a.options.verticalSwiping && !a.swiping && s > 4 ? (a.scrolling = !0, !1) : (!0 === a.options.verticalSwiping && (a.touchObject.swipeLength = s), n = a.swipeDirection(), void 0 !== e.originalEvent && a.touchObject.swipeLength > 4 && (a.swiping = !0, e.preventDefault()), o = (!1 === a.options.rtl ? 1 : -1) * (a.touchObject.curX > a.touchObject.startX ? 1 : -1), !0 === a.options.verticalSwiping && (o = a.touchObject.curY > a.touchObject.startY ? 1 : -1), i = a.touchObject.swipeLength, a.touchObject.edgeHit = !1, !1 === a.options.infinite && (0 === a.currentSlide && "right" === n || a.currentSlide >= a.getDotCount() && "left" === n) && (i = a.touchObject.swipeLength * a.options.edgeFriction, a.touchObject.edgeHit = !0), !1 === a.options.vertical ? a.swipeLeft = t + i * o : a.swipeLeft = t + i * (a.$list.height() / a.listWidth) * o, !0 === a.options.verticalSwiping && (a.swipeLeft = t + i * o), !0 !== a.options.fade && !1 !== a.options.touchMove && (!0 === a.animating ? (a.swipeLeft = null, !1) : void a.setCSS(a.swipeLeft))))
	}, t.prototype.swipeStart = function(e) {
		var t, n = this;
		if (n.interrupted = !0, 1 !== n.touchObject.fingerCount || n.slideCount <= n.options.slidesToShow) return n.touchObject = {}, !1;
		void 0 !== e.originalEvent && void 0 !== e.originalEvent.touches && (t = e.originalEvent.touches[0]), n.touchObject.startX = n.touchObject.curX = void 0 !== t ? t.pageX : e.clientX, n.touchObject.startY = n.touchObject.curY = void 0 !== t ? t.pageY : e.clientY, n.dragging = !0
	}, t.prototype.unfilterSlides = t.prototype.slickUnfilter = function() {
		var e = this;
		null !== e.$slidesCache && (e.unload(), e.$slideTrack.children(this.options.slide).detach(), e.$slidesCache.appendTo(e.$slideTrack), e.reinit())
	}, t.prototype.unload = function() {
		var t = this;
		e(".slick-cloned", t.$slider).remove(), t.$dots && t.$dots.remove(), t.$prevArrow && t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove(), t.$nextArrow && t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove(), t.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "")
	}, t.prototype.unslick = function(e) {
		var t = this;
		t.$slider.trigger("unslick", [t, e]), t.destroy()
	}, t.prototype.updateArrows = function() {
		var e = this;
		Math.floor(e.options.slidesToShow / 2), !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && !e.options.infinite && (e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), 0 === e.currentSlide ? (e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"), e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : e.currentSlide >= e.slideCount - e.options.slidesToShow && !1 === e.options.centerMode ? (e.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : e.currentSlide >= e.slideCount - 1 && !0 === e.options.centerMode && (e.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")))
	}, t.prototype.updateDots = function() {
		var e = this;
		null !== e.$dots && (e.$dots.find("li").removeClass("slick-active").end(), e.$dots.find("li").eq(Math.floor(e.currentSlide / e.options.slidesToScroll)).addClass("slick-active"))
	}, t.prototype.visibility = function() {
		var e = this;
		e.options.autoplay && (document[e.hidden] ? e.interrupted = !0 : e.interrupted = !1)
	}, e.fn.slick = function() {
		var e, n, i = this,
			o = arguments[0],
			r = Array.prototype.slice.call(arguments, 1),
			s = i.length;
		for (e = 0; e < s; e++)
			if ("object" == _typeof(o) || void 0 === o ? i[e].slick = new t(i[e], o) : n = i[e].slick[o].apply(i[e].slick, r), void 0 !== n) return n;
		return i
	}
}),
function(e) {
	"function" == typeof define && define.amd ? define(["jquery"], e) : e("object" == ("undefined" == typeof exports ? "undefined" : _typeof(exports)) ? require("jquery") : window.jQuery || window.Zepto)
}(function(e) {
	var t, n, i, o, r, s, a, l = "Close",
		c = "BeforeClose",
		d = "MarkupParse",
		u = "Open",
		p = "Change",
		f = "mfp",
		h = "." + f,
		m = "mfp-ready",
		g = "mfp-removing",
		v = "mfp-prevent-close",
		y = function() {},
		w = !!window.jQuery,
		b = e(window),
		x = function(e, n) {
			t.ev.on(f + e + h, n)
		},
		T = function(t, n, i, o) {
			var r = document.createElement("div");
			return r.className = "mfp-" + t, i && (r.innerHTML = i), o ? n && n.appendChild(r) : (r = e(r), n && r.appendTo(n)), r
		},
		k = function(n, i) {
			t.ev.triggerHandler(f + n, i), t.st.callbacks && (n = n.charAt(0).toLowerCase() + n.slice(1), t.st.callbacks[n] && t.st.callbacks[n].apply(t, e.isArray(i) ? i : [i]))
		},
		S = function(n) {
			return n === a && t.currTemplate.closeBtn || (t.currTemplate.closeBtn = e(t.st.closeMarkup.replace("%title%", t.st.tClose)), a = n), t.currTemplate.closeBtn
		},
		C = function() {
			e.magnificPopup.instance || (t = new y, t.init(), e.magnificPopup.instance = t)
		},
		E = function() {
			var e = document.createElement("p").style,
				t = ["ms", "O", "Moz", "Webkit"];
			if (void 0 !== e.transition) return !0;
			for (; t.length;)
				if (t.pop() + "Transition" in e) return !0;
			return !1
		};
	y.prototype = {
		constructor: y,
		init: function() {
			var n = navigator.appVersion;
			t.isIE7 = -1 !== n.indexOf("MSIE 7."), t.isIE8 = -1 !== n.indexOf("MSIE 8."), t.isLowIE = t.isIE7 || t.isIE8, t.isAndroid = /android/gi.test(n), t.isIOS = /iphone|ipad|ipod/gi.test(n), t.supportsTransition = E(), t.probablyMobile = t.isAndroid || t.isIOS || /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent), o = e(document), t.popupsCache = {}
		},
		open: function(n) {
			i || (i = e(document.body));
			var r;
			if (!1 === n.isObj) {
				t.items = n.items.toArray(), t.index = 0;
				var a, l = n.items;
				for (r = 0; l.length > r; r++)
					if (a = l[r], a.parsed && (a = a.el[0]), a === n.el[0]) {
						t.index = r;
						break
					}
			} else t.items = e.isArray(n.items) ? n.items : [n.items], t.index = n.index || 0;
			if (t.isOpen) return void t.updateItemHTML();
			t.types = [], s = "", t.ev = n.mainEl && n.mainEl.length ? n.mainEl.eq(0) : o, n.key ? (t.popupsCache[n.key] || (t.popupsCache[n.key] = {}), t.currTemplate = t.popupsCache[n.key]) : t.currTemplate = {}, t.st = e.extend(!0, {}, e.magnificPopup.defaults, n), t.fixedContentPos = "auto" === t.st.fixedContentPos ? !t.probablyMobile : t.st.fixedContentPos, t.st.modal && (t.st.closeOnContentClick = !1, t.st.closeOnBgClick = !1, t.st.showCloseBtn = !1, t.st.enableEscapeKey = !1), t.bgOverlay || (t.bgOverlay = T("bg").on("click" + h, function() {
				t.close()
			}), t.wrap = T("wrap").attr("tabindex", -1).on("click" + h, function(e) {
				t._checkIfClose(e.target) && t.close()
			}), t.container = T("container", t.wrap)), t.contentContainer = T("content"), t.st.preloader && (t.preloader = T("preloader", t.container, t.st.tLoading));
			var c = e.magnificPopup.modules;
			for (r = 0; c.length > r; r++) {
				var p = c[r];
				p = p.charAt(0).toUpperCase() + p.slice(1), t["init" + p].call(t)
			}
			k("BeforeOpen"), t.st.showCloseBtn && (t.st.closeBtnInside ? (x(d, function(e, t, n, i) {
				n.close_replaceWith = S(i.type)
			}), s += " mfp-close-btn-in") : t.wrap.append(S())), t.st.alignTop && (s += " mfp-align-top"), t.fixedContentPos ? t.wrap.css({
				overflow: t.st.overflowY,
				overflowX: "hidden",
				overflowY: t.st.overflowY
			}) : t.wrap.css({
				top: b.scrollTop(),
				position: "absolute"
			}), (!1 === t.st.fixedBgPos || "auto" === t.st.fixedBgPos && !t.fixedContentPos) && t.bgOverlay.css({
				height: o.height(),
				position: "absolute"
			}), t.st.enableEscapeKey && o.on("keyup" + h, function(e) {
				27 === e.keyCode && t.close()
			}), b.on("resize" + h, function() {
				t.updateSize()
			}), t.st.closeOnContentClick || (s += " mfp-auto-cursor"), s && t.wrap.addClass(s);
			var f = t.wH = b.height(),
				g = {};
			if (t.fixedContentPos && t._hasScrollBar(f)) {
				var v = t._getScrollbarSize();
				v && (g.marginRight = v)
			}
			t.fixedContentPos && (t.isIE7 ? e("body, html").css("overflow", "hidden") : g.overflow = "hidden");
			var y = t.st.mainClass;
			return t.isIE7 && (y += " mfp-ie7"), y && t._addClassToMFP(y), t.updateItemHTML(), k("BuildControls"), e("html").css(g), t.bgOverlay.add(t.wrap).prependTo(t.st.prependTo || i), t._lastFocusedEl = document.activeElement, setTimeout(function() {
				t.content ? (t._addClassToMFP(m), t._setFocus()) : t.bgOverlay.addClass(m), o.on("focusin" + h, t._onFocusIn)
			}, 16), t.isOpen = !0, t.updateSize(f), k(u), n
		},
		close: function() {
			t.isOpen && (k(c), t.isOpen = !1, t.st.removalDelay && !t.isLowIE && t.supportsTransition ? (t._addClassToMFP(g), setTimeout(function() {
				t._close()
			}, t.st.removalDelay)) : t._close())
		},
		_close: function() {
			k(l);
			var n = g + " " + m + " ";
			if (t.bgOverlay.detach(), t.wrap.detach(), t.container.empty(), t.st.mainClass && (n += t.st.mainClass + " "), t._removeClassFromMFP(n), t.fixedContentPos) {
				var i = {
					marginRight: ""
				};
				t.isIE7 ? e("body, html").css("overflow", "") : i.overflow = "", e("html").css(i)
			}
			o.off("keyup.mfp focusin" + h), t.ev.off(h), t.wrap.attr("class", "mfp-wrap").removeAttr("style"), t.bgOverlay.attr("class", "mfp-bg"), t.container.attr("class", "mfp-container"), !t.st.showCloseBtn || t.st.closeBtnInside && !0 !== t.currTemplate[t.currItem.type] || t.currTemplate.closeBtn && t.currTemplate.closeBtn.detach(), t._lastFocusedEl && e(t._lastFocusedEl).focus(), t.currItem = null, t.content = null, t.currTemplate = null, t.prevHeight = 0, k("AfterClose")
		},
		updateSize: function(e) {
			if (t.isIOS) {
				var n = document.documentElement.clientWidth / window.innerWidth,
					i = window.innerHeight * n;
				t.wrap.css("height", i), t.wH = i
			} else t.wH = e || b.height();
			t.fixedContentPos || t.wrap.css("height", t.wH), k("Resize")
		},
		updateItemHTML: function() {
			var n = t.items[t.index];
			t.contentContainer.detach(), t.content && t.content.detach(), n.parsed || (n = t.parseEl(t.index));
			var i = n.type;
			if (k("BeforeChange", [t.currItem ? t.currItem.type : "", i]), t.currItem = n, !t.currTemplate[i]) {
				var o = !!t.st[i] && t.st[i].markup;
				k("FirstMarkupParse", o), t.currTemplate[i] = !o || e(o)
			}
			r && r !== n.type && t.container.removeClass("mfp-" + r + "-holder");
			var s = t["get" + i.charAt(0).toUpperCase() + i.slice(1)](n, t.currTemplate[i]);
			t.appendContent(s, i), n.preloaded = !0, k(p, n), r = n.type, t.container.prepend(t.contentContainer), k("AfterChange")
		},
		appendContent: function(e, n) {
			t.content = e, e ? t.st.showCloseBtn && t.st.closeBtnInside && !0 === t.currTemplate[n] ? t.content.find(".mfp-close").length || t.content.append(S()) : t.content = e : t.content = "", k("BeforeAppend"), t.container.addClass("mfp-" + n + "-holder"), t.contentContainer.append(t.content)
		},
		parseEl: function(n) {
			var i, o = t.items[n];
			if (o.tagName ? o = {
					el: e(o)
				} : (i = o.type, o = {
					data: o,
					src: o.src
				}), o.el) {
				for (var r = t.types, s = 0; r.length > s; s++)
					if (o.el.hasClass("mfp-" + r[s])) {
						i = r[s];
						break
					} o.src = o.el.attr("data-mfp-src"), o.src || (o.src = o.el.attr("href"))
			}
			return o.type = i || t.st.type || "inline", o.index = n, o.parsed = !0, t.items[n] = o, k("ElementParse", o), t.items[n]
		},
		addGroup: function(e, n) {
			var i = function(i) {
				i.mfpEl = this, t._openClick(i, e, n)
			};
			n || (n = {});
			var o = "click.magnificPopup";
			n.mainEl = e, n.items ? (n.isObj = !0, e.off(o).on(o, i)) : (n.isObj = !1, n.delegate ? e.off(o).on(o, n.delegate, i) : (n.items = e, e.off(o).on(o, i)))
		},
		_openClick: function(n, i, o) {
			if ((void 0 !== o.midClick ? o.midClick : e.magnificPopup.defaults.midClick) || 2 !== n.which && !n.ctrlKey && !n.metaKey) {
				var r = void 0 !== o.disableOn ? o.disableOn : e.magnificPopup.defaults.disableOn;
				if (r)
					if (e.isFunction(r)) {
						if (!r.call(t)) return !0
					} else if (r > b.width()) return !0;
				n.type && (n.preventDefault(), t.isOpen && n.stopPropagation()), o.el = e(n.mfpEl), o.delegate && (o.items = i.find(o.delegate)), t.open(o)
			}
		},
		updateStatus: function(e, i) {
			if (t.preloader) {
				n !== e && t.container.removeClass("mfp-s-" + n), i || "loading" !== e || (i = t.st.tLoading);
				var o = {
					status: e,
					text: i
				};
				k("UpdateStatus", o), e = o.status, i = o.text, t.preloader.html(i), t.preloader.find("a").on("click", function(e) {
					e.stopImmediatePropagation()
				}), t.container.addClass("mfp-s-" + e), n = e
			}
		},
		_checkIfClose: function(n) {
			if (!e(n).hasClass(v)) {
				var i = t.st.closeOnContentClick,
					o = t.st.closeOnBgClick;
				if (i && o) return !0;
				if (!t.content || e(n).hasClass("mfp-close") || t.preloader && n === t.preloader[0]) return !0;
				if (n === t.content[0] || e.contains(t.content[0], n)) {
					if (i) return !0
				} else if (o && e.contains(document, n)) return !0;
				return !1
			}
		},
		_addClassToMFP: function(e) {
			t.bgOverlay.addClass(e), t.wrap.addClass(e)
		},
		_removeClassFromMFP: function(e) {
			this.bgOverlay.removeClass(e), t.wrap.removeClass(e)
		},
		_hasScrollBar: function(e) {
			return (t.isIE7 ? o.height() : document.body.scrollHeight) > (e || b.height())
		},
		_setFocus: function() {
			(t.st.focus ? t.content.find(t.st.focus).eq(0) : t.wrap).focus()
		},
		_onFocusIn: function(n) {
			return n.target === t.wrap[0] || e.contains(t.wrap[0], n.target) ? void 0 : (t._setFocus(), !1)
		},
		_parseMarkup: function(t, n, i) {
			var o;
			i.data && (n = e.extend(i.data, n)), k(d, [t, n, i]), e.each(n, function(e, n) {
				if (void 0 === n || !1 === n) return !0;
				if (o = e.split("_"), o.length > 1) {
					var i = t.find(h + "-" + o[0]);
					if (i.length > 0) {
						var r = o[1];
						"replaceWith" === r ? i[0] !== n[0] && i.replaceWith(n) : "img" === r ? i.is("img") ? i.attr("src", n) : i.replaceWith('<img src="' + n + '" class="' + i.attr("class") + '" />') : i.attr(o[1], n)
					}
				} else t.find(h + "-" + e).html(n)
			})
		},
		_getScrollbarSize: function() {
			if (void 0 === t.scrollbarSize) {
				var e = document.createElement("div");
				e.style.cssText = "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;", document.body.appendChild(e), t.scrollbarSize = e.offsetWidth - e.clientWidth, document.body.removeChild(e)
			}
			return t.scrollbarSize
		}
	}, e.magnificPopup = {
		instance: null,
		proto: y.prototype,
		modules: [],
		open: function(t, n) {
			return C(), t = t ? e.extend(!0, {}, t) : {}, t.isObj = !0, t.index = n || 0, this.instance.open(t)
		},
		close: function() {
			return e.magnificPopup.instance && e.magnificPopup.instance.close()
		},
		registerModule: function(t, n) {
			n.options && (e.magnificPopup.defaults[t] = n.options), e.extend(this.proto, n.proto), this.modules.push(t)
		},
		defaults: {
			disableOn: 0,
			key: null,
			midClick: !1,
			mainClass: "",
			preloader: !0,
			focus: "",
			closeOnContentClick: !1,
			closeOnBgClick: !0,
			closeBtnInside: !0,
			showCloseBtn: !0,
			enableEscapeKey: !0,
			modal: !1,
			alignTop: !1,
			removalDelay: 0,
			prependTo: null,
			fixedContentPos: "auto",
			fixedBgPos: "auto",
			overflowY: "auto",
			closeMarkup: '<button title="%title%" type="button" class="mfp-close">&times;</button>',
			tClose: "Close (Esc)",
			tLoading: "Loading..."
		}
	}, e.fn.magnificPopup = function(n) {
		C();
		var i = e(this);
		if ("string" == typeof n)
			if ("open" === n) {
				var o, r = w ? i.data("magnificPopup") : i[0].magnificPopup,
					s = parseInt(arguments[1], 10) || 0;
				r.items ? o = r.items[s] : (o = i, r.delegate && (o = o.find(r.delegate)), o = o.eq(s)), t._openClick({
					mfpEl: o
				}, i, r)
			} else t.isOpen && t[n].apply(t, Array.prototype.slice.call(arguments, 1));
		else n = e.extend(!0, {}, n), w ? i.data("magnificPopup", n) : i[0].magnificPopup = n, t.addGroup(i, n);
		return i
	};
	var $, A, M, _ = "inline",
		P = function() {
			M && (A.after(M.addClass($)).detach(), M = null)
		};
	e.magnificPopup.registerModule(_, {
		options: {
			hiddenClass: "hide",
			markup: "",
			tNotFound: "Content not found"
		},
		proto: {
			initInline: function() {
				t.types.push(_), x(l + "." + _, function() {
					P()
				})
			},
			getInline: function(n, i) {
				if (P(), n.src) {
					var o = t.st.inline,
						r = e(n.src);
					if (r.length) {
						var s = r[0].parentNode;
						s && s.tagName && (A || ($ = o.hiddenClass, A = T($), $ = "mfp-" + $), M = r.after(A).detach().removeClass($)), t.updateStatus("ready")
					} else t.updateStatus("error", o.tNotFound), r = e("<div>");
					return n.inlineElement = r, r
				}
				return t.updateStatus("ready"), t._parseMarkup(i, {}, n), i
			}
		}
	});
	var N, L = "ajax",
		O = function() {
			N && i.removeClass(N)
		},
		H = function() {
			O(), t.req && t.req.abort()
		};
	e.magnificPopup.registerModule(L, {
		options: {
			settings: null,
			cursor: "mfp-ajax-cur",
			tError: '<a href="%url%">The content</a> could not be loaded.'
		},
		proto: {
			initAjax: function() {
				t.types.push(L), N = t.st.ajax.cursor, x(l + "." + L, H), x("BeforeChange." + L, H)
			},
			getAjax: function(n) {
				N && i.addClass(N), t.updateStatus("loading");
				var o = e.extend({
					url: n.src,
					success: function(i, o, r) {
						var s = {
							data: i,
							xhr: r
						};
						k("ParseAjax", s), t.appendContent(e(s.data), L), n.finished = !0, O(), t._setFocus(), setTimeout(function() {
							t.wrap.addClass(m)
						}, 16), t.updateStatus("ready"), k("AjaxContentAdded")
					},
					error: function() {
						O(), n.finished = n.loadError = !0, t.updateStatus("error", t.st.ajax.tError.replace("%url%", n.src))
					}
				}, t.st.ajax.settings);
				return t.req = e.ajax(o), ""
			}
		}
	});
	var D, j = function(n) {
		if (n.data && void 0 !== n.data.title) return n.data.title;
		var i = t.st.image.titleSrc;
		if (i) {
			if (e.isFunction(i)) return i.call(t, n);
			if (n.el) return n.el.attr(i) || ""
		}
		return ""
	};
	e.magnificPopup.registerModule("image", {
		options: {
			markup: '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',
			cursor: "mfp-zoom-out-cur",
			titleSrc: "title",
			verticalFit: !0,
			tError: '<a href="%url%">The image</a> could not be loaded.'
		},
		proto: {
			initImage: function() {
				var e = t.st.image,
					n = ".image";
				t.types.push("image"), x(u + n, function() {
					"image" === t.currItem.type && e.cursor && i.addClass(e.cursor)
				}), x(l + n, function() {
					e.cursor && i.removeClass(e.cursor), b.off("resize" + h)
				}), x("Resize" + n, t.resizeImage), t.isLowIE && x("AfterChange", t.resizeImage)
			},
			resizeImage: function() {
				var e = t.currItem;
				if (e && e.img && t.st.image.verticalFit) {
					var n = 0;
					t.isLowIE && (n = parseInt(e.img.css("padding-top"), 10) + parseInt(e.img.css("padding-bottom"), 10)), e.img.css("max-height", t.wH - n)
				}
			},
			_onImageHasSize: function(e) {
				e.img && (e.hasSize = !0, D && clearInterval(D), e.isCheckingImgSize = !1, k("ImageHasSize", e), e.imgHidden && (t.content && t.content.removeClass("mfp-loading"), e.imgHidden = !1))
			},
			findImageSize: function(e) {
				var n = 0,
					i = e.img[0];
				! function o(r) {
					D && clearInterval(D), D = setInterval(function() {
						return i.naturalWidth > 0 ? void t._onImageHasSize(e) : (n > 200 && clearInterval(D), n++, void(3 === n ? o(10) : 40 === n ? o(50) : 100 === n && o(500)))
					}, r)
				}(1)
			},
			getImage: function(n, i) {
				var o = 0,
					r = function e() {
						n && (n.img[0].complete ? (n.img.off(".mfploader"), n === t.currItem && (t._onImageHasSize(n), t.updateStatus("ready")), n.hasSize = !0, n.loaded = !0, k("ImageLoadComplete")) : (o++, 200 > o ? setTimeout(e, 100) : s()))
					},
					s = function() {
						n && (n.img.off(".mfploader"), n === t.currItem && (t._onImageHasSize(n), t.updateStatus("error", a.tError.replace("%url%", n.src))), n.hasSize = !0, n.loaded = !0, n.loadError = !0)
					},
					a = t.st.image,
					l = i.find(".mfp-img");
				if (l.length) {
					var c = document.createElement("img");
					c.className = "mfp-img", n.el && n.el.find("img").length && (c.alt = n.el.find("img").attr("alt")), n.img = e(c).on("load.mfploader", r).on("error.mfploader", s), c.src = n.src, l.is("img") && (n.img = n.img.clone()), c = n.img[0], c.naturalWidth > 0 ? n.hasSize = !0 : c.width || (n.hasSize = !1)
				}
				return t._parseMarkup(i, {
					title: j(n),
					img_replaceWith: n.img
				}, n), t.resizeImage(), n.hasSize ? (D && clearInterval(D), n.loadError ? (i.addClass("mfp-loading"), t.updateStatus("error", a.tError.replace("%url%", n.src))) : (i.removeClass("mfp-loading"), t.updateStatus("ready")), i) : (t.updateStatus("loading"), n.loading = !0, n.hasSize || (n.imgHidden = !0, i.addClass("mfp-loading"), t.findImageSize(n)), i)
			}
		}
	});
	var I, z = function() {
		return void 0 === I && (I = void 0 !== document.createElement("p").style.MozTransform), I
	};
	e.magnificPopup.registerModule("zoom", {
		options: {
			enabled: !1,
			easing: "ease-in-out",
			duration: 300,
			opener: function(e) {
				return e.is("img") ? e : e.find("img")
			}
		},
		proto: {
			initZoom: function() {
				var e, n = t.st.zoom,
					i = ".zoom";
				if (n.enabled && t.supportsTransition) {
					var o, r, s = n.duration,
						a = function(e) {
							var t = e.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),
								i = "all " + n.duration / 1e3 + "s " + n.easing,
								o = {
									position: "fixed",
									zIndex: 9999,
									left: 0,
									top: 0,
									"-webkit-backface-visibility": "hidden"
								},
								r = "transition";
							return o["-webkit-" + r] = o["-moz-" + r] = o["-o-" + r] = o[r] = i, t.css(o), t
						},
						d = function() {
							t.content.css("visibility", "visible")
						};
					x("BuildControls" + i, function() {
						if (t._allowZoom()) {
							if (clearTimeout(o), t.content.css("visibility", "hidden"), !(e = t._getItemToZoom())) return void d();
							r = a(e), r.css(t._getOffset()), t.wrap.append(r), o = setTimeout(function() {
								r.css(t._getOffset(!0)), o = setTimeout(function() {
									d(), setTimeout(function() {
										r.remove(), e = r = null, k("ZoomAnimationEnded")
									}, 16)
								}, s)
							}, 16)
						}
					}), x(c + i, function() {
						if (t._allowZoom()) {
							if (clearTimeout(o), t.st.removalDelay = s, !e) {
								if (!(e = t._getItemToZoom())) return;
								r = a(e)
							}
							r.css(t._getOffset(!0)), t.wrap.append(r), t.content.css("visibility", "hidden"), setTimeout(function() {
								r.css(t._getOffset())
							}, 16)
						}
					}), x(l + i, function() {
						t._allowZoom() && (d(), r && r.remove(), e = null)
					})
				}
			},
			_allowZoom: function() {
				return "image" === t.currItem.type
			},
			_getItemToZoom: function() {
				return !!t.currItem.hasSize && t.currItem.img
			},
			_getOffset: function(n) {
				var i;
				i = n ? t.currItem.img : t.st.zoom.opener(t.currItem.el || t.currItem);
				var o = i.offset(),
					r = parseInt(i.css("padding-top"), 10),
					s = parseInt(i.css("padding-bottom"), 10);
				o.top -= e(window).scrollTop() - r;
				var a = {
					width: i.width(),
					height: (w ? i.innerHeight() : i[0].offsetHeight) - s - r
				};
				return z() ? a["-moz-transform"] = a.transform = "translate(" + o.left + "px," + o.top + "px)" : (a.left = o.left, a.top = o.top), a
			}
		}
	});
	var F = "iframe",
		q = function(e) {
			if (t.currTemplate[F]) {
				var n = t.currTemplate[F].find("iframe");
				n.length && (e || (n[0].src = "//about:blank"), t.isIE8 && n.css("display", e ? "block" : "none"))
			}
		};
	e.magnificPopup.registerModule(F, {
		options: {
			markup: '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',
			srcAction: "iframe_src",
			patterns: {
				youtube: {
					index: "youtube.com",
					id: "v=",
					src: "//www.youtube.com/embed/%id%?autoplay=1"
				},
				vimeo: {
					index: "vimeo.com/",
					id: "/",
					src: "//player.vimeo.com/video/%id%?autoplay=1"
				},
				gmaps: {
					index: "//maps.google.",
					src: "%id%&output=embed"
				}
			}
		},
		proto: {
			initIframe: function() {
				t.types.push(F), x("BeforeChange", function(e, t, n) {
					t !== n && (t === F ? q() : n === F && q(!0))
				}), x(l + "." + F, function() {
					q()
				})
			},
			getIframe: function(n, i) {
				var o = n.src,
					r = t.st.iframe;
				e.each(r.patterns, function() {
					return o.indexOf(this.index) > -1 ? (this.id && (o = "string" == typeof this.id ? o.substr(o.lastIndexOf(this.id) + this.id.length, o.length) : this.id.call(this, o)), o = this.src.replace("%id%", o), !1) : void 0
				});
				var s = {};
				return r.srcAction && (s[r.srcAction] = o), t._parseMarkup(i, s, n), t.updateStatus("ready"), i
			}
		}
	});
	var B = function(e) {
			var n = t.items.length;
			return e > n - 1 ? e - n : 0 > e ? n + e : e
		},
		R = function(e, t, n) {
			return e.replace(/%curr%/gi, t + 1).replace(/%total%/gi, n)
		};
	e.magnificPopup.registerModule("gallery", {
		options: {
			enabled: !1,
			arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
			preload: [0, 2],
			navigateByImgClick: !0,
			arrows: !0,
			tPrev: "Previous (Left arrow key)",
			tNext: "Next (Right arrow key)",
			tCounter: "%curr% of %total%"
		},
		proto: {
			initGallery: function() {
				var n = t.st.gallery,
					i = ".mfp-gallery",
					r = Boolean(e.fn.mfpFastClick);
				return t.direction = !0, !(!n || !n.enabled) && (s += " mfp-gallery", x(u + i, function() {
					n.navigateByImgClick && t.wrap.on("click" + i, ".mfp-img", function() {
						return t.items.length > 1 ? (t.next(), !1) : void 0
					}), o.on("keydown" + i, function(e) {
						37 === e.keyCode ? t.prev() : 39 === e.keyCode && t.next()
					})
				}), x("UpdateStatus" + i, function(e, n) {
					n.text && (n.text = R(n.text, t.currItem.index, t.items.length))
				}), x(d + i, function(e, i, o, r) {
					var s = t.items.length;
					o.counter = s > 1 ? R(n.tCounter, r.index, s) : ""
				}), x("BuildControls" + i, function() {
					if (t.items.length > 1 && n.arrows && !t.arrowLeft) {
						var i = n.arrowMarkup,
							o = t.arrowLeft = e(i.replace(/%title%/gi, n.tPrev).replace(/%dir%/gi, "left")).addClass(v),
							s = t.arrowRight = e(i.replace(/%title%/gi, n.tNext).replace(/%dir%/gi, "right")).addClass(v),
							a = r ? "mfpFastClick" : "click";
						o[a](function() {
							t.prev()
						}), s[a](function() {
							t.next()
						}), t.isIE7 && (T("b", o[0], !1, !0), T("a", o[0], !1, !0), T("b", s[0], !1, !0), T("a", s[0], !1, !0)), t.container.append(o.add(s))
					}
				}), x(p + i, function() {
					t._preloadTimeout && clearTimeout(t._preloadTimeout), t._preloadTimeout = setTimeout(function() {
						t.preloadNearbyImages(), t._preloadTimeout = null
					}, 16)
				}), void x(l + i, function() {
					o.off(i), t.wrap.off("click" + i), t.arrowLeft && r && t.arrowLeft.add(t.arrowRight).destroyMfpFastClick(), t.arrowRight = t.arrowLeft = null
				}))
			},
			next: function() {
				t.direction = !0, t.index = B(t.index + 1), t.updateItemHTML()
			},
			prev: function() {
				t.direction = !1, t.index = B(t.index - 1), t.updateItemHTML()
			},
			goTo: function(e) {
				t.direction = e >= t.index, t.index = e, t.updateItemHTML()
			},
			preloadNearbyImages: function() {
				var e, n = t.st.gallery.preload,
					i = Math.min(n[0], t.items.length),
					o = Math.min(n[1], t.items.length);
				for (e = 1;
					(t.direction ? o : i) >= e; e++) t._preloadItem(t.index + e);
				for (e = 1;
					(t.direction ? i : o) >= e; e++) t._preloadItem(t.index - e)
			},
			_preloadItem: function(n) {
				if (n = B(n), !t.items[n].preloaded) {
					var i = t.items[n];
					i.parsed || (i = t.parseEl(n)), k("LazyLoad", i), "image" === i.type && (i.img = e('<img class="mfp-img" />').on("load.mfploader", function() {
						i.hasSize = !0
					}).on("error.mfploader", function() {
						i.hasSize = !0, i.loadError = !0, k("LazyLoadError", i)
					}).attr("src", i.src)), i.preloaded = !0
				}
			}
		}
	});
	var W = "retina";
	e.magnificPopup.registerModule(W, {
			options: {
				replaceSrc: function(e) {
					return e.src.replace(/\.\w+$/, function(e) {
						return "@2x" + e
					})
				},
				ratio: 1
			},
			proto: {
				initRetina: function() {
					if (window.devicePixelRatio > 1) {
						var e = t.st.retina,
							n = e.ratio;
						(n = isNaN(n) ? n() : n) > 1 && (x("ImageHasSize." + W, function(e, t) {
							t.img.css({
								"max-width": t.img[0].naturalWidth / n,
								width: "100%"
							})
						}), x("ElementParse." + W, function(t, i) {
							i.src = e.replaceSrc(i, n)
						}))
					}
				}
			}
		}),
		function() {
			var t = "ontouchstart" in window,
				n = function() {
					b.off("touchmove" + i + " touchend" + i)
				},
				i = ".mfpFastClick";
			e.fn.mfpFastClick = function(o) {
				return e(this).each(function() {
					var r, s = e(this);
					if (t) {
						var a, l, c, d, u, p;
						s.on("touchstart" + i, function(e) {
							d = !1, p = 1, u = e.originalEvent ? e.originalEvent.touches[0] : e.touches[0], l = u.clientX, c = u.clientY, b.on("touchmove" + i, function(e) {
								u = e.originalEvent ? e.originalEvent.touches : e.touches, p = u.length, u = u[0], (Math.abs(u.clientX - l) > 10 || Math.abs(u.clientY - c) > 10) && (d = !0, n())
							}).on("touchend" + i, function(e) {
								n(), d || p > 1 || (r = !0, e.preventDefault(), clearTimeout(a), a = setTimeout(function() {
									r = !1
								}, 1e3), o())
							})
						})
					}
					s.on("click" + i, function() {
						r || o()
					})
				})
			}, e.fn.destroyMfpFastClick = function() {
				e(this).off("touchstart" + i + " click" + i), t && b.off("touchmove" + i + " touchend" + i)
			}
		}(), C()
}),
function() {
	function e(e) {
		if (void 0 === e) throw new Error('Pathformer [constructor]: "element" parameter is required');
		if (e.constructor === String && !(e = document.getElementById(e))) throw new Error('Pathformer [constructor]: "element" parameter is not related to an existing ID');
		if (!(e instanceof window.SVGElement || e instanceof window.SVGGElement || /^svg$/i.test(e.nodeName))) throw new Error('Pathformer [constructor]: "element" parameter must be a string or a SVGelement');
		this.el = e, this.scan(e)
	}

	function t(e, t, i) {
		n(), this.isReady = !1, this.setElement(e, t), this.setOptions(t), this.setCallback(i), this.isReady && this.init()
	}
	e.prototype.TYPES = ["line", "ellipse", "circle", "polygon", "polyline", "rect"], e.prototype.ATTR_WATCH = ["cx", "cy", "points", "r", "rx", "ry", "x", "x1", "x2", "y", "y1", "y2"], e.prototype.scan = function(e) {
		for (var t, n, i, o, r = e.querySelectorAll(this.TYPES.join(",")), s = 0; s < r.length; s++) n = r[s], t = this[n.tagName.toLowerCase() + "ToPath"], i = t(this.parseAttr(n.attributes)), o = this.pathMaker(n, i), n.parentNode.replaceChild(o, n)
	}, e.prototype.lineToPath = function(e) {
		var t = {},
			n = e.x1 || 0,
			i = e.y1 || 0,
			o = e.x2 || 0,
			r = e.y2 || 0;
		return t.d = "M" + n + "," + i + "L" + o + "," + r, t
	}, e.prototype.rectToPath = function(e) {
		var t = {},
			n = parseFloat(e.x) || 0,
			i = parseFloat(e.y) || 0,
			o = parseFloat(e.width) || 0,
			r = parseFloat(e.height) || 0;
		if (e.rx || e.ry) {
			var s = parseInt(e.rx, 10) || -1,
				a = parseInt(e.ry, 10) || -1;
			s = Math.min(Math.max(0 > s ? a : s, 0), o / 2), a = Math.min(Math.max(0 > a ? s : a, 0), r / 2), t.d = "M " + (n + s) + "," + i + " L " + (n + o - s) + "," + i + " A " + s + "," + a + ",0,0,1," + (n + o) + "," + (i + a) + " L " + (n + o) + "," + (i + r - a) + " A " + s + "," + a + ",0,0,1," + (n + o - s) + "," + (i + r) + " L " + (n + s) + "," + (i + r) + " A " + s + "," + a + ",0,0,1," + n + "," + (i + r - a) + " L " + n + "," + (i + a) + " A " + s + "," + a + ",0,0,1," + (n + s) + "," + i
		} else t.d = "M" + n + " " + i + " L" + (n + o) + " " + i + " L" + (n + o) + " " + (i + r) + " L" + n + " " + (i + r) + " Z";
		return t
	}, e.prototype.polylineToPath = function(e) {
		var t, n, i = {},
			o = e.points.trim().split(" ");
		if (-1 === e.points.indexOf(",")) {
			var r = [];
			for (t = 0; t < o.length; t += 2) r.push(o[t] + "," + o[t + 1]);
			o = r
		}
		for (n = "M" + o[0], t = 1; t < o.length; t++) - 1 !== o[t].indexOf(",") && (n += "L" + o[t]);
		return i.d = n, i
	}, e.prototype.polygonToPath = function(t) {
		var n = e.prototype.polylineToPath(t);
		return n.d += "Z", n
	}, e.prototype.ellipseToPath = function(e) {
		var t = {},
			n = parseFloat(e.rx) || 0,
			i = parseFloat(e.ry) || 0,
			o = parseFloat(e.cx) || 0,
			r = parseFloat(e.cy) || 0,
			s = o - n,
			a = r,
			l = parseFloat(o) + parseFloat(n),
			c = r;
		return t.d = "M" + s + "," + a + "A" + n + "," + i + " 0,1,1 " + l + "," + c + "A" + n + "," + i + " 0,1,1 " + s + "," + c, t
	}, e.prototype.circleToPath = function(e) {
		var t = {},
			n = parseFloat(e.r) || 0,
			i = parseFloat(e.cx) || 0,
			o = parseFloat(e.cy) || 0,
			r = i - n,
			s = o,
			a = parseFloat(i) + parseFloat(n),
			l = o;
		return t.d = "M" + r + "," + s + "A" + n + "," + n + " 0,1,1 " + a + "," + l + "A" + n + "," + n + " 0,1,1 " + r + "," + l, t
	}, e.prototype.pathMaker = function(e, t) {
		var n, i, o = document.createElementNS("http://www.w3.org/2000/svg", "path");
		for (n = 0; n < e.attributes.length; n++) i = e.attributes[n], -1 === this.ATTR_WATCH.indexOf(i.name) && o.setAttribute(i.name, i.value);
		for (n in t) o.setAttribute(n, t[n]);
		return o
	}, e.prototype.parseAttr = function(e) {
		for (var t, n = {}, i = 0; i < e.length; i++) {
			if (t = e[i], -1 !== this.ATTR_WATCH.indexOf(t.name) && -1 !== t.value.indexOf("%")) throw new Error("Pathformer [parseAttr]: a SVG shape got values in percentage. This cannot be transformed into 'path' tags. Please use 'viewBox'.");
			n[t.name] = t.value
		}
		return n
	};
	var n, i, o, r;
	t.LINEAR = function(e) {
		return e
	}, t.EASE = function(e) {
		return -Math.cos(e * Math.PI) / 2 + .5
	}, t.EASE_OUT = function(e) {
		return 1 - Math.pow(1 - e, 3)
	}, t.EASE_IN = function(e) {
		return Math.pow(e, 3)
	}, t.EASE_OUT_BOUNCE = function(e) {
		var t = 1 - Math.cos(.5 * e * Math.PI),
			n = Math.pow(t, 1.5),
			i = Math.pow(1 - e, 2);
		return 1 - i + (1 - Math.abs(Math.cos(2.5 * n * Math.PI))) * i
	}, t.prototype.setElement = function(e, t) {
		var n, i;
		if (void 0 === e) throw new Error('Vivus [constructor]: "element" parameter is required');
		if (e.constructor === String && !(e = document.getElementById(e))) throw new Error('Vivus [constructor]: "element" parameter is not related to an existing ID');
		if (this.parentEl = e, t && t.file) {
			var i = this;
			n = function() {
				var e = document.createElement("div");
				e.innerHTML = this.responseText;
				var n = e.querySelector("svg");
				if (!n) throw new Error("Vivus [load]: Cannot find the SVG in the loaded file : " + t.file);
				i.el = n, i.el.setAttribute("width", "100%"), i.el.setAttribute("height", "100%"), i.parentEl.appendChild(i.el), i.isReady = !0, i.init(), i = null
			};
			var o = new window.XMLHttpRequest;
			return o.addEventListener("load", n), o.open("GET", t.file), void o.send()
		}
		switch (e.constructor) {
			case window.SVGSVGElement:
			case window.SVGElement:
			case window.SVGGElement:
				this.el = e, this.isReady = !0;
				break;
			case window.HTMLObjectElement:
				i = this, (n = function(t) {
					if (!i.isReady) {
						if (i.el = e.contentDocument && e.contentDocument.querySelector("svg"), !i.el && t) throw new Error("Vivus [constructor]: object loaded does not contain any SVG");
						i.el && (e.getAttribute("built-by-vivus") && (i.parentEl.insertBefore(i.el, e), i.parentEl.removeChild(e), i.el.setAttribute("width", "100%"), i.el.setAttribute("height", "100%")), i.isReady = !0, i.init(), i = null)
					}
				})() || e.addEventListener("load", n);
				break;
			default:
				throw new Error('Vivus [constructor]: "element" parameter is not valid (or miss the "file" attribute)')
		}
	}, t.prototype.setOptions = function(e) {
		var n = ["delayed", "sync", "async", "nsync", "oneByOne", "scenario", "scenario-sync"],
			i = ["inViewport", "manual", "autostart"];
		if (void 0 !== e && e.constructor !== Object) throw new Error('Vivus [constructor]: "options" parameter must be an object');
		if (e = e || {}, e.type && -1 === n.indexOf(e.type)) throw new Error("Vivus [constructor]: " + e.type + " is not an existing animation `type`");
		if (this.type = e.type || n[0], e.start && -1 === i.indexOf(e.start)) throw new Error("Vivus [constructor]: " + e.start + " is not an existing `start` option");
		if (this.start = e.start || i[0], this.isIE = -1 !== window.navigator.userAgent.indexOf("MSIE") || -1 !== window.navigator.userAgent.indexOf("Trident/") || -1 !== window.navigator.userAgent.indexOf("Edge/"), this.duration = r(e.duration, 120), this.delay = r(e.delay, null), this.dashGap = r(e.dashGap, 1), this.forceRender = e.hasOwnProperty("forceRender") ? !!e.forceRender : this.isIE, this.reverseStack = !!e.reverseStack, this.selfDestroy = !!e.selfDestroy, this.onReady = e.onReady, this.map = [], this.frameLength = this.currentFrame = this.delayUnit = this.speed = this.handle = null, this.ignoreInvisible = !!e.hasOwnProperty("ignoreInvisible") && !!e.ignoreInvisible, this.animTimingFunction = e.animTimingFunction || t.LINEAR, this.pathTimingFunction = e.pathTimingFunction || t.LINEAR, this.delay >= this.duration) throw new Error("Vivus [constructor]: delay must be shorter than duration")
	}, t.prototype.setCallback = function(e) {
		if (e && e.constructor !== Function) throw new Error('Vivus [constructor]: "callback" parameter must be a function');
		this.callback = e || function() {}
	}, t.prototype.mapping = function() {
		var e, t, n, i, o, s, a, l;
		for (l = s = a = 0, t = this.el.querySelectorAll("path"), e = 0; e < t.length; e++) n = t[e], this.isInvisible(n) || (o = {
			el: n,
			length: Math.ceil(n.getTotalLength())
		}, isNaN(o.length) ? window.console && console.warn && console.warn("Vivus [mapping]: cannot retrieve a path element length", n) : (this.map.push(o), n.style.strokeDasharray = o.length + " " + (o.length + 2 * this.dashGap), n.style.strokeDashoffset = o.length + this.dashGap, o.length += this.dashGap, s += o.length, this.renderPath(e)));
		for (s = 0 === s ? 1 : s, this.delay = null === this.delay ? this.duration / 3 : this.delay, this.delayUnit = this.delay / (t.length > 1 ? t.length - 1 : 1), this.reverseStack && this.map.reverse(), e = 0; e < this.map.length; e++) {
			switch (o = this.map[e], this.type) {
				case "delayed":
					o.startAt = this.delayUnit * e, o.duration = this.duration - this.delay;
					break;
				case "oneByOne":
					o.startAt = a / s * this.duration, o.duration = o.length / s * this.duration;
					break;
				case "sync":
				case "async":
				case "nsync":
					o.startAt = 0, o.duration = this.duration;
					break;
				case "scenario-sync":
					n = o.el, i = this.parseAttr(n), o.startAt = l + (r(i["data-delay"], this.delayUnit) || 0), o.duration = r(i["data-duration"], this.duration), l = void 0 !== i["data-async"] ? o.startAt : o.startAt + o.duration, this.frameLength = Math.max(this.frameLength, o.startAt + o.duration);
					break;
				case "scenario":
					n = o.el, i = this.parseAttr(n), o.startAt = r(i["data-start"], this.delayUnit) || 0, o.duration = r(i["data-duration"], this.duration), this.frameLength = Math.max(this.frameLength, o.startAt + o.duration)
			}
			a += o.length, this.frameLength = this.frameLength || this.duration
		}
	}, t.prototype.drawer = function() {
		var e = this;
		if (this.currentFrame += this.speed, this.currentFrame <= 0) this.stop(), this.reset();
		else {
			if (!(this.currentFrame >= this.frameLength)) return this.trace(), void(this.handle = i(function() {
				e.drawer()
			}));
			this.stop(), this.currentFrame = this.frameLength, this.trace(), this.selfDestroy && this.destroy()
		}
		this.callback(this), this.instanceCallback && (this.instanceCallback(this), this.instanceCallback = null)
	}, t.prototype.trace = function() {
		var e, t, n, i;
		for (i = this.animTimingFunction(this.currentFrame / this.frameLength) * this.frameLength, e = 0; e < this.map.length; e++) n = this.map[e], t = (i - n.startAt) / n.duration, t = this.pathTimingFunction(Math.max(0, Math.min(1, t))), n.progress !== t && (n.progress = t, n.el.style.strokeDashoffset = Math.floor(n.length * (1 - t)), this.renderPath(e))
	}, t.prototype.renderPath = function(e) {
		if (this.forceRender && this.map && this.map[e]) {
			var t = this.map[e],
				n = t.el.cloneNode(!0);
			t.el.parentNode.replaceChild(n, t.el), t.el = n
		}
	}, t.prototype.init = function() {
		this.frameLength = 0, this.currentFrame = 0, this.map = [], new e(this.el), this.mapping(), this.starter(), this.onReady && this.onReady(this)
	}, t.prototype.starter = function() {
		switch (this.start) {
			case "manual":
				return;
			case "autostart":
				this.play();
				break;
			case "inViewport":
				var e = this,
					t = function t() {
						e.isInViewport(e.parentEl, 1) && (e.play(), window.removeEventListener("scroll", t))
					};
				window.addEventListener("scroll", t), t()
		}
	}, t.prototype.getStatus = function() {
		return 0 === this.currentFrame ? "start" : this.currentFrame === this.frameLength ? "end" : "progress"
	}, t.prototype.reset = function() {
		return this.setFrameProgress(0)
	}, t.prototype.finish = function() {
		return this.setFrameProgress(1)
	}, t.prototype.setFrameProgress = function(e) {
		return e = Math.min(1, Math.max(0, e)), this.currentFrame = Math.round(this.frameLength * e), this.trace(), this
	}, t.prototype.play = function(e, t) {
		if (this.instanceCallback = null, e && "function" == typeof e) this.instanceCallback = e, e = null;
		else if (e && "number" != typeof e) throw new Error("Vivus [play]: invalid speed");
		return t && "function" == typeof t && !this.instanceCallback && (this.instanceCallback = t), this.speed = e || 1, this.handle || this.drawer(), this
	}, t.prototype.stop = function() {
		return this.handle && (o(this.handle), this.handle = null), this
	}, t.prototype.destroy = function() {
		this.stop();
		var e, t;
		for (e = 0; e < this.map.length; e++) t = this.map[e], t.el.style.strokeDashoffset = null, t.el.style.strokeDasharray = null, this.renderPath(e)
	}, t.prototype.isInvisible = function(e) {
		var t, n = e.getAttribute("data-ignore");
		return null !== n ? "false" !== n : !!this.ignoreInvisible && (t = e.getBoundingClientRect(), !t.width && !t.height)
	}, t.prototype.parseAttr = function(e) {
		var t, n = {};
		if (e && e.attributes)
			for (var i = 0; i < e.attributes.length; i++) t = e.attributes[i], n[t.name] = t.value;
		return n
	}, t.prototype.isInViewport = function(e, t) {
		var n = this.scrollY(),
			i = n + this.getViewportH(),
			o = e.getBoundingClientRect(),
			r = o.height,
			s = n + o.top,
			a = s + r;
		return t = t || 0, i >= s + r * t && a >= n
	}, t.prototype.getViewportH = function() {
		var e = this.docElem.clientHeight,
			t = window.innerHeight;
		return t > e ? t : e
	}, t.prototype.scrollY = function() {
		return window.pageYOffset || this.docElem.scrollTop
	}, n = function() {
		t.prototype.docElem || (t.prototype.docElem = window.document.documentElement, i = function() {
			return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function(e) {
				return window.setTimeout(e, 1e3 / 60)
			}
		}(), o = function() {
			return window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || window.oCancelAnimationFrame || window.msCancelAnimationFrame || function(e) {
				return window.clearTimeout(e)
			}
		}())
	}, r = function(e, t) {
		var n = parseInt(e, 10);
		return n >= 0 ? n : t
	}, "function" == typeof define && define.amd ? define([], function() {
		return t
	}) : "object" == ("undefined" == typeof exports ? "undefined" : _typeof(exports)) ? module.exports = t : window.Vivus = t
}(),
function(e) {
	window.cash = function() {
		function e(e, t) {
			return t = t || $, j.test(e) ? t.getElementsByClassName(e.slice(1)) : z.test(e) ? t.getElementsByTagName(e) : t.querySelectorAll(e)
		}

		function t(e) {
			if (!E) {
				E = $.implementation.createHTMLDocument(null);
				var t = E.createElement("base");
				t.href = $.location.href, E.head.appendChild(t)
			}
			return E.body.innerHTML = e, E.body.childNodes
		}

		function n(e) {
			"loading" !== $.readyState ? e() : $.addEventListener("DOMContentLoaded", e)
		}

		function i(i, o) {
			if (!i) return this;
			if (i.cash && i !== A) return i;
			var r, s = i,
				a = 0;
			if (H(i)) s = D.test(i) ? $.getElementById(i.slice(1)) : I.test(i) ? t(i) : e(i, o);
			else if (O(i)) return n(i), this;
			if (!s) return this;
			if (s.nodeType || s === A) this[0] = s, this.length = 1;
			else
				for (r = this.length = s.length; a < r; a++) this[a] = s[a];
			return this
		}

		function o(e, t) {
			return new i(e, t)
		}

		function r(e, t) {
			for (var n = e.length, i = 0; i < n && !1 !== t.call(e[i], e[i], i, e); i++);
		}

		function s(e, t) {
			var n = e && (e.matches || e.webkitMatchesSelector || e.mozMatchesSelector || e.msMatchesSelector || e.oMatchesSelector);
			return !!n && n.call(e, t)
		}

		function a(e) {
			return H(e) ? s : e.cash ? function(t) {
				return e.is(t)
			} : function(e, t) {
				return e === t
			}
		}

		function l(e) {
			return o(_.call(e).filter(function(e, t, n) {
				return n.indexOf(e) === t
			}))
		}

		function c(e) {
			return e[q] = e[q] || {}
		}

		function d(e, t, n) {
			return c(e)[t] = n
		}

		function u(e, t) {
			var n = c(e);
			return void 0 === n[t] && (n[t] = e.dataset ? e.dataset[t] : o(e).attr("data-" + t)), n[t]
		}

		function p(e, t) {
			var n = c(e);
			n ? delete n[t] : e.dataset ? delete e.dataset[t] : o(e).removeAttr("data-" + name)
		}

		function f(e) {
			return H(e) && e.match(B)
		}

		function h(e, t) {
			return e.classList ? e.classList.contains(t) : new RegExp("(^| )" + t + "( |$)", "gi").test(e.className)
		}

		function m(e, t, n) {
			e.classList ? e.classList.add(t) : n.indexOf(" " + t + " ") && (e.className += " " + t)
		}

		function g(e, t) {
			e.classList ? e.classList.remove(t) : e.className = e.className.replace(t, "")
		}

		function v(e, t) {
			return parseInt(A.getComputedStyle(e[0], null)[t], 10) || 0
		}

		function y(e, t, n) {
			var i = u(e, "_cashEvents") || d(e, "_cashEvents", {});
			i[t] = i[t] || [], i[t].push(n), e.addEventListener(t, n)
		}

		function w(e, t, n) {
			var i, o = u(e, "_cashEvents"),
				s = o && o[t];
			s && (n ? (e.removeEventListener(t, n), (i = s.indexOf(n)) >= 0 && s.splice(i, 1)) : (r(s, function(n) {
				e.removeEventListener(t, n)
			}), s = []))
		}

		function b(e, t) {
			return "&" + encodeURIComponent(e) + "=" + encodeURIComponent(t).replace(/%20/g, "+")
		}

		function x(e) {
			var t = [];
			return r(e.options, function(e) {
				e.selected && t.push(e.value)
			}), t.length ? t : null
		}

		function T(e) {
			var t = e.selectedIndex;
			return t >= 0 ? e.options[t].value : null
		}

		function k(e) {
			var t = e.type;
			if (!t) return null;
			switch (t.toLowerCase()) {
				case "select-one":
					return T(e);
				case "select-multiple":
					return x(e);
				case "radio":
				case "checkbox":
					return e.checked ? e.value : null;
				default:
					return e.value ? e.value : null
			}
		}

		function S(e, t, n) {
			if (n) {
				var i = e.childNodes[0];
				e.insertBefore(t, i)
			} else e.appendChild(t)
		}

		function C(e, t, n) {
			var i = H(t);
			if (!i && t.length) return void r(t, function(t) {
				return C(e, t, n)
			});
			r(e, i ? function(e) {
				return e.insertAdjacentHTML(n ? "afterbegin" : "beforeend", t)
			} : function(e, i) {
				return S(e, 0 === i ? t : t.cloneNode(!0), n)
			})
		}
		var E, $ = document,
			A = window,
			M = Array.prototype,
			_ = M.slice,
			P = M.filter,
			N = M.push,
			L = function() {},
			O = function(e) {
				return _typeof(e) === _typeof(L) && e.call
			},
			H = function(e) {
				return _typeof(e) === _typeof("")
			},
			D = /^#[\w-]*$/,
			j = /^\.[\w-]*$/,
			I = /<.+>/,
			z = /^\w+$/,
			F = o.fn = o.prototype = i.prototype = {
				cash: !0,
				length: 0,
				push: N,
				splice: M.splice,
				map: M.map,
				init: i
			};
		Object.defineProperty(F, "constructor", {
			value: o
		}), o.parseHTML = t, o.noop = L, o.isFunction = O, o.isString = H, o.extend = F.extend = function(e) {
			e = e || {};
			var t = _.call(arguments),
				n = t.length,
				i = 1;
			for (1 === t.length && (e = this, i = 0); i < n; i++)
				if (t[i])
					for (var o in t[i]) t[i].hasOwnProperty(o) && (e[o] = t[i][o]);
			return e
		}, o.extend({
			merge: function(e, t) {
				for (var n = +t.length, i = e.length, o = 0; o < n; i++, o++) e[i] = t[o];
				return e.length = i, e
			},
			each: r,
			matches: s,
			unique: l,
			isArray: Array.isArray,
			isNumeric: function(e) {
				return !isNaN(parseFloat(e)) && isFinite(e)
			}
		});
		var q = o.uid = "_cash" + Date.now();
		F.extend({
			data: function(e, t) {
				if (H(e)) return void 0 === t ? u(this[0], e) : this.each(function(n) {
					return d(n, e, t)
				});
				for (var n in e) this.data(n, e[n]);
				return this
			},
			removeData: function(e) {
				return this.each(function(t) {
					return p(t, e)
				})
			}
		});
		var B = /\S+/g;
		F.extend({
			addClass: function(e) {
				var t = f(e);
				return t ? this.each(function(e) {
					var n = " " + e.className + " ";
					r(t, function(t) {
						m(e, t, n)
					})
				}) : this
			},
			attr: function(e, t) {
				if (e) {
					if (H(e)) return void 0 === t ? this[0] ? this[0].getAttribute ? this[0].getAttribute(e) : this[0][e] : void 0 : this.each(function(n) {
						n.setAttribute ? n.setAttribute(e, t) : n[e] = t
					});
					for (var n in e) this.attr(n, e[n]);
					return this
				}
			},
			hasClass: function(e) {
				var t = !1,
					n = f(e);
				return n && n.length && this.each(function(e) {
					return !(t = h(e, n[0]))
				}), t
			},
			prop: function(e, t) {
				if (H(e)) return void 0 === t ? this[0][e] : this.each(function(n) {
					n[e] = t
				});
				for (var n in e) this.prop(n, e[n]);
				return this
			},
			removeAttr: function(e) {
				return this.each(function(t) {
					t.removeAttribute ? t.removeAttribute(e) : delete t[e]
				})
			},
			removeClass: function(e) {
				if (!arguments.length) return this.attr("class", "");
				var t = f(e);
				return t ? this.each(function(e) {
					r(t, function(t) {
						g(e, t)
					})
				}) : this
			},
			removeProp: function(e) {
				return this.each(function(t) {
					delete t[e]
				})
			},
			toggleClass: function(e, t) {
				if (void 0 !== t) return this[t ? "addClass" : "removeClass"](e);
				var n = f(e);
				return n ? this.each(function(e) {
					var t = " " + e.className + " ";
					r(n, function(n) {
						h(e, n) ? g(e, n) : m(e, n, t)
					})
				}) : this
			}
		}), F.extend({
			add: function(e, t) {
				return l(o.merge(this, o(e, t)))
			},
			each: function(e) {
				return r(this, e), this
			},
			eq: function(e) {
				return o(this.get(e))
			},
			filter: function(e) {
				if (!e) return this;
				var t = O(e) ? e : a(e);
				return o(P.call(this, function(n) {
					return t(n, e)
				}))
			},
			first: function() {
				return this.eq(0)
			},
			get: function(e) {
				return void 0 === e ? _.call(this) : e < 0 ? this[e + this.length] : this[e]
			},
			index: function(e) {
				var t = e ? o(e)[0] : this[0],
					n = e ? this : o(t).parent().children();
				return _.call(n).indexOf(t)
			},
			last: function() {
				return this.eq(-1)
			}
		});
		var R = function() {
				var e = /(?:^\w|[A-Z]|\b\w)/g,
					t = /[\s-_]+/g;
				return function(n) {
					return n.replace(e, function(e, t) {
						return e[0 === t ? "toLowerCase" : "toUpperCase"]()
					}).replace(t, "")
				}
			}(),
			W = function() {
				var e = {},
					t = document,
					n = t.createElement("div"),
					i = n.style;
				return function(t) {
					if (t = R(t), e[t]) return e[t];
					var n = t.charAt(0).toUpperCase() + t.slice(1);
					return r((t + " " + ["webkit", "moz", "ms", "o"].join(n + " ") + n).split(" "), function(n) {
						if (n in i) return e[n] = t = e[t] = n, !1
					}), e[t]
				}
			}();
		o.prefixedProp = W, o.camelCase = R, F.extend({
			css: function(e, t) {
				if (H(e)) return e = W(e), arguments.length > 1 ? this.each(function(n) {
					return n.style[e] = t
				}) : A.getComputedStyle(this[0])[e];
				for (var n in e) this.css(n, e[n]);
				return this
			}
		}), r(["Width", "Height"], function(e) {
			var t = e.toLowerCase();
			F[t] = function() {
				return this[0].getBoundingClientRect()[t]
			}, F["inner" + e] = function() {
				return this[0]["client" + e]
			}, F["outer" + e] = function(t) {
				return this[0]["offset" + e] + (t ? v(this, "margin" + ("Width" === e ? "Left" : "Top")) + v(this, "margin" + ("Width" === e ? "Right" : "Bottom")) : 0)
			}
		}), F.extend({
			off: function(e, t) {
				return this.each(function(n) {
					return w(n, e, t)
				})
			},
			on: function(e, t, i, o) {
				var r;
				if (!H(e)) {
					for (var a in e) this.on(a, t, e[a]);
					return this
				}
				return O(t) && (i = t, t = null), "ready" === e ? (n(i), this) : (t && (r = i, i = function(e) {
					for (var n = e.target; !s(n, t);) {
						if (n === this || null === n) return n = !1;
						n = n.parentNode
					}
					n && r.call(n, e)
				}), this.each(function(t) {
					var n = i;
					o && (n = function() {
						i.apply(this, arguments), w(t, e, n)
					}), y(t, e, n)
				}))
			},
			one: function(e, t, n) {
				return this.on(e, t, n, !0)
			},
			ready: n,
			trigger: function(e, t) {
				if (document.createEvent) {
					var n = document.createEvent("HTMLEvents");
					return n.initEvent(e, !0, !1), n = this.extend(n, t), this.each(function(e) {
						return e.dispatchEvent(n)
					})
				}
			}
		}), F.extend({
			serialize: function() {
				var e = "";
				return r(this[0].elements || this, function(t) {
					if (!t.disabled && "FIELDSET" !== t.tagName) {
						var n = t.name;
						switch (t.type.toLowerCase()) {
							case "file":
							case "reset":
							case "submit":
							case "button":
								break;
							case "select-multiple":
								var i = k(t);
								null !== i && r(i, function(t) {
									e += b(n, t)
								});
								break;
							default:
								var o = k(t);
								null !== o && (e += b(n, o))
						}
					}
				}), e.substr(1)
			},
			val: function(e) {
				return void 0 === e ? k(this[0]) : this.each(function(t) {
					return t.value = e
				})
			}
		}), F.extend({
			after: function(e) {
				return o(e).insertAfter(this), this
			},
			append: function(e) {
				return C(this, e), this
			},
			appendTo: function(e) {
				return C(o(e), this), this
			},
			before: function(e) {
				return o(e).insertBefore(this), this
			},
			clone: function() {
				return o(this.map(function(e) {
					return e.cloneNode(!0)
				}))
			},
			empty: function() {
				return this.html(""), this
			},
			html: function(e) {
				if (void 0 === e) return this[0].innerHTML;
				var t = e.nodeType ? e[0].outerHTML : e;
				return this.each(function(e) {
					return e.innerHTML = t
				})
			},
			insertAfter: function(e) {
				var t = this;
				return o(e).each(function(e, n) {
					var i = e.parentNode,
						o = e.nextSibling;
					t.each(function(e) {
						i.insertBefore(0 === n ? e : e.cloneNode(!0), o)
					})
				}), this
			},
			insertBefore: function(e) {
				var t = this;
				return o(e).each(function(e, n) {
					var i = e.parentNode;
					t.each(function(t) {
						i.insertBefore(0 === n ? t : t.cloneNode(!0), e)
					})
				}), this
			},
			prepend: function(e) {
				return C(this, e, !0), this
			},
			prependTo: function(e) {
				return C(o(e), this, !0), this
			},
			remove: function() {
				return this.each(function(e) {
					if (e.parentNode) return e.parentNode.removeChild(e)
				})
			},
			text: function(e) {
				return void 0 === e ? this[0].textContent : this.each(function(t) {
					return t.textContent = e
				})
			}
		});
		var U = $.documentElement;
		return F.extend({
			position: function() {
				var e = this[0];
				return {
					left: e.offsetLeft,
					top: e.offsetTop
				}
			},
			offset: function() {
				var e = this[0].getBoundingClientRect();
				return {
					top: e.top + A.pageYOffset - U.clientTop,
					left: e.left + A.pageXOffset - U.clientLeft
				}
			},
			offsetParent: function() {
				return o(this[0].offsetParent)
			}
		}), F.extend({
			children: function(e) {
				var t = [];
				return this.each(function(e) {
					N.apply(t, e.children)
				}), t = l(t), e ? t.filter(function(t) {
					return s(t, e)
				}) : t
			},
			closest: function(e) {
				return !e || this.length < 1 ? o() : this.is(e) ? this.filter(e) : this.parent().closest(e)
			},
			is: function(e) {
				if (!e) return !1;
				var t = !1,
					n = a(e);
				return this.each(function(i) {
					return !(t = n(i, e))
				}), t
			},
			find: function(t) {
				if (!t || t.nodeType) return o(t && this.has(t).length ? t : null);
				var n = [];
				return this.each(function(i) {
					N.apply(n, e(t, i))
				}), l(n)
			},
			has: function(t) {
				var n = H(t) ? function(n) {
					return 0 !== e(t, n).length
				} : function(e) {
					return e.contains(t)
				};
				return this.filter(n)
			},
			next: function() {
				return o(this[0].nextElementSibling)
			},
			not: function(e) {
				if (!e) return this;
				var t = a(e);
				return this.filter(function(n) {
					return !t(n, e)
				})
			},
			parent: function() {
				var e = [];
				return this.each(function(t) {
					t && t.parentNode && e.push(t.parentNode)
				}), l(e)
			},
			parents: function(e) {
				var t, n = [];
				return this.each(function(i) {
					for (t = i; t && t.parentNode && t !== $.body.parentNode;) t = t.parentNode, (!e || e && s(t, e)) && n.push(t)
				}), l(n)
			},
			prev: function() {
				return o(this[0].previousElementSibling)
			},
			siblings: function(e) {
				var t = this.parent().children(e),
					n = this[0];
				return t.filter(function(e) {
					return e !== n
				})
			}
		}), o
	}()
}();
var Component = function() {
	function e(t, n, i) {
		_classCallCheck(this, e), n instanceof Element || console.error(Error(n + " is not an HTML Element"));
		var o = t.getInstance(n);
		o && o.destroy(), this.el = n, this.$el = cash(n)
	}
	return _createClass(e, null, [{
		key: "init",
		value: function(e, t, n) {
			var i = null;
			if (t instanceof Element) i = new e(t, n);
			else if (t && (t.jquery || t.cash || t instanceof NodeList)) {
				for (var o = [], r = 0; r < t.length; r++) o.push(new e(t[r], n));
				i = o
			}
			return i
		}
	}]), e
}();
! function(e) {
	e.Package ? M = {} : e.M = {}, M.jQueryLoaded = !!e.jQuery
}(window), "function" == typeof define && define.amd ? define("M", [], function() {
	return M
}) : "undefined" == typeof exports || exports.nodeType || ("undefined" != typeof module && !module.nodeType && module.exports && (exports = module.exports = M), exports.default = M), M.version = "1.0.0", M.keys = {
	TAB: 9,
	ENTER: 13,
	ESC: 27,
	ARROW_UP: 38,
	ARROW_DOWN: 40
}, M.tabPressed = !1, M.keyDown = !1;
var docHandleKeydown = function(e) {
		M.keyDown = !0, e.which !== M.keys.TAB && e.which !== M.keys.ARROW_DOWN && e.which !== M.keys.ARROW_UP || (M.tabPressed = !0)
	},
	docHandleKeyup = function(e) {
		M.keyDown = !1, e.which !== M.keys.TAB && e.which !== M.keys.ARROW_DOWN && e.which !== M.keys.ARROW_UP || (M.tabPressed = !1)
	},
	docHandleFocus = function(e) {
		M.keyDown && document.body.classList.add("keyboard-focused")
	},
	docHandleBlur = function(e) {
		document.body.classList.remove("keyboard-focused")
	};
document.addEventListener("keydown", docHandleKeydown, !0), document.addEventListener("keyup", docHandleKeyup, !0), document.addEventListener("focus", docHandleFocus, !0), document.addEventListener("blur", docHandleBlur, !0), M.initializeJqueryWrapper = function(e, t, n) {
	jQuery.fn[t] = function(i) {
		if (e.prototype[i]) {
			var o = Array.prototype.slice.call(arguments, 1);
			if ("get" === i.slice(0, 3)) {
				var r = this.first()[0][n];
				return r[i].apply(r, o)
			}
			return this.each(function() {
				var e = this[n];
				e[i].apply(e, o)
			})
		}
		if ("object" === _typeof(i) || !i) return e.init(this, arguments[0]), this;
		jQuery.error("Method ".concat(i, " does not exist on jQuery.").concat(t))
	}
}, M.AutoInit = function(e) {
	var t = e || document.body,
		n = {
			Autocomplete: t.querySelectorAll(".autocomplete:not(.no-autoinit)"),
			Carousel: t.querySelectorAll(".carousel:not(.no-autoinit)"),
			Chips: t.querySelectorAll(".chips:not(.no-autoinit)"),
			Collapsible: t.querySelectorAll(".collapsible:not(.no-autoinit)"),
			Datepicker: t.querySelectorAll(".datepicker:not(.no-autoinit)"),
			Dropdown: t.querySelectorAll(".dropdown-trigger:not(.no-autoinit)"),
			Materialbox: t.querySelectorAll(".materialboxed:not(.no-autoinit)"),
			Modal: t.querySelectorAll(".modal:not(.no-autoinit)"),
			Parallax: t.querySelectorAll(".parallax:not(.no-autoinit)"),
			Pushpin: t.querySelectorAll(".pushpin:not(.no-autoinit)"),
			ScrollSpy: t.querySelectorAll(".scrollspy:not(.no-autoinit)"),
			FormSelect: t.querySelectorAll("select:not(.no-autoinit)"),
			Sidenav: t.querySelectorAll(".sidenav:not(.no-autoinit)"),
			Tabs: t.querySelectorAll(".tabs:not(.no-autoinit)"),
			TapTarget: t.querySelectorAll(".tap-target:not(.no-autoinit)"),
			Timepicker: t.querySelectorAll(".timepicker:not(.no-autoinit)"),
			Tooltip: t.querySelectorAll(".tooltipped:not(.no-autoinit)"),
			FloatingActionButton: t.querySelectorAll(".fixed-action-btn:not(.no-autoinit)")
		};
	for (var i in n) {
		M[i].init(n[i])
	}
}, M.objectSelectorString = function(e) {
	return ((e.prop("tagName") || "") + (e.attr("id") || "") + (e.attr("class") || "")).replace(/\s/g, "")
}, M.guid = function() {
	function e() {
		return Math.floor(65536 * (1 + Math.random())).toString(16).substring(1)
	}
	return function() {
		return e() + e() + "-" + e() + "-" + e() + "-" + e() + "-" + e() + e() + e()
	}
}(), M.escapeHash = function(e) {
	return e.replace(/(:|\.|\[|\]|,|=|\/)/g, "\\$1")
}, M.elementOrParentIsFixed = function(e) {
	var t = $(e),
		n = t.add(t.parents()),
		i = !1;
	return n.each(function() {
		if ("fixed" === $(this).css("position")) return i = !0, !1
	}), i
}, M.checkWithinContainer = function(e, t, n) {
	var i = {
			top: !1,
			right: !1,
			bottom: !1,
			left: !1
		},
		o = e.getBoundingClientRect(),
		r = e === document.body ? Math.max(o.bottom, window.innerHeight) : o.bottom,
		s = e.scrollLeft,
		a = e.scrollTop,
		l = t.left - s,
		c = t.top - a;
	return (l < o.left + n || l < n) && (i.left = !0), (l + t.width > o.right - n || l + t.width > window.innerWidth - n) && (i.right = !0), (c < o.top + n || c < n) && (i.top = !0), (c + t.height > r - n || c + t.height > window.innerHeight - n) && (i.bottom = !0), i
}, M.checkPossibleAlignments = function(e, t, n, i) {
	var o = {
			top: !0,
			right: !0,
			bottom: !0,
			left: !0,
			spaceOnTop: null,
			spaceOnRight: null,
			spaceOnBottom: null,
			spaceOnLeft: null
		},
		r = "visible" === getComputedStyle(t).overflow,
		s = t.getBoundingClientRect(),
		a = Math.min(s.height, window.innerHeight),
		l = Math.min(s.width, window.innerWidth),
		c = e.getBoundingClientRect(),
		d = t.scrollLeft,
		u = t.scrollTop,
		p = n.left - d,
		f = n.top - u,
		h = n.top + c.height - u;
	return o.spaceOnRight = r ? window.innerWidth - (c.left + n.width) : l - (p + n.width), o.spaceOnRight < 0 && (o.left = !1), o.spaceOnLeft = r ? c.right - n.width : p - n.width + c.width, o.spaceOnLeft < 0 && (o.right = !1), o.spaceOnBottom = r ? window.innerHeight - (c.top + n.height + i) : a - (f + n.height + i), o.spaceOnBottom < 0 && (o.top = !1), o.spaceOnTop = r ? c.bottom - (n.height + i) : h - (n.height - i), o.spaceOnTop < 0 && (o.bottom = !1), o
}, M.getOverflowParent = function(e) {
	return null == e ? null : e === document.body || "visible" !== getComputedStyle(e).overflow ? e : M.getOverflowParent(e.parentElement)
}, M.getIdFromTrigger = function(e) {
	var t = e.getAttribute("data-target");
	return t || (t = e.getAttribute("href"), t = t ? t.slice(1) : ""), t
}, M.getDocumentScrollTop = function() {
	return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
}, M.getDocumentScrollLeft = function() {
	return window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0
};
var getTime = Date.now || function() {
	return (new Date).getTime()
};
M.throttle = function(e, t, n) {
		var i, o, r, s = null,
			a = 0;
		n || (n = {});
		var l = function() {
			a = !1 === n.leading ? 0 : getTime(), s = null, r = e.apply(i, o), i = o = null
		};
		return function() {
			var c = getTime();
			a || !1 !== n.leading || (a = c);
			var d = t - (c - a);
			return i = this, o = arguments, d <= 0 ? (clearTimeout(s), s = null, a = c, r = e.apply(i, o), i = o = null) : s || !1 === n.trailing || (s = setTimeout(l, d)), r
		}
	},
	function() {
		for (var e, t = function() {}, n = ["assert", "clear", "count", "debug", "dir", "dirxml", "error", "exception", "group", "groupCollapsed", "groupEnd", "info", "log", "markTimeline", "profile", "profileEnd", "table", "time", "timeEnd", "timeline", "timelineEnd", "timeStamp", "trace", "warn"], i = n.length, o = window.console = window.console || {}; i--;) e = n[i], o[e] || (o[e] = t)
	}();
var indexPage = $("#index_page").length,
	aboutPage = $("#about_us").length,
	contactPage = $("#contact_page").length,
	productPage = $("#product_inside").length,
	productlistingPage = $("#product_listing").length,
	bloginsidePage = $("#blog_inside").length,
	contactPage = $("#contact").length,
	awardsPage = $("#awards_page").length,
	transferHeight = function(e, t) {
		var n = $(e).outerHeight();
		$(t).outerHeight(n)
	},
	equalHeight = function(e) {
		var t = 0;
		$(e).each(function() {
			var e = $(this).outerHeight();
			t < e && (t = e)
		}), $(e).outerHeight(t)
	};
$(window).on("load", function() {
	$(window).outerWidth() > 767 && (equalHeight(".shop_product"), equalHeight(".also_product"), equalHeight(".good_product"))
}), $(window).on("load", function() {
	$(window).outerWidth() < 767 && (equalHeight(".also_product"), $(".our_slider").slick({
		rows: 0,
		dots: !1,
		arrows: !0,
		autoplay: !0,
		infinite: !0,
		slidesToShow: 4,
		slidesToScroll: 1,
		pauseOnHover: !1,
		centerMode: !0,
		centerPadding: 0,
		speed: 1e3,
		autoplaySpeed: 3e3,
		prevArrow: '<button class="slide-arrow prev-arrow our_left_arrow"><img src="//cdn.shopify.com/s/files/1/0578/9715/6765/t/2/assets/our_left_arrow.png" class="img-responsive"></button>',
		nextArrow: '<button class="slide-arrow next-arrow our_right_arrow"><img src="//cdn.shopify.com/s/files/1/0578/9715/6765/t/2/assets/our_right_arrow.png" class="img-responsive "></button>',
		responsive: [{
			breakpoint: 1200,
			settings: {
				arrows: !1,
				centerMode: !0,
				centerPadding: "0px",
				slidesToShow: 3,
				slidesToScroll: 1
			}
		}, {
			breakpoint: 1024,
			settings: {
				arrows: !1,
				centerMode: !0,
				centerPadding: "0px",
				slidesToShow: 2,
				slidesToScroll: 1
			}
		}, {
			breakpoint: 480,
			settings: {
				arrows: !1,
				dots: !1,
				autoplay: !0,
				slidesToShow: 2,
				slidesToScroll: 1,
				centerMode: !1,
				centerPadding: "0px",
				cssEase: "linear"
			}
		}]
	}))
});
var checkHiddenRadio = function(e, t) {
		$(e).find(".hidden_inputs").prop("checked", !1), $(t).find(".hidden_inputs").prop("checked", !0)
	},
	getCurrentYear = function() {
		var e = new Date,
			t = e.getFullYear();
		$(".current_year").text(t)
	},
	winW = $(window).outerWidth(),
	winH = $(window).outerHeight();
$(function() {
	$(".silde_id").on("click", function(e) {
		$("html, body").animate({
			scrollTop: $($(this).attr("data-scrollto")).offset().top - 50
		}, 500, "linear")
	})
}), $(document).ready(function() {
	ScrollOut({
		once: !0
	})
}), $(window).scroll(function() {
	if ($("#index_page").length) {
		$(window).scrollTop() > $("#let").offset().top - 200 && setTimeout(function() {
			$(".clip").addClass("clip_animaction")
		}, 0)
	}
}), $(document).ready(function(e) {
	getCurrentYear(), $("#nav-icon3").click(function() {
		$(this).toggleClass("open"), $(".sidebar_wrap").toggleClass("open")
	}), $(".sidebar_wrap .links a").on("click", function() {
		$("#nav-icon3").trigger("click")
	}), console.log("window width is ".concat(winW)), $(document).ready(function() {
		$(".tabs a").click(function() {
			$(".panel").hide(), $(".tabs a.active").removeClass("active"), $(this).addClass("active");
			var e = $(this).attr("href");
			return $(e).fadeIn(1e3), !1
		}), $(".tabs li:first a").click()
	});
	$(".box_section .box").on("click", function() {
		$(".box_section .box").removeClass("active"), $(this).addClass("active")
	}), 1 == indexPage && ($(".banner_slider").slick({
		rows: 0,
		dots: !0,
		arrows: !1,
		autoplay: !0,
		infinite: !0,
		slidesToShow: 1,
		slidesToScroll: 1,
		pauseOnHover: !1,
		centerMode: !0,
		centerPadding: 0,
		speed: 1500,
		autoplaySpeed: 3e3,
		responsive: [{
			breakpoint: 1024,
			settings: {
				arrows: !0,
				centerMode: !0,
				centerPadding: "0px",
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}, {
			breakpoint: 480,
			settings: {
				autoplaySpeed: 3e3,
				arrows: !1,
				dots: !0,
				autoplay: !0,
				slidesToShow: 1,
				slidesToScroll: 1,
				centerMode: !1,
				speed: 1500,
				centerPadding: "0px",
				cssEase: "linear"
			}
		}]
	}), $(".buzzfeed_scetion").slick({
		rows: 0,
		dots: !1,
		arrows: !0,
		infinite: !0,
		slidesToShow: 1,
		slidesToScroll: 1,
		pauseOnHover: !1,
		centerMode: !0,
		centerPadding: 0,
		speed: 1500,
		prevArrow: '<button class="slide-arrow prev-arrow buzzfeed_left_arrow"><img src="https://cdn.shopify.com/s/files/1/0578/9715/6765/files/left_arrow_6afc4b56-7b86-4ab8-9369-ac8c025c46a9.png?v=1630395725" class="img-responsive"></button>',
		nextArrow: '<button class="slide-arrow next-arrow buzzfeed_right_arrow"><img src="https://cdn.shopify.com/s/files/1/0578/9715/6765/files/right_arrow_b458c26a-5240-43e0-afd7-880a19b98f82.png?v=1630395725" class="img-responsive "></button>',
		responsive: [{
			breakpoint: 1024,
			settings: {
				arrows: !0,
				centerMode: !0,
				centerPadding: "0px",
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}, {
			breakpoint: 480,
			settings: {
				arrows: !0,
				dots: !1,
				slidesToShow: 1,
				slidesToScroll: 1,
				centerMode: !1,
				speed: 1500,
				centerPadding: "0px",
				cssEase: "linear"
			}
		}]
	}), $(".shout_section").slick({
		rows: 0,
		dots: !0,
		arrows: !1,
		autoplay: !0,
		infinite: !0,
		slidesToShow: 4,
		slidesToScroll: 1,
		pauseOnHover: !1,
		centerMode: !1,
		centerPadding: 1,
		speed: 1e3,
		autoplaySpeed: 2500,
		prevArrow: '<button class="slide-arrow prev-arrow buzzfeed_left_arrow"><img src="//cdn.shopify.com/s/files/1/0578/9715/6765/t/2/assets/left_arrow.png" class="img-responsive"></button>',
		nextArrow: '<button class="slide-arrow next-arrow buzzfeed_right_arrow"><img src="//cdn.shopify.com/s/files/1/0578/9715/6765/t/2/assets/right_arrow.png" class="img-responsive "></button>',
		responsive: [{
			breakpoint: 1200,
			settings: {
				arrows: !1,
				centerMode: !0,
				centerPadding: "0px",
				slidesToShow: 3,
				slidesToScroll: 1
			}
		}, {
			breakpoint: 1024,
			settings: {
				arrows: !1,
				centerMode: !0,
				centerPadding: "0px",
				slidesToShow: 2,
				slidesToScroll: 1
			}
		}, {
			breakpoint: 480,
			settings: {
				autoplaySpeed: 2500,
				arrows: !1,
				dots: !0,
				autoplay: !0,
				slidesToShow: 2,
				slidesToScroll: 1,
				centerMode: !0,
                adaptiveHeight:false,
				centerMode: !0,
				centerPadding: "0px",
				speed: 1e3,
				centerPadding: "0px",
				cssEase: "linear"
			}
		}]
	})

),
      
      1 == aboutPage && ($(".our_slider").slick({
		rows: 0,
		dots: !1,
		arrows: !0,
		autoplay: !0,
		infinite: !0,
		slidesToShow: 4,
		slidesToScroll: 1,
		pauseOnHover: !1,
		centerMode: !0,
		centerPadding: 0,
		speed: 1e3,
		autoplaySpeed: 2500,
		prevArrow: '<button class="slide-arrow prev-arrow our_left_arrow"><img src="//cdn.shopify.com/s/files/1/0578/9715/6765/t/2/assets/our_left_arrow.png" class="img-responsive"></button>',
		nextArrow: '<button class="slide-arrow next-arrow our_right_arrow"><img src="//cdn.shopify.com/s/files/1/0578/9715/6765/t/2/assets/our_right_arrow.png" class="img-responsive "></button>',
		responsive: [{
			breakpoint: 1200,
			settings: {
				arrows: !1,
				centerMode: !0,
				centerPadding: "0px",
				slidesToShow: 3,
				slidesToScroll: 1
			}
		}, {
			breakpoint: 1024,
			settings: {
				arrows: !1,
				centerMode: !0,
				centerPadding: "0px",
				slidesToShow: 2,
				slidesToScroll: 1
			}
		}, {
			breakpoint: 480,
			settings: {
				arrows: !1,
				dots: !1,
				autoplay: !0,
				slidesToShow: 2,
				slidesToScroll: 1,
				centerMode: !1,
				centerPadding: "0px",
				cssEase: "linear"
			}
		}]
	}), $("ul.tabs li").click(function() {
		var e = $(this).attr("data-tab");
		$("ul.tabs li").removeClass("current"), $(".tab-content").removeClass("current"), $(this).addClass("current"), $("#" + e).addClass("current")
	}), $("ul.tabs-1 li").click(function() {
		var e = $(this).attr("data-tab");
		$("ul.tabs-1 li").removeClass("current-1"), $(".tab-content-1").removeClass("current-1"), $(this).addClass("current-1"), $("#" + e).addClass("current-1")
	})), 1 == bloginsidePage && $(".good_section").slick({
		rows: 0,
		dots: !0,
		arrows: !1,
		autoplay: !0,
		infinite: !0,
		slidesToShow: 3,
		slidesToScroll: 1,
		pauseOnHover: !1,
		centerMode: !0,
		centerPadding: 0,
		autoplaySpeed: 2500,
		prevArrow: '<button class="slide-arrow prev-arrow buzzfeed_left_arrow"><img src="//cdn.shopify.com/s/files/1/0578/9715/6765/t/2/assets/left_arrow.png" class="img-responsive"></button>',
		nextArrow: '<button class="slide-arrow next-arrow buzzfeed_right_arrow"><img src="//cdn.shopify.com/s/files/1/0578/9715/6765/t/2/assets/right_arrow.png" class="img-responsive "></button>',
		responsive: [{
			breakpoint: 1200,
			settings: {
				arrows: !1,
				centerMode: !0,
				centerPadding: "0px",
				slidesToShow: 3,
				slidesToScroll: 1
			}
		}, {
			breakpoint: 1024,
			settings: {
				arrows: !1,
				centerMode: !0,
				centerPadding: "0px",
				slidesToShow: 2,
				slidesToScroll: 1
			}
		}, {
			breakpoint: 480,
			settings: {
				autoplaySpeed: 2500,
				arrows: !1,
				dots: !1,
				autoplay: !0,
				slidesToShow: 2,
				slidesToScroll: 1,
				centerMode: !1,
				speed: 1e3,
				centerPadding: "0px",
				cssEase: "linear"
			}
		}]
	}), 1 == productlistingPage && $(".also_section").not('slick-initialized').slick({
		rows: 0,
		dots: !0,
		arrows: !1,
		autoplay: !0,
		infinite: !0,
		slidesToShow: 3,
		slidesToScroll: 1,
		pauseOnHover: !1,
		centerMode: !0,
		centerPadding: 0,
		autoplaySpeed: 2500,
		prevArrow: '<button class="slide-arrow prev-arrow buzzfeed_left_arrow"><img src="//cdn.shopify.com/s/files/1/0578/9715/6765/t/2/assets/left_arrow.png" class="img-responsive"></button>',
		nextArrow: '<button class="slide-arrow next-arrow buzzfeed_right_arrow"><img src="//cdn.shopify.com/s/files/1/0578/9715/6765/t/2/assets/right_arrow.png" class="img-responsive "></button>',
		responsive: [{
			breakpoint: 1200,
			settings: {
				arrows: !1,
				centerMode: !0,
				centerPadding: "0px",
				slidesToShow: 3,
				slidesToScroll: 1
			}
		}, {
			breakpoint: 1024,
			settings: {
				arrows: !1,
				centerMode: !0,
				centerPadding: "0px",
				slidesToShow: 2,
				slidesToScroll: 1
			}
		}, {
			breakpoint: 480,
			settings: {
				autoplaySpeed: 2500,
				arrows: !1,
				dots: !1,
				autoplay: !0,
				slidesToShow: 2,
				slidesToScroll: 1,
				centerMode: !1,
				speed: 1e3,
				centerPadding: "0px",
				cssEase: "linear"
			}
		}]
	}), 1 == productPage && ($(".also_section").slick({
		rows: 0,
		dots: !0,
		arrows: !1,
		autoplay: !0,
		infinite: !0,
		slidesToShow: 4,
		slidesToScroll: 1,
		pauseOnHover: !1,
		centerMode: !0,
		centerPadding: 0,
		autoplaySpeed: 2500,
		prevArrow: '<button class="slide-arrow prev-arrow buzzfeed_left_arrow"><img src="//cdn.shopify.com/s/files/1/0578/9715/6765/t/2/assets/left_arrow.png" class="img-responsive"></button>',
		nextArrow: '<button class="slide-arrow next-arrow buzzfeed_right_arrow"><img src="//cdn.shopify.com/s/files/1/0578/9715/6765/t/2/assets/right_arrow.png" class="img-responsive "></button>',
		responsive: [{
			breakpoint: 1200,
			settings: {
				arrows: !1,
				centerMode: !0,
				centerPadding: "0px",
				slidesToShow: 3,
				slidesToScroll: 1
			}
		}, {
			breakpoint: 1024,
			settings: {
				arrows: !1,
				centerMode: !0,
				centerPadding: "0px",
				slidesToShow: 2,
				slidesToScroll: 1
			}
		}, {
			breakpoint: 480,
			settings: {
				autoplaySpeed: 2500,
				arrows: !1,
				dots: !0,
				autoplay: !0,
				slidesToShow: 2,
				slidesToScroll: 1,
				centerMode: !1,
				speed: 1e3,
				centerPadding: "0px",
				cssEase: "linear"
			}
		}]
	}), $(".good_section").slick({
		
		dots: !0,
		arrows: !1,
		autoplay: !1,
		infinite: !0,
		slidesToShow: 3,
		slidesToScroll: 1,
		pauseOnHover: !1,
		centerMode: !0,
		centerPadding: 0,
		autoplaySpeed: 2500,
		prevArrow: '<button class="slide-arrow prev-arrow buzzfeed_left_arrow"><img src="//cdn.shopify.com/s/files/1/0578/9715/6765/t/2/assets/left_arrow.png" class="img-responsive"></button>',
		nextArrow: '<button class="slide-arrow next-arrow buzzfeed_right_arrow"><img src="//cdn.shopify.com/s/files/1/0578/9715/6765/t/2/assets/right_arrow.png" class="img-responsive "></button>',
		responsive: [{
			breakpoint: 1200,
			settings: {
				arrows: !1,
				centerMode: !0,
				centerPadding: "0px",
				slidesToShow: 3,
				slidesToScroll: 1
			}
		}, {
			breakpoint: 1024,
			settings: {
				arrows: !1,
				centerMode: !0,
				centerPadding: "0px",
				slidesToShow: 2,
				slidesToScroll: 1
			}
		}, {
			breakpoint: 480,
			settings: {
				autoplaySpeed: 2500,
				arrows: !1,
				dots: !0,
				autoplay: !1,
				slidesToShow: 2,
				slidesToScroll: 1,
				centerMode: !1,
				speed: 1e3,
				centerPadding: "0px",
				cssEase: "linear"
			}
		}]
	}), $(document).ready(function() {
		$("ul.tabs li").click(function() {
			var e = $(this).attr("data-tab");
			$("ul.tabs li").removeClass("current"), $(".tab-content").removeClass("current"), $(this).addClass("current"), $("#" + e).addClass("current")
		})
        $("div.review_link a").click(function() {
			var e = $(this).attr("data-tab");
			$("ul.tabs li").removeClass("current"), $(".tab-content").removeClass("current"), $("ul.tabs li:nth-child(2)").addClass("current"), $("#" + e).addClass("current")
		})
        
	}), $(document).ready(function() {
		$(".set > a").on("click", function() {
			$(this).hasClass("active") ? ($(this).removeClass("active"), $(this).siblings(".content").slideUp(200), $(".set > a i").removeClass("fa-minus").addClass("fa-plus")) : ($(".set > a i").removeClass("fa-minus").addClass("fa-plus"), $(this).find("i").removeClass("fa-plus").addClass("fa-minus"), $(".set > a").removeClass("active"), $(this).addClass("active"), $(".content").slideUp(200), $(this).siblings(".content").slideDown(200))
		})
	})), 1 == contactPage && $(".also_section").slick({
		rows: 0,
		dots: !0,
		arrows: !1,
		autoplay: !0,
		infinite: !0,
		slidesToShow: 3,
		slidesToScroll: 1,
		pauseOnHover: !1,
		centerMode: !0,
		centerPadding: 0,
		autoplaySpeed: 2500,
		prevArrow: '<button class="slide-arrow prev-arrow buzzfeed_left_arrow"><img src="//cdn.shopify.com/s/files/1/0578/9715/6765/t/2/assets/left_arrow.png" class="img-responsive"></button>',
		nextArrow: '<button class="slide-arrow next-arrow buzzfeed_right_arrow"><img src="//cdn.shopify.com/s/files/1/0578/9715/6765/t/2/assets/right_arrow.png" class="img-responsive "></button>',
		responsive: [{
			breakpoint: 1200,
			settings: {
				arrows: !1,
				centerMode: !0,
				centerPadding: "0px",
				slidesToShow: 2,
				slidesToScroll: 1
			}
		}, {
			breakpoint: 1024,
			settings: {
				arrows: !1,
				centerMode: !0,
				centerPadding: "0px",
				slidesToShow: 2,
				slidesToScroll: 1
			}
		}, {
			breakpoint: 480,
			settings: {
				autoplaySpeed: 2500,
				arrows: !1,
				dots: !1,
				autoplay: !0,
				slidesToShow: 2,
				slidesToScroll: 1,
				centerMode: !1,
				speed: 1e3,
				centerPadding: "0px",
				cssEase: "linear"
			}
		}]
	})
}), $(window).on("load", function() {
	setTimeout(function() {
		$(".loader_overlay").fadeOut(500)
	}, 300)
}), $(window).on("scroll", function(e) {
	var t = $(window).scrollTop();
	$("img[data-lazy-src]").each(function() {
		$(this).offset().top < t + 2 * winH && $(this).attr("src", $(this).attr("data-lazy-src"))
	})
}), $(window).on("resize", function() {}), window.addEventListener("orientationchange", function() {
	location.reload()
});

$("#increment").click(function() {
                var str = $("#Quantity-product-accessories-new-template").val();
                if (str >= 0) {
                    str++;
                    $('#Quantity-product-accessories-new-template').val(str);
                }
            });

  $("#decrement").click(function() {
                var str = $("#Quantity-product-accessories-new-template").val();
                if (str > 0) {
                    str--;
                    $('#Quantity-product-accessories-new-template').val(str);
                }
            });
